/* eslint-disable */
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

/** Model Errors mit Attribute Keys */
export type AttributeError = {
  __typename?: 'AttributeError';
  attribute?: Maybe<Scalars['String']['output']>;
  className?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Banner */
export type Banner = {
  __typename?: 'Banner';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  image?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

/** Open Orders */
export type Basket = {
  __typename?: 'Basket';
  /** Checkout Daten Warenkorb */
  checkoutData?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Liste aller Positionen im Warenkorb */
  positions?: Maybe<Array<Maybe<BasketPosition>>>;
  /** Zusammenfassung des Warenkorbs */
  summary?: Maybe<BasketSummary>;
};

/** Werte für das Verwalten einer Position im Warenkorb */
export type BasketInputType = {
  basket_position_id?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  commission?: InputMaybe<Scalars['String']['input']>;
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  delivery_date_label?: InputMaybe<Scalars['String']['input']>;
  delivery_date_wish?: InputMaybe<Scalars['String']['input']>;
  group_ident?: InputMaybe<Scalars['String']['input']>;
  group_ident_id?: InputMaybe<Scalars['String']['input']>;
  price_tag_rrp?: InputMaybe<Scalars['Float']['input']>;
  /** Daten zu Produkten innerhalb einer Position im Warenkorb */
  products?: InputMaybe<Array<InputMaybe<BasketProductInputType>>>;
  shop_product_id_parent: Scalars['Int']['input'];
};

/** Position in Warenkorb */
export type BasketPosition = {
  __typename?: 'BasketPosition';
  /** Zusammenfassung des Warenkorbs */
  basketSummary?: Maybe<BasketSummary>;
  comment?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  deliveryDateLabel?: Maybe<Scalars['String']['output']>;
  deliveryDateWish?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  groupIdent?: Maybe<Scalars['String']['output']>;
  groupIdentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastAdded?: Maybe<Scalars['Boolean']['output']>;
  originalSubTotal?: Maybe<Scalars['String']['output']>;
  priceTagRrp?: Maybe<Scalars['Float']['output']>;
  productCount?: Maybe<Scalars['Int']['output']>;
  productData?: Maybe<Product>;
  productQty?: Maybe<Scalars['Int']['output']>;
  /** Liste der Produkte einer Position in Warenkorb */
  products?: Maybe<Array<Maybe<BasketProduct>>>;
  shopBasketId?: Maybe<Scalars['Int']['output']>;
  shopProductIdParent?: Maybe<Scalars['Int']['output']>;
  subTotal?: Maybe<Scalars['String']['output']>;
  subTotalRrp?: Maybe<Scalars['String']['output']>;
};


/** Position in Warenkorb */
export type BasketPositionOriginalSubTotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Position in Warenkorb */
export type BasketPositionSubTotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Position in Warenkorb */
export type BasketPositionSubTotalRrpArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Produkt im Warenkorb */
export type BasketProduct = {
  __typename?: 'BasketProduct';
  deliveryDate?: Maybe<Scalars['String']['output']>;
  deliveryDateLabel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  productData?: Maybe<Product>;
  quantity?: Maybe<Scalars['Int']['output']>;
  shopBasketId?: Maybe<Scalars['Int']['output']>;
  shopBasketPositionId?: Maybe<Scalars['Int']['output']>;
  shopProductId?: Maybe<Scalars['Int']['output']>;
  subTotal?: Maybe<Scalars['String']['output']>;
};


/** Produkt im Warenkorb */
export type BasketProductSubTotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Werte für das Verwalten von Produkten innerhalb einer Position im Warenkorb */
export type BasketProductInputType = {
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  delivery_date_label?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  shop_product_id: Scalars['Int']['input'];
};

/** Zusammenfassung Warenkorb */
export type BasketSummary = {
  __typename?: 'BasketSummary';
  currency?: Maybe<Scalars['String']['output']>;
  originalSubTotal?: Maybe<Scalars['String']['output']>;
  /** Anzahl Positionen im Warenkorb */
  positionCount?: Maybe<Scalars['Int']['output']>;
  /** Anzahl Produkte (Grössen / Kind-Produkte) im Warenkorb */
  productCount?: Maybe<Scalars['Int']['output']>;
  /** Gesamtmenge von Produkten (Grössen / Kind-Produkte) im Warenkorb */
  productQty?: Maybe<Scalars['Int']['output']>;
  shippingMethodTitle?: Maybe<Scalars['String']['output']>;
  subTotal?: Maybe<Scalars['String']['output']>;
  subTotalDiscount?: Maybe<Scalars['String']['output']>;
  subTotalRrp?: Maybe<Scalars['String']['output']>;
  subTotalSale?: Maybe<Scalars['String']['output']>;
  subTotalShipping?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['String']['output']>;
};


/** Zusammenfassung Warenkorb */
export type BasketSummaryOriginalSubTotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Zusammenfassung Warenkorb */
export type BasketSummarySubTotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Zusammenfassung Warenkorb */
export type BasketSummarySubTotalDiscountArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Zusammenfassung Warenkorb */
export type BasketSummarySubTotalRrpArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Zusammenfassung Warenkorb */
export type BasketSummarySubTotalSaleArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Zusammenfassung Warenkorb */
export type BasketSummarySubTotalShippingArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Zusammenfassung Warenkorb */
export type BasketSummaryTotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Blog */
export type Blog = {
  __typename?: 'Blog';
  blogAuthor?: Maybe<BlogAuthor>;
  blogId?: Maybe<Scalars['Int']['output']>;
  categories?: Maybe<Array<Maybe<BlogCategory>>>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<BlogTag>>>;
  teaser?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Blog */
export type BlogDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Blog */
export type BlogDescriptionArgs = {
  format?: InputMaybe<ContentFormatEnum>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
};


/** Blog */
export type BlogMediasArgs = {
  targetAttr?: InputMaybe<Scalars['ID']['input']>;
};


/** Blog */
export type BlogTeaserArgs = {
  format?: InputMaybe<ContentFormatEnum>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
};


/** Blog */
export type BlogUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Blog Authoren */
export type BlogAuthor = {
  __typename?: 'BlogAuthor';
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
};


/** Blog Authoren */
export type BlogAuthorMediasArgs = {
  targetAttr?: InputMaybe<Scalars['ID']['input']>;
};

/** Blog Kategorien */
export type BlogCategory = {
  __typename?: 'BlogCategory';
  blogCategoryId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Liste von Blog Kategorien */
export type BlogCategoryList = {
  __typename?: 'BlogCategoryList';
  results?: Maybe<Array<Maybe<BlogCategory>>>;
  totalCount: Scalars['Int']['output'];
};

/** Liste von Blogs */
export type BlogList = {
  __typename?: 'BlogList';
  blogSortOptions?: Maybe<Array<Maybe<BlogSortOption>>>;
  results?: Maybe<Array<Maybe<Blog>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export const BlogSortByEnum = {
  /** i18n.blog_id ASC */
  BlogIdAsc: 'BLOG_ID_ASC',
  /** i18n.blog_id DESC */
  BlogIdDesc: 'BLOG_ID_DESC',
  /** i18n.date ASC */
  DateAsc: 'DATE_ASC',
  /** i18n.date DESC */
  DateDesc: 'DATE_DESC',
  /** i18n.sort_order ASC */
  SortOrderAsc: 'SORT_ORDER_ASC',
  /** i18n.sort_order DESC */
  SortOrderDesc: 'SORT_ORDER_DESC'
} as const;

export type BlogSortByEnum = typeof BlogSortByEnum[keyof typeof BlogSortByEnum];
/** Sortierung Blog */
export type BlogSortOption = {
  __typename?: 'BlogSortOption';
  enumValue?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** Blog Tags */
export type BlogTag = {
  __typename?: 'BlogTag';
  blogTagId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Brand */
export type Brand = {
  __typename?: 'Brand';
  brandId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Liste mit Features, die ShopBrand zugewiesen sind */
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  products?: Maybe<Array<Maybe<BrandProduct>>>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Brand */
export type BrandDescriptionArgs = {
  format?: InputMaybe<ContentFormatEnum>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
};


/** Brand */
export type BrandMediasArgs = {
  targetAttr?: InputMaybe<Scalars['String']['input']>;
};


/** Brand */
export type BrandUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Brands */
export type BrandList = {
  __typename?: 'BrandList';
  results?: Maybe<Array<Maybe<Brand>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Brand Produkte */
export type BrandProduct = {
  __typename?: 'BrandProduct';
  brandId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isFavorite?: Maybe<Scalars['Int']['output']>;
  productData?: Maybe<Product>;
  shopProductId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Brand Produkte */
export type BrandProductUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Katalog-Filter */
export type CatalogFilter = {
  __typename?: 'CatalogFilter';
  id?: Maybe<Scalars['String']['output']>;
  ident?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Einstellungen Katalog */
export type CatalogSettings = {
  __typename?: 'CatalogSettings';
  categoryTree?: Maybe<Scalars['String']['output']>;
  /** Standard-Filter (hinterlegt auf Mandant oder Konfiguration) */
  defaultFilters: Array<CatalogFilter>;
  /** Standard-Filter für oberen Bereich (hinterlegt auf Mandant oder Konfiguration) */
  defaultTopFilters: Array<CatalogFilter>;
  /** Allgemeine Sortierung (hinterlegt auf Mandant oder Konfiguration) */
  sorting: Array<CatalogSorting>;
};

/** Katalog-Sortierung */
export type CatalogSorting = {
  __typename?: 'CatalogSorting';
  attribute?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDefault?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  sortOption?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Katalog-Sortierung */
export type CatalogSortingUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Mandant */
export type Client = {
  __typename?: 'Client';
  b2bConfiguration?: Maybe<Scalars['String']['output']>;
  b2bStatus?: Maybe<Scalars['Int']['output']>;
  brandColor?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Liste mit Features, die ShopClient zugewiesen sind */
  features: Array<Scalars['String']['output']>;
  /** Liste mit Filtern dieses Mandanten */
  filters: Array<ClientFilter>;
  footerNavigation?: Maybe<Scalars['String']['output']>;
  hasPreOrder?: Maybe<Scalars['Int']['output']>;
  hasPreOrderDirect?: Maybe<Scalars['Int']['output']>;
  hasPreOrderSubmission?: Maybe<Scalars['Int']['output']>;
  hasReOrder?: Maybe<Scalars['Int']['output']>;
  hasReOrderDirect?: Maybe<Scalars['Int']['output']>;
  hasReOrderSubmission?: Maybe<Scalars['Int']['output']>;
  headerNavigation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ident?: Maybe<Scalars['String']['output']>;
  imprint?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  maintenance?: Maybe<Scalars['Int']['output']>;
  maintenanceText?: Maybe<Scalars['String']['output']>;
  medias: Array<Media>;
  /** Pfad zur Shop-Client Seite */
  pagePath?: Maybe<Scalars['String']['output']>;
  preOrderBlock?: Maybe<Scalars['Int']['output']>;
  preOrderBlockEndDate?: Maybe<Scalars['String']['output']>;
  preOrderBlockStartDate?: Maybe<Scalars['String']['output']>;
  preOrderBlockUnlockOnOrder?: Maybe<Scalars['Int']['output']>;
  preOrderHideWithoutPrices?: Maybe<Scalars['Int']['output']>;
  preOrderSeasonTitle?: Maybe<Scalars['String']['output']>;
  preOrderSplitProductline?: Maybe<Scalars['Int']['output']>;
  preOrderSplitSeason?: Maybe<Scalars['Int']['output']>;
  privacyPolicy?: Maybe<Scalars['String']['output']>;
  /** Liste mit IDs verknüpfter Produktlinien */
  productlines: Array<Scalars['Int']['output']>;
  products: Array<Product>;
  reOrderHideWithoutPrices?: Maybe<Scalars['Int']['output']>;
  reOrderOnlyInstock?: Maybe<Scalars['Int']['output']>;
  reOrderSplitProductline?: Maybe<Scalars['Int']['output']>;
  reOrderSplitSeason?: Maybe<Scalars['Int']['output']>;
  /** Liste mit IDs verknüpfter Saisons */
  seasons: Array<Scalars['Int']['output']>;
  shopClientId?: Maybe<Scalars['Int']['output']>;
  /** shop_client_seasonal_id (Dynamisches Feld / Feature) */
  shop_client_seasonal_id?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** Liste mit Sortierungen dieses Mandanten */
  sorting: Array<ClientSorting>;
  status?: Maybe<Scalars['Int']['output']>;
  structureId?: Maybe<Scalars['Int']['output']>;
  termsOfService?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  urlSlug?: Maybe<Scalars['String']['output']>;
};


/** Mandant */
export type ClientDescriptionArgs = {
  format?: InputMaybe<ContentFormatEnum>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
};


/** Mandant */
export type ClientMediasArgs = {
  targetAttr?: InputMaybe<Scalars['String']['input']>;
};


/** Mandant */
export type ClientPreOrderBlockEndDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Mandant */
export type ClientPreOrderBlockStartDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Mandant */
export type ClientUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Mandanten-Filter */
export type ClientFilter = {
  __typename?: 'ClientFilter';
  additionalOption?: Maybe<Scalars['Int']['output']>;
  displayOnTop?: Maybe<Scalars['Int']['output']>;
  displayOption?: Maybe<Scalars['Int']['output']>;
  filterData?: Maybe<ProductFilter>;
  filterId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isFavorite?: Maybe<Scalars['Int']['output']>;
  shopClientId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Mandanten-Filter */
export type ClientFilterUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Shop-Mandanten */
export type ClientList = {
  __typename?: 'ClientList';
  results: Array<Client>;
  totalCount: Scalars['Int']['output'];
};

/** Mandanten-Sortierung */
export type ClientSorting = {
  __typename?: 'ClientSorting';
  attribute?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDefault?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  shopClientId?: Maybe<Scalars['Int']['output']>;
  sortOption?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Mandanten-Sortierung */
export type ClientSortingUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Color */
export type Color = {
  __typename?: 'Color';
  colorId?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Liste mit Features, die Color zugewiesen sind */
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hexCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  number?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Color */
export type ColorMediasArgs = {
  targetAttr?: InputMaybe<Scalars['String']['input']>;
};

/** Color */
export type ColorGroup = {
  __typename?: 'ColorGroup';
  colorGroupId?: Maybe<Scalars['Int']['output']>;
  hexCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Color */
export type ColorGroupMediasArgs = {
  targetAttr?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Farbgruppen */
export type ColorGroupList = {
  __typename?: 'ColorGroupList';
  results?: Maybe<Array<Maybe<ColorGroup>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Liste von Farben */
export type ColorList = {
  __typename?: 'ColorList';
  results?: Maybe<Array<Maybe<Color>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export const ColorSortByEnum = {
  /** i18n.sort_order ASC */
  SortOrderAsc: 'SORT_ORDER_ASC',
  /** i18n.sort_order DESC */
  SortOrderDesc: 'SORT_ORDER_DESC',
  /** i18n.title ASC */
  TitleAsc: 'TITLE_ASC',
  /** i18n.title DESC */
  TitleDesc: 'TITLE_DESC'
} as const;

export type ColorSortByEnum = typeof ColorSortByEnum[keyof typeof ColorSortByEnum];
export const ContentFormatEnum = {
  Html: 'HTML',
  Text: 'TEXT'
} as const;

export type ContentFormatEnum = typeof ContentFormatEnum[keyof typeof ContentFormatEnum];
/** Country */
export type Country = {
  __typename?: 'Country';
  countryCode?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  customCountryCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imprint?: Maybe<Scalars['String']['output']>;
  isoCode3?: Maybe<Scalars['String']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Scalars['String']['output']>;
  popupTermsOfService?: Maybe<Scalars['String']['output']>;
  privacyPolicy?: Maybe<Scalars['String']['output']>;
  termsOfService?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Country */
export type CountryMediasArgs = {
  targetAttr?: InputMaybe<Scalars['ID']['input']>;
};


/** Country */
export type CountryUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export const CountryCodeEnum = {
  /** Andorra (AD) */
  Ad: 'AD',
  /** United Arab Emirates (AE) */
  Ae: 'AE',
  /** Afghanistan (AF) */
  Af: 'AF',
  /** Antigua and Barbuda (AG) */
  Ag: 'AG',
  /** Anguilla (AI) */
  Ai: 'AI',
  /** Albania (AL) */
  Al: 'AL',
  /** Armenia (AM) */
  Am: 'AM',
  /** Netherlands Antilles (AN) */
  An: 'AN',
  /** Angola (AO) */
  Ao: 'AO',
  /** Antarctica (AQ) */
  Aq: 'AQ',
  /** Argentina (AR) */
  Ar: 'AR',
  /** Austria (AT) */
  At: 'AT',
  /** Australia (AU) */
  Au: 'AU',
  /** Aruba (AW) */
  Aw: 'AW',
  /** Åland Islands (AX) */
  Ax: 'AX',
  /** Azerbaijan (AZ) */
  Az: 'AZ',
  /** Bosnia and Herzegovina (BA) */
  Ba: 'BA',
  /** Barbados (BB) */
  Bb: 'BB',
  /** Bangladesh (BD) */
  Bd: 'BD',
  /** Belgium (BE) */
  Be: 'BE',
  /** Burkina Faso (BF) */
  Bf: 'BF',
  /** Bulgaria (BG) */
  Bg: 'BG',
  /** Bahrain (BH) */
  Bh: 'BH',
  /** Burundi (BI) */
  Bi: 'BI',
  /** Benin (BJ) */
  Bj: 'BJ',
  /** Saint Barthélemy (BL) */
  Bl: 'BL',
  /** Bermuda (BM) */
  Bm: 'BM',
  /** Brunei Darussalam (BN) */
  Bn: 'BN',
  /** Bolivia (BO) */
  Bo: 'BO',
  /** Bonaire (BQ) */
  Bq: 'BQ',
  /** Brazil (BR) */
  Br: 'BR',
  /** Bahamas (BS) */
  Bs: 'BS',
  /** Bhutan (BT) */
  Bt: 'BT',
  /** Bouvet Island (BV) */
  Bv: 'BV',
  /** Botswana (BW) */
  Bw: 'BW',
  /** Belarus (BY) */
  By: 'BY',
  /** Belize (BZ) */
  Bz: 'BZ',
  /** Canada (CA) */
  Ca: 'CA',
  /** Cocos (Keeling) Islands (CC) */
  Cc: 'CC',
  /** Demokratische Republik Kongo (CD) */
  Cd: 'CD',
  /** Central African Republic (CF) */
  Cf: 'CF',
  /** Congo (CG) */
  Cg: 'CG',
  /** Schweiz (CH) */
  Ch: 'CH',
  /** Ivory Coast (CI) */
  Ci: 'CI',
  /** Cook Islands (CK) */
  Ck: 'CK',
  /** Chile (CL) */
  Cl: 'CL',
  /** Cameroon (CM) */
  Cm: 'CM',
  /** China (CN) */
  Cn: 'CN',
  /** Colombia (CO) */
  Co: 'CO',
  /** Costa Rica (CR) */
  Cr: 'CR',
  /** Cuba (CU) */
  Cu: 'CU',
  /** Cape Verde (CV) */
  Cv: 'CV',
  /** Curaçao (CW) */
  Cw: 'CW',
  /** Christmas Island (CX) */
  Cx: 'CX',
  /** Cyprus (CY) */
  Cy: 'CY',
  /** Czech Republic (CZ) */
  Cz: 'CZ',
  /** Germany (DE) */
  De: 'DE',
  /** Djibouti (DJ) */
  Dj: 'DJ',
  /** Denmark (DK) */
  Dk: 'DK',
  /** Dominica (DM) */
  Dm: 'DM',
  /** Dominican Republic (DO) */
  Do: 'DO',
  /** American Samoa (DS) */
  Ds: 'DS',
  /** Algeria (DZ) */
  Dz: 'DZ',
  /** Ecuador (EC) */
  Ec: 'EC',
  /** Estonia (EE) */
  Ee: 'EE',
  /** Egypt (EG) */
  Eg: 'EG',
  /** Western Sahara (EH) */
  Eh: 'EH',
  /** Eritrea (ER) */
  Er: 'ER',
  /** Spain (ES) */
  Es: 'ES',
  /** Ethiopia (ET) */
  Et: 'ET',
  /** Finland (FI) */
  Fi: 'FI',
  /** Fiji (FJ) */
  Fj: 'FJ',
  /** Falkland Islands (Malvinas) (FK) */
  Fk: 'FK',
  /** Micronesia, Federated States of (FM) */
  Fm: 'FM',
  /** Faroe Islands (FO) */
  Fo: 'FO',
  /** France (FR) */
  Fr: 'FR',
  /** France, Metropolitan (FX) */
  Fx: 'FX',
  /** Gabon (GA) */
  Ga: 'GA',
  /** United Kingdom (GB) */
  Gb: 'GB',
  /** Grenada (GD) */
  Gd: 'GD',
  /** Georgia (GE) */
  Ge: 'GE',
  /** French Guiana (GF) */
  Gf: 'GF',
  /** Guernsey (GG) */
  Gg: 'GG',
  /** Ghana (GH) */
  Gh: 'GH',
  /** Gibraltar (GI) */
  Gi: 'GI',
  /** Guernsey (GK) */
  Gk: 'GK',
  /** Greenland (GL) */
  Gl: 'GL',
  /** Gambia (GM) */
  Gm: 'GM',
  /** Guinea (GN) */
  Gn: 'GN',
  /** Guadeloupe (GP) */
  Gp: 'GP',
  /** Equatorial Guinea (GQ) */
  Gq: 'GQ',
  /** Greece (GR) */
  Gr: 'GR',
  /** South Georgia South Sandwich Islands (GS) */
  Gs: 'GS',
  /** Guatemala (GT) */
  Gt: 'GT',
  /** Guam (GU) */
  Gu: 'GU',
  /** Guinea-Bissau (GW) */
  Gw: 'GW',
  /** Guyana (GY) */
  Gy: 'GY',
  /** Hong Kong (HK) */
  Hk: 'HK',
  /** Heard and Mc Donald Islands (HM) */
  Hm: 'HM',
  /** Honduras (HN) */
  Hn: 'HN',
  /** Croatia (Hrvatska) (HR) */
  Hr: 'HR',
  /** Haiti (HT) */
  Ht: 'HT',
  /** Hungary (HU) */
  Hu: 'HU',
  /** Indonesia (ID) */
  Id: 'ID',
  /** Ireland (IE) */
  Ie: 'IE',
  /** Israel (IL) */
  Il: 'IL',
  /** Isle of Man (IM) */
  Im: 'IM',
  /** India (IN) */
  In: 'IN',
  /** British Indian Ocean Territory (IO) */
  Io: 'IO',
  /** Iraq (IQ) */
  Iq: 'IQ',
  /** Iran (Islamic Republic of) (IR) */
  Ir: 'IR',
  /** Iceland (IS) */
  Is: 'IS',
  /** Italy (IT) */
  It: 'IT',
  /** Jersey (JE) */
  Je: 'JE',
  /** Jamaica (JM) */
  Jm: 'JM',
  /** Jordan (JO) */
  Jo: 'JO',
  /** Japan (JP) */
  Jp: 'JP',
  /** Kenya (KE) */
  Ke: 'KE',
  /** Kyrgyzstan (KG) */
  Kg: 'KG',
  /** Cambodia (KH) */
  Kh: 'KH',
  /** Kiribati (KI) */
  Ki: 'KI',
  /** Comoros (KM) */
  Km: 'KM',
  /** Saint Kitts and Nevis (KN) */
  Kn: 'KN',
  /** Korea, Democratic People's Republic of (KP) */
  Kp: 'KP',
  /** Korea, Republic of (KR) */
  Kr: 'KR',
  /** Kuwait (KW) */
  Kw: 'KW',
  /** Cayman Islands (KY) */
  Ky: 'KY',
  /** Kazakhstan (KZ) */
  Kz: 'KZ',
  /** Lao People's Democratic Republic (LA) */
  La: 'LA',
  /** Lebanon (LB) */
  Lb: 'LB',
  /** Saint Lucia (LC) */
  Lc: 'LC',
  /** Liechtenstein (LI) */
  Li: 'LI',
  /** Sri Lanka (LK) */
  Lk: 'LK',
  /** Liberia (LR) */
  Lr: 'LR',
  /** Lesotho (LS) */
  Ls: 'LS',
  /** Lithuania (LT) */
  Lt: 'LT',
  /** Luxembourg (LU) */
  Lu: 'LU',
  /** Latvia (LV) */
  Lv: 'LV',
  /** Libyan Arab Jamahiriya (LY) */
  Ly: 'LY',
  /** Morocco (MA) */
  Ma: 'MA',
  /** Monaco (MC) */
  Mc: 'MC',
  /** Moldova, Republic of (MD) */
  Md: 'MD',
  /** Montenegro (ME) */
  Me: 'ME',
  /** Madagascar (MG) */
  Mg: 'MG',
  /** Marshall Islands (MH) */
  Mh: 'MH',
  /** Macedonia (MK) */
  Mk: 'MK',
  /** Mali (ML) */
  Ml: 'ML',
  /** Myanmar (MM) */
  Mm: 'MM',
  /** Mongolia (MN) */
  Mn: 'MN',
  /** Macau (MO) */
  Mo: 'MO',
  /** Northern Mariana Islands (MP) */
  Mp: 'MP',
  /** Martinique (MQ) */
  Mq: 'MQ',
  /** Mauritania (MR) */
  Mr: 'MR',
  /** Montserrat (MS) */
  Ms: 'MS',
  /** Malta (MT) */
  Mt: 'MT',
  /** Mauritius (MU) */
  Mu: 'MU',
  /** Maldives (MV) */
  Mv: 'MV',
  /** Malawi (MW) */
  Mw: 'MW',
  /** Mexico (MX) */
  Mx: 'MX',
  /** Malaysia (MY) */
  My: 'MY',
  /** Mozambique (MZ) */
  Mz: 'MZ',
  /** Namibia (NA) */
  Na: 'NA',
  /** New Caledonia (NC) */
  Nc: 'NC',
  /** Niger (NE) */
  Ne: 'NE',
  /** Norfolk Island (NF) */
  Nf: 'NF',
  /** Nigeria (NG) */
  Ng: 'NG',
  /** Nicaragua (NI) */
  Ni: 'NI',
  /** Netherlands (NL) */
  Nl: 'NL',
  /** Norway (NO) */
  No: 'NO',
  /** Nepal (NP) */
  Np: 'NP',
  /** Nauru (NR) */
  Nr: 'NR',
  /** Niue (NU) */
  Nu: 'NU',
  /** New Zealand (NZ) */
  Nz: 'NZ',
  /** Oman (OM) */
  Om: 'OM',
  /** Panama (PA) */
  Pa: 'PA',
  /** Peru (PE) */
  Pe: 'PE',
  /** French Polynesia (PF) */
  Pf: 'PF',
  /** Papua New Guinea (PG) */
  Pg: 'PG',
  /** Philippines (PH) */
  Ph: 'PH',
  /** Pakistan (PK) */
  Pk: 'PK',
  /** Poland (PL) */
  Pl: 'PL',
  /** St. Pierre and Miquelon (PM) */
  Pm: 'PM',
  /** Pitcairn (PN) */
  Pn: 'PN',
  /** Puerto Rico (PR) */
  Pr: 'PR',
  /** Palestine (PS) */
  Ps: 'PS',
  /** Portugal (PT) */
  Pt: 'PT',
  /** Palau (PW) */
  Pw: 'PW',
  /** Paraguay (PY) */
  Py: 'PY',
  /** Qatar (QA) */
  Qa: 'QA',
  /** Reunion (RE) */
  Re: 'RE',
  /** Romania (RO) */
  Ro: 'RO',
  /** Serbia (RS) */
  Rs: 'RS',
  /** Russian Federation (RU) */
  Ru: 'RU',
  /** Rwanda (RW) */
  Rw: 'RW',
  /** Saudi Arabia (SA) */
  Sa: 'SA',
  /** Solomon Islands (SB) */
  Sb: 'SB',
  /** Seychelles (SC) */
  Sc: 'SC',
  /** Sudan (SD) */
  Sd: 'SD',
  /** Sweden (SE) */
  Se: 'SE',
  /** Singapore (SG) */
  Sg: 'SG',
  /** St. Helena (SH) */
  Sh: 'SH',
  /** Slovenia (SI) */
  Si: 'SI',
  /** Svalbard and Jan Mayen Islands (SJ) */
  Sj: 'SJ',
  /** Slovakia (SK) */
  Sk: 'SK',
  /** Sierra Leone (SL) */
  Sl: 'SL',
  /** San Marino (SM) */
  Sm: 'SM',
  /** Senegal (SN) */
  Sn: 'SN',
  /** Somalia (SO) */
  So: 'SO',
  /** Suriname (SR) */
  Sr: 'SR',
  /** Sao Tome and Principe (ST) */
  St: 'ST',
  /** El Salvador (SV) */
  Sv: 'SV',
  /** Sint Maarten (SX) */
  Sx: 'SX',
  /** Syrian Arab Republic (SY) */
  Sy: 'SY',
  /** Swaziland (SZ) */
  Sz: 'SZ',
  /** Turks and Caicos Islands (TC) */
  Tc: 'TC',
  /** Chad (TD) */
  Td: 'TD',
  /** French Southern Territories (TF) */
  Tf: 'TF',
  /** Togo (TG) */
  Tg: 'TG',
  /** Thailand (TH) */
  Th: 'TH',
  /** Tajikistan (TJ) */
  Tj: 'TJ',
  /** Tokelau (TK) */
  Tk: 'TK',
  /** Turkmenistan (TM) */
  Tm: 'TM',
  /** Tunisia (TN) */
  Tn: 'TN',
  /** Tonga (TO) */
  To: 'TO',
  /** East Timor (TP) */
  Tp: 'TP',
  /** Turkey (TR) */
  Tr: 'TR',
  /** Trinidad and Tobago (TT) */
  Tt: 'TT',
  /** Tuvalu (TV) */
  Tv: 'TV',
  /** Taiwan (TW) */
  Tw: 'TW',
  /** Mayotte (TY) */
  Ty: 'TY',
  /** Tanzania, United Republic of (TZ) */
  Tz: 'TZ',
  /** Ukraine (UA) */
  Ua: 'UA',
  /** Uganda (UG) */
  Ug: 'UG',
  /** United States minor outlying islands (UM) */
  Um: 'UM',
  /** United States (US) */
  Us: 'US',
  /** Uruguay (UY) */
  Uy: 'UY',
  /** Uzbekistan (UZ) */
  Uz: 'UZ',
  /** Vatican City State (VA) */
  Va: 'VA',
  /** Saint Vincent and the Grenadines (VC) */
  Vc: 'VC',
  /** Venezuela (VE) */
  Ve: 'VE',
  /** Virgin Islands (British) (VG) */
  Vg: 'VG',
  /** Virgin Islands (U.S.) (VI) */
  Vi: 'VI',
  /** Vietnam (VN) */
  Vn: 'VN',
  /** Vanuatu (VU) */
  Vu: 'VU',
  /** Wallis and Futuna Islands (WF) */
  Wf: 'WF',
  /** Samoa (WS) */
  Ws: 'WS',
  /** United Kingdom (Northern Ireland) (XI) */
  Xi: 'XI',
  /** Kosovo (XK) */
  Xk: 'XK',
  /** Yemen (YE) */
  Ye: 'YE',
  /** South Africa (ZA) */
  Za: 'ZA',
  /** Zambia (ZM) */
  Zm: 'ZM',
  /** Zaire (ZR) */
  Zr: 'ZR',
  /** Zimbabwe (ZW) */
  Zw: 'ZW'
} as const;

export type CountryCodeEnum = typeof CountryCodeEnum[keyof typeof CountryCodeEnum];
/** Liste von Ländern */
export type CountryList = {
  __typename?: 'CountryList';
  results?: Maybe<Array<Maybe<Country>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Credits */
export type CreditMemo = {
  __typename?: 'CreditMemo';
  amount?: Maybe<Scalars['String']['output']>;
  amountRemaining?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  docNo?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  format?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  no?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  statusClass?: Maybe<Scalars['String']['output']>;
  statusLabel?: Maybe<Scalars['String']['output']>;
};


/** Credits */
export type CreditMemoDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Gutschriften */
export type CreditMemoList = {
  __typename?: 'CreditMemoList';
  results?: Maybe<Array<Maybe<CreditMemo>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Währungen */
export type Currency = {
  __typename?: 'Currency';
  currencyId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isoCode?: Maybe<Scalars['String']['output']>;
  rounding?: Maybe<Scalars['Float']['output']>;
  separatorDecimal?: Maybe<Scalars['String']['output']>;
  separatorThousands?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Währungen */
export type CurrencyUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** List of currencies */
export type CurrencyList = {
  __typename?: 'CurrencyList';
  results?: Maybe<Array<Maybe<Currency>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Kunde */
export type Customer = {
  __typename?: 'Customer';
  addresses?: Maybe<Array<Maybe<CustomerAddress>>>;
  allowShop?: Maybe<Scalars['Int']['output']>;
  backOfficeTeam?: Maybe<Team>;
  bic?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<Maybe<CustomerContact>>>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['Int']['output']>;
  currencyIdRrp?: Maybe<Scalars['Int']['output']>;
  currencyRrp?: Maybe<Currency>;
  customerGroups?: Maybe<Array<Maybe<CustomerGroup>>>;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerNumber?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  information?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameAddition?: Maybe<Scalars['String']['output']>;
  salesRepTeam?: Maybe<Team>;
  shopClientIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  sizeConversionId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  /** Liste von Unterkunden, welche via parentId verknüpft sind */
  subCustomers?: Maybe<Array<Maybe<Customer>>>;
  uId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


/** Kunde */
export type CustomerAddressesArgs = {
  addressType?: InputMaybe<Scalars['Int']['input']>;
};


/** Kunde */
export type CustomerUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Kundenadresse */
export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  addressCode?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  companyAddition?: Maybe<Scalars['String']['output']>;
  companyAddition2?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryLabel?: Maybe<Scalars['String']['output']>;
  customerIds?: Maybe<Scalars['Int']['output']>;
  default?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  modelErrors?: Maybe<Array<Maybe<AttributeError>>>;
  number?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  salutationCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  typeEnum?: Maybe<Scalars['String']['output']>;
  typeLabel?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** Input-Werte für Kundenadresse */
export type CustomerAddressInputType = {
  address_code: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  company_addition?: InputMaybe<Scalars['String']['input']>;
  company_addition2?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<CountryCodeEnum>;
  default?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<SalutationEnum>;
  status?: InputMaybe<StateEnum>;
  street?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CustomerAddressTypeEnum>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export const CustomerAddressTypeEnum = {
  /** Delivery (delivery) */
  Delivery: 'delivery',
  /** Invoice (invoice) */
  Invoice: 'invoice'
} as const;

export type CustomerAddressTypeEnum = typeof CustomerAddressTypeEnum[keyof typeof CustomerAddressTypeEnum];
/** Ansprechpartner */
export type CustomerContact = {
  __typename?: 'CustomerContact';
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstname?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** Kundengruppe */
export type CustomerGroup = {
  __typename?: 'CustomerGroup';
  customerGroupId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ident?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Kundengruppe */
export type CustomerGroupUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Kunden */
export type CustomerList = {
  __typename?: 'CustomerList';
  results?: Maybe<Array<Maybe<Customer>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export const CustomerSortByEnum = {
  /** i18n.customer_number ASC */
  CustomerNumberAsc: 'CUSTOMER_NUMBER_ASC',
  /** i18n.customer_number DESC */
  CustomerNumberDesc: 'CUSTOMER_NUMBER_DESC',
  /** i18n.name ASC */
  NameAsc: 'NAME_ASC',
  /** i18n.name DESC */
  NameDesc: 'NAME_DESC'
} as const;

export type CustomerSortByEnum = typeof CustomerSortByEnum[keyof typeof CustomerSortByEnum];
/** Produkt Preise */
export type DeliveryDate = {
  __typename?: 'DeliveryDate';
  allData?: Maybe<Scalars['String']['output']>;
  allowApp?: Maybe<Scalars['Boolean']['output']>;
  allowShop?: Maybe<Scalars['Boolean']['output']>;
  customerGroupId?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  deadline?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  seasonId?: Maybe<Scalars['Int']['output']>;
  shopProductId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Produkt Preise */
export type DeliveryDateDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Produkt Preise */
export type DeliveryDateDeadlineArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Produkt Preise */
export type DeliveryDateUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Sendungen */
export type DeliveryNote = {
  __typename?: 'DeliveryNote';
  commission?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  link?: Maybe<Scalars['String']['output']>;
  linkLabel?: Maybe<Scalars['String']['output']>;
  no?: Maybe<Scalars['Int']['output']>;
  numberArticles?: Maybe<Scalars['Int']['output']>;
  shippingDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  statusClass?: Maybe<Scalars['String']['output']>;
  statusLabel?: Maybe<Scalars['String']['output']>;
  subTotalWithVat?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};


/** Sendungen */
export type DeliveryNoteDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Sendungen */
export type DeliveryNoteShippingDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Sendungen */
export type DeliveryNoteList = {
  __typename?: 'DeliveryNoteList';
  results?: Maybe<Array<Maybe<DeliveryNote>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Download */
export type Download = {
  __typename?: 'Download';
  categoryIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  downloadId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lft?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  parentId?: Maybe<Scalars['String']['output']>;
  shopClientId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Download */
export type DownloadDescriptionArgs = {
  format?: InputMaybe<ContentFormatEnum>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
};


/** Download */
export type DownloadMediasArgs = {
  targetAttr?: InputMaybe<Scalars['String']['input']>;
};


/** Download */
export type DownloadUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Downloads */
export type DownloadList = {
  __typename?: 'DownloadList';
  /** Kategoriebaum als JSON-String */
  categoryTree?: Maybe<Scalars['String']['output']>;
  /** Strukturbaum der Downloads / Media Center als JSON-String */
  downloadTree?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<Download>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Werte Auswahlliste */
export type DropdownList = {
  __typename?: 'DropdownList';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  valueIdent?: Maybe<Scalars['String']['output']>;
};

/** Formular (Formgenerator) */
export type FormGenerator = {
  __typename?: 'FormGenerator';
  formData?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ident?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  webFormId?: Maybe<Scalars['Int']['output']>;
};

export const FormGeneratorIdentEnum = {
  /** App: Support Form */
  AppRequestSupport: 'APP_REQUEST_SUPPORT',
  /** App: Checkout */
  Checkout: 'CHECKOUT',
  /** Contact */
  Contact: 'Contact',
  /** App: Neukunden Formular */
  NewCustomer: 'NEW_CUSTOMER',
  /** Test Form */
  TestForm: 'TEST_FORM'
} as const;

export type FormGeneratorIdentEnum = typeof FormGeneratorIdentEnum[keyof typeof FormGeneratorIdentEnum];
/** Liste von Formularen */
export type FormGeneratorList = {
  __typename?: 'FormGeneratorList';
  results: Array<FormGenerator>;
  totalCount: Scalars['Int']['output'];
};

/** Frontenduser */
export type Frontenduser = {
  __typename?: 'Frontenduser';
  /** Aktiver Kunde */
  activeCustomer: Customer;
  canOrder?: Maybe<Scalars['Int']['output']>;
  canSeeInvoice?: Maybe<Scalars['Int']['output']>;
  canSeeOrders?: Maybe<Scalars['Int']['output']>;
  canSeePrices?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAdmin?: Maybe<Scalars['Int']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  localeId?: Maybe<Scalars['Int']['output']>;
  medias: Array<Media>;
  modelErrors?: Maybe<Array<Maybe<AttributeError>>>;
  orderBlock?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  salutationCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};


/** Frontenduser */
export type FrontenduserMediasArgs = {
  targetAttr?: InputMaybe<Scalars['ID']['input']>;
};

/** Eingabewerte zum Anlegen oder Aktualisieren eines Frontendusers */
export type FrontenduserInputType = {
  can_order?: InputMaybe<Scalars['Int']['input']>;
  can_see_invoice?: InputMaybe<Scalars['Int']['input']>;
  can_see_orders?: InputMaybe<Scalars['Int']['input']>;
  /** Preise anzeigen, als Werte sind nur 0 oder 1 zulässig */
  can_see_prices?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  is_admin?: InputMaybe<Scalars['Int']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<LocaleEnum>;
  order_block?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  password_repeat?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<SalutationEnum>;
  shop_client_id?: InputMaybe<Scalars['Int']['input']>;
  /** Status */
  status?: InputMaybe<Scalars['Int']['input']>;
  username: Scalars['String']['input'];
};

/** Liste von Benutzern, die mit dem Kunden verknüpft sind */
export type FrontenduserList = {
  __typename?: 'FrontenduserList';
  results: Array<Frontenduser>;
  totalCount: Scalars['Int']['output'];
};

/** Produkt Funktionen */
export type Function = {
  __typename?: 'Function';
  description?: Maybe<Scalars['String']['output']>;
  /** Liste mit Features, die CommerceFashionFunction zugewiesen sind */
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  functionId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Produkt Funktionen */
export type FunctionDescriptionArgs = {
  format?: InputMaybe<ContentFormatEnum>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
};


/** Produkt Funktionen */
export type FunctionMediasArgs = {
  targetAttr?: InputMaybe<Scalars['String']['input']>;
};


/** Produkt Funktionen */
export type FunctionUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Funktionen */
export type FunctionList = {
  __typename?: 'FunctionList';
  results?: Maybe<Array<Maybe<Function>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Zukünftiger Lagerbestand */
export type FutureStock = {
  __typename?: 'FutureStock';
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  shopProductId?: Maybe<Scalars['Int']['output']>;
};


/** Zukünftiger Lagerbestand */
export type FutureStockDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von zukünftigen Lagerbeständen */
export type FutureStockList = {
  __typename?: 'FutureStockList';
  futureStockTotal?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<FutureStock>>>;
};

/** Glossary */
export type Glossary = {
  __typename?: 'Glossary';
  /** Erster Buchstabe des Titels, oder # bei nicht Buchstaben */
  char?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  glossaryId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Glossary */
export type GlossaryDescriptionArgs = {
  format?: InputMaybe<ContentFormatEnum>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
};


/** Glossary */
export type GlossaryMediasArgs = {
  targetAttr?: InputMaybe<Scalars['ID']['input']>;
};

/** Liste von Glossare */
export type GlossaryList = {
  __typename?: 'GlossaryList';
  results?: Maybe<Array<Maybe<Glossary>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export const GlossarySortByEnum = {
  /** i18n.id ASC */
  GlossaryIdAsc: 'GLOSSARY_ID_ASC',
  /** i18n.id DESC */
  GlossaryIdDesc: 'GLOSSARY_ID_DESC',
  /** i18n.title ASC */
  GlossaryTitleAsc: 'GLOSSARY_TITLE_ASC',
  /** i18n.title DESC */
  GlossaryTitleDesc: 'GLOSSARY_TITLE_DESC'
} as const;

export type GlossarySortByEnum = typeof GlossarySortByEnum[keyof typeof GlossarySortByEnum];
/** Invoices */
export type Invoice = {
  __typename?: 'Invoice';
  amount?: Maybe<Scalars['String']['output']>;
  amountRemaining?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  format?: Maybe<Scalars['String']['output']>;
  inWarning?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  no?: Maybe<Scalars['Int']['output']>;
  orderNo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  statusClass?: Maybe<Scalars['String']['output']>;
  statusLabel?: Maybe<Scalars['String']['output']>;
};


/** Invoices */
export type InvoiceDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Invoices */
export type InvoiceDueDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Rechnungen */
export type InvoiceList = {
  __typename?: 'InvoiceList';
  results?: Maybe<Array<Maybe<Invoice>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export const ListTypeEnum = {
  /** Liste mit Icons */
  IconList: 'ICON_LIST',
  /** Liste */
  List: 'LIST'
} as const;

export type ListTypeEnum = typeof ListTypeEnum[keyof typeof ListTypeEnum];
export const LocaleEnum = {
  /** Locale for English (en) */
  En: 'en'
} as const;

export type LocaleEnum = typeof LocaleEnum[keyof typeof LocaleEnum];
/** Looks */
export type Looks = {
  __typename?: 'Looks';
  /** Liste mit IDs verknüpfter Brands */
  brands: Array<Scalars['Int']['output']>;
  categories: Array<LooksCategory>;
  customTitle?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  isFilter?: Maybe<Scalars['Int']['output']>;
  light?: Maybe<Scalars['String']['output']>;
  looksId?: Maybe<Scalars['Int']['output']>;
  medias: Array<Media>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  /** Liste mit IDs verknüpfter Produktlinien */
  productlines: Array<Scalars['Int']['output']>;
  /** Returns list of all products in look model */
  products: Array<LooksProduct>;
  saison?: Maybe<Scalars['String']['output']>;
  /** Liste mit IDs verknüpfter Saisons */
  seasons: Array<Scalars['Int']['output']>;
  shopClientId?: Maybe<Scalars['Int']['output']>;
  showInB2b?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Looks */
export type LooksMediasArgs = {
  targetAttr?: InputMaybe<Scalars['ID']['input']>;
};


/** Looks */
export type LooksUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Looks Kategorien */
export type LooksCategory = {
  __typename?: 'LooksCategory';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  looksCategoryId?: Maybe<Scalars['Int']['output']>;
  medias: Array<Media>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  urlSlug?: Maybe<Scalars['String']['output']>;
};


/** Looks Kategorien */
export type LooksCategoryMediasArgs = {
  targetAttr?: InputMaybe<Scalars['ID']['input']>;
};

/** Liste von Looks Kategorien */
export type LooksCategoryList = {
  __typename?: 'LooksCategoryList';
  results: Array<LooksCategory>;
  totalCount: Scalars['Int']['output'];
};

/** Liste von Looks */
export type LooksList = {
  __typename?: 'LooksList';
  results: Array<Looks>;
  totalCount: Scalars['Int']['output'];
};

/** Look Produkte */
export type LooksProduct = {
  __typename?: 'LooksProduct';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  isFavorite?: Maybe<Scalars['Int']['output']>;
  looksId?: Maybe<Scalars['Int']['output']>;
  productData: Product;
  shopProductId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export const LooksSortByEnum = {
  /** i18n.looks_id ASC */
  LooksIdAsc: 'LOOKS_ID_ASC',
  /** i18n.looks_id DESC */
  LooksIdDesc: 'LOOKS_ID_DESC',
  /** i18n.title ASC */
  LooksTitleAsc: 'LOOKS_TITLE_ASC',
  /** i18n.title DESC */
  LooksTitleDesc: 'LOOKS_TITLE_DESC',
  /** i18n.sort_order ASC */
  SortOrderAsc: 'SORT_ORDER_ASC',
  /** i18n.sort_order DESC */
  SortOrderDesc: 'SORT_ORDER_DESC'
} as const;

export type LooksSortByEnum = typeof LooksSortByEnum[keyof typeof LooksSortByEnum];
/** Medias */
export type Media = {
  __typename?: 'Media';
  alpha?: Maybe<Scalars['Int']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  animation?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  iconClass?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  linkTitle?: Maybe<Scalars['String']['output']>;
  mime?: Maybe<Scalars['String']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  sublabel?: Maybe<Scalars['String']['output']>;
  targetAttr?: Maybe<Scalars['String']['output']>;
  targetClass?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['Int']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


/** Medias */
export type MediaThumbnailArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  useWebp?: InputMaybe<Scalars['Boolean']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/** Medias */
export type MediaUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Menu */
export type Menu = {
  __typename?: 'Menu';
  columns?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  minPerColumn?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<ListTypeEnum>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Alle Positionen einer Merkliste zum Warenkorb hinzufügen */
  addWishlistToBasket?: Maybe<Basket>;
  /** Freigabe Open Order */
  approveWishlist?: Maybe<Wishlist>;
  /** Passwort ändern (mit Token) */
  changePassword?: Maybe<Frontenduser>;
  /** Merkliste duplizieren */
  copyWishlist?: Maybe<Wishlist>;
  /** Erfassen einer neuen Kundenadresse */
  createCustomerAddress?: Maybe<CustomerAddress>;
  /** Erfassen eines neuen Feedback */
  createFeedback?: Maybe<Supportcenterfeedback>;
  /** Neuen Benutzer für übergebenen Kunden anlegen */
  createFrontenduser?: Maybe<Frontenduser>;
  /** Löschen einer Kundenadresse */
  deleteCustomerAddress?: Maybe<CustomerAddress>;
  /** Löschen eines existierenden Benutzers */
  deleteFrontenduser?: Maybe<Frontenduser>;
  /** Merkliste löschen */
  deleteWishlist?: Maybe<Wishlist>;
  hello?: Maybe<Scalars['String']['output']>;
  /** Passwort zurücksetzen anfordern */
  passwordResetRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Benutzer registrieren */
  registerFrontenduser?: Maybe<Frontenduser>;
  /** Entfernen einer Position aus dem Warenkorb */
  removeBasketPosition?: Maybe<Basket>;
  /** Entfernen einer Position aus einer Merkliste */
  removeWishlistPosition?: Maybe<Wishlist>;
  /** Alle Positionen einer Merkliste löschen */
  resetWishlist?: Maybe<Wishlist>;
  /** Abschicken des Warenkorbs (Erstellung einer Bestellung) */
  submitBasket?: Maybe<Array<Maybe<Order>>>;
  /** Bearbeiten des Warenkorbs */
  updateBasket?: Maybe<Basket>;
  /** Aktualisieren Checkout-Daten Warenkorb */
  updateBasketCheckoutData?: Maybe<Basket>;
  /** Verwalten einer Position im Warenkorb */
  updateBasketPosition?: Maybe<BasketPosition>;
  /** Bearbeiten einer Kundenadresse */
  updateCustomerAddress?: Maybe<CustomerAddress>;
  /** Bearbeiten eines existierenden Benutzers */
  updateFrontenduser?: Maybe<Frontenduser>;
  /** Erstellen oder verwalten einer Merkliste */
  updateWishlist?: Maybe<Wishlist>;
  /** Verwalten einer Position der Merkliste */
  updateWishlistPosition?: Maybe<WishlistPosition>;
  /** Verifizierung des Reset-Tokens */
  verifyResetToken?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAddWishlistToBasketArgs = {
  wishlistId: Scalars['Int']['input'];
};


export type MutationApproveWishlistArgs = {
  commission?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  releaseComment?: InputMaybe<Scalars['String']['input']>;
  wishlistId: Scalars['Int']['input'];
};


export type MutationChangePasswordArgs = {
  password: Scalars['String']['input'];
  passwordRepeat: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCopyWishlistArgs = {
  title: Scalars['String']['input'];
  wishlistId: Scalars['Int']['input'];
};


export type MutationCreateCustomerAddressArgs = {
  customerAddressData: CustomerAddressInputType;
};


export type MutationCreateFeedbackArgs = {
  supportcenterFeedbackData: SupportcenterFeedbackInputType;
};


export type MutationCreateFrontenduserArgs = {
  customerId: Scalars['Int']['input'];
  frontenduserData?: InputMaybe<FrontenduserInputType>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteCustomerAddressArgs = {
  customerAddressId: Scalars['Int']['input'];
};


export type MutationDeleteFrontenduserArgs = {
  frontenduserId: Scalars['Int']['input'];
};


export type MutationDeleteWishlistArgs = {
  wishlistId: Scalars['Int']['input'];
};


export type MutationPasswordResetRequestArgs = {
  username: Scalars['String']['input'];
};


export type MutationRegisterFrontenduserArgs = {
  frontenduserData?: InputMaybe<FrontenduserInputType>;
};


export type MutationRemoveBasketPositionArgs = {
  basketPositionId?: InputMaybe<Scalars['Int']['input']>;
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveWishlistPositionArgs = {
  wishlistPositionId: Scalars['Int']['input'];
};


export type MutationResetWishlistArgs = {
  wishlistId: Scalars['Int']['input'];
};


export type MutationSubmitBasketArgs = {
  deliveryOrderAddress: OrderAddressInputType;
  invoiceOrderAddress: OrderAddressInputType;
  orderAsSubCustomer?: InputMaybe<Scalars['Int']['input']>;
  orderData: OrderInputType;
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateBasketArgs = {
  basketPositionData?: InputMaybe<BasketInputType>;
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateBasketCheckoutDataArgs = {
  basketId: Scalars['Int']['input'];
  checkoutData: Scalars['String']['input'];
};


export type MutationUpdateBasketPositionArgs = {
  basketPositionData?: InputMaybe<BasketInputType>;
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateCustomerAddressArgs = {
  customerAddressData: CustomerAddressInputType;
  customerAddressId: Scalars['Int']['input'];
};


export type MutationUpdateFrontenduserArgs = {
  frontenduserData?: InputMaybe<FrontenduserInputType>;
  frontenduserId: Scalars['Int']['input'];
};


export type MutationUpdateWishlistArgs = {
  wishlistData: WishlistInputType;
  wishlistPosition?: InputMaybe<WishlistPositionInputType>;
};


export type MutationUpdateWishlistPositionArgs = {
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
  wishlistId: Scalars['Int']['input'];
  wishlistPosition?: InputMaybe<WishlistPositionInputType>;
};


export type MutationVerifyResetTokenArgs = {
  token: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Navigation */
export type Navigation = {
  __typename?: 'Navigation';
  banner?: Maybe<Array<Maybe<Banner>>>;
  children?: Maybe<Array<Maybe<Navigation>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  icon?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  menu?: Maybe<Menu>;
  path?: Maybe<Scalars['String']['output']>;
  section?: Maybe<SectionTypeEnum>;
  style?: Maybe<StyleTypeEnum>;
  subline?: Maybe<Scalars['String']['output']>;
  target?: Maybe<TargetTypeEnum>;
};

/** Navigation Configuration */
export type NavigationConfiguration = {
  __typename?: 'NavigationConfiguration';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  navigation?: Maybe<Array<Maybe<Navigation>>>;
  template?: Maybe<TemplateTypeEnum>;
};

export const OperatorEnum = {
  /** Greater than */
  Gt: 'gt',
  /** Greater than or equal as */
  Gte: 'gte',
  /** Lower than */
  Lt: 'lt',
  /** Lower than or equal as */
  Lte: 'lte',
  /** Not equal */
  Neq: 'neq'
} as const;

export type OperatorEnum = typeof OperatorEnum[keyof typeof OperatorEnum];
/** Bestellung */
export type Order = {
  __typename?: 'Order';
  addresses?: Maybe<Array<Maybe<OrderAddress>>>;
  comment?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['String']['output']>;
  couponCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  currency?: Maybe<Scalars['String']['output']>;
  currencyId?: Maybe<Scalars['Int']['output']>;
  currencyIdRrp?: Maybe<Scalars['Int']['output']>;
  currencyRrp?: Maybe<Scalars['String']['output']>;
  customOrderId?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerNumber?: Maybe<Scalars['String']['output']>;
  dateCompleted?: Maybe<Scalars['String']['output']>;
  dateOpen?: Maybe<Scalars['String']['output']>;
  dateRefunded?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  /** Department (Dynamisches Feld / Feature) */
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exceptionDate?: Maybe<Scalars['String']['output']>;
  frontendUserName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  information?: Maybe<Scalars['String']['output']>;
  isSigned?: Maybe<Scalars['Int']['output']>;
  isSubmission?: Maybe<Scalars['Int']['output']>;
  modelErrors?: Maybe<Array<Maybe<AttributeError>>>;
  openOrderReferenceId?: Maybe<Scalars['Int']['output']>;
  orderPayment?: Maybe<OrderPayment>;
  orderShippings?: Maybe<Array<Maybe<OrderShipping>>>;
  orderStatus?: Maybe<Scalars['String']['output']>;
  orderStatusLabel?: Maybe<Scalars['String']['output']>;
  orderTaxes?: Maybe<Array<Maybe<OrderTax>>>;
  /** Order Start Date (Dynamisches Feld / Feature) */
  order_start_date?: Maybe<Scalars['String']['output']>;
  /** Order Stop Date (Dynamisches Feld / Feature) */
  order_stop_date?: Maybe<Scalars['String']['output']>;
  /** Order submitted at (UTC) (Dynamisches Feld / Feature) */
  order_submission_at?: Maybe<Scalars['String']['output']>;
  /** Order submission payload (Dynamisches Feld / Feature) */
  order_submission_payload?: Maybe<Scalars['String']['output']>;
  /** Order submission response (Dynamisches Feld / Feature) */
  order_submission_response?: Maybe<Scalars['String']['output']>;
  /** Order submission response code (Dynamisches Feld / Feature) */
  order_submission_response_code?: Maybe<Scalars['String']['output']>;
  /** OrderType (Dynamisches Feld / Feature) */
  order_type?: Maybe<Scalars['String']['output']>;
  /** order_zll_sizes (Dynamisches Feld / Feature) */
  order_zll_sizes?: Maybe<Scalars['String']['output']>;
  paymentRequestUrl?: Maybe<Scalars['String']['output']>;
  paymentTransactionId?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<Maybe<OrderPosition>>>;
  preOrder?: Maybe<Scalars['Int']['output']>;
  /** Retail Distribution Channel (Dynamisches Feld / Feature) */
  retail_distribution_channel?: Maybe<Scalars['String']['output']>;
  salesAppUserFirstname?: Maybe<Scalars['String']['output']>;
  salesAppUserId?: Maybe<Scalars['Int']['output']>;
  salesAppUserLastname?: Maybe<Scalars['String']['output']>;
  salesAppUserName?: Maybe<Scalars['String']['output']>;
  /** Sales Office (Dynamisches Feld / Feature) */
  sales_office?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Season>;
  seasonId?: Maybe<Scalars['Int']['output']>;
  /** Ship To (Dynamisches Feld / Feature) */
  ship_to?: Maybe<Scalars['String']['output']>;
  shippingCosts?: Maybe<Scalars['String']['output']>;
  shippingCostsAdditional?: Maybe<Scalars['String']['output']>;
  shippingCostsTotal?: Maybe<Scalars['String']['output']>;
  shippingCostsVat?: Maybe<Scalars['String']['output']>;
  shippingCostsWithoutVat?: Maybe<Scalars['String']['output']>;
  shopClientId?: Maybe<Scalars['Int']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  /** Statistical Ship To (Dynamisches Feld / Feature) */
  statistical_ship_to?: Maybe<Scalars['String']['output']>;
  subtotalDiscount?: Maybe<Scalars['String']['output']>;
  subtotalRrp?: Maybe<Scalars['String']['output']>;
  subtotalWithVat?: Maybe<Scalars['String']['output']>;
  subtotalWithoutVat?: Maybe<Scalars['String']['output']>;
  totalWithVat?: Maybe<Scalars['String']['output']>;
  totalWithoutVat?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  vatSubtotal?: Maybe<Scalars['String']['output']>;
  vatTotal?: Maybe<Scalars['String']['output']>;
  whiteboardData?: Maybe<Scalars['String']['output']>;
};


/** Bestellung */
export type OrderDateCompletedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Bestellung */
export type OrderDateOpenArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Bestellung */
export type OrderDateRefundedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Bestellung */
export type OrderDeliveryDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Bestellung */
export type OrderExceptionDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Bestellung */
export type OrderShippingCostsArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bestellung */
export type OrderShippingCostsAdditionalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bestellung */
export type OrderShippingCostsTotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bestellung */
export type OrderShippingCostsVatArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bestellung */
export type OrderShippingCostsWithoutVatArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bestellung */
export type OrderSubtotalDiscountArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bestellung */
export type OrderSubtotalRrpArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bestellung */
export type OrderSubtotalWithVatArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bestellung */
export type OrderSubtotalWithoutVatArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bestellung */
export type OrderTotalWithVatArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bestellung */
export type OrderTotalWithoutVatArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bestellung */
export type OrderUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Bestellung */
export type OrderVatSubtotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bestellung */
export type OrderVatTotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Adresse für Bestellung */
export type OrderAddress = {
  __typename?: 'OrderAddress';
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  companyAddition?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  countryLabel?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pobox?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  shopOrderId?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetAddition?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Input-Werte einer Kundenadresse */
export type OrderAddressInputType = {
  address_code?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  company_addition?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['Int']['input']>;
  customer_address_id?: InputMaybe<Scalars['Int']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pobox?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street_addition?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Input-Werte für die Aufgabe einer Bestellung */
export type OrderInputType = {
  basket_id: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  commerce_fashion_season_id?: InputMaybe<Scalars['Int']['input']>;
  commission?: InputMaybe<Scalars['String']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  /** Department (Dynamisches Feld / Feature) */
  department?: InputMaybe<Scalars['String']['input']>;
  /** Order Start Date (Dynamisches Feld / Feature) */
  order_start_date?: InputMaybe<Scalars['String']['input']>;
  /** Order Stop Date (Dynamisches Feld / Feature) */
  order_stop_date?: InputMaybe<Scalars['String']['input']>;
  /** Order submitted at (UTC) (Dynamisches Feld / Feature) */
  order_submission_at?: InputMaybe<Scalars['String']['input']>;
  /** Order submission payload (Dynamisches Feld / Feature) */
  order_submission_payload?: InputMaybe<Scalars['String']['input']>;
  /** Order submission response (Dynamisches Feld / Feature) */
  order_submission_response?: InputMaybe<Scalars['String']['input']>;
  /** Order submission response code (Dynamisches Feld / Feature) */
  order_submission_response_code?: InputMaybe<Scalars['String']['input']>;
  /** OrderType (Dynamisches Feld / Feature) */
  order_type?: InputMaybe<Scalars['String']['input']>;
  /** order_zll_sizes (Dynamisches Feld / Feature) */
  order_zll_sizes?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['Int']['input']>;
  pre_order?: InputMaybe<Scalars['Int']['input']>;
  /** Retail Distribution Channel (Dynamisches Feld / Feature) */
  retail_distribution_channel?: InputMaybe<Scalars['String']['input']>;
  /** Sales Office (Dynamisches Feld / Feature) */
  sales_office?: InputMaybe<Scalars['String']['input']>;
  /** Ship To (Dynamisches Feld / Feature) */
  ship_to?: InputMaybe<Scalars['String']['input']>;
  shipping_custom_option?: InputMaybe<Scalars['Int']['input']>;
  shipping_custom_type?: InputMaybe<Scalars['Int']['input']>;
  shipping_method_id?: InputMaybe<Scalars['Int']['input']>;
  /** Statistical Ship To (Dynamisches Feld / Feature) */
  statistical_ship_to?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Bestellungen */
export type OrderList = {
  __typename?: 'OrderList';
  results?: Maybe<Array<Maybe<Order>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Zahlung Bestellung */
export type OrderPayment = {
  __typename?: 'OrderPayment';
  amountCanceled?: Maybe<Scalars['String']['output']>;
  amountPaid?: Maybe<Scalars['String']['output']>;
  amountRefunded?: Maybe<Scalars['String']['output']>;
  amountShipping?: Maybe<Scalars['String']['output']>;
  amountShippingRefunded?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  paymentMethodId?: Maybe<Scalars['Int']['output']>;
  paymentMethodLabel?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};


/** Zahlung Bestellung */
export type OrderPaymentAmountCanceledArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Zahlung Bestellung */
export type OrderPaymentAmountPaidArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Zahlung Bestellung */
export type OrderPaymentAmountRefundedArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Zahlung Bestellung */
export type OrderPaymentAmountShippingArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Zahlung Bestellung */
export type OrderPaymentAmountShippingRefundedArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Position einer Bestellung */
export type OrderPosition = {
  __typename?: 'OrderPosition';
  comment?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['String']['output']>;
  customSku?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  deliveryDateLabel?: Maybe<Scalars['String']['output']>;
  deliveryDateWish?: Maybe<Scalars['String']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  discountValue?: Maybe<Scalars['String']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  exceptionDate?: Maybe<Scalars['String']['output']>;
  groupIdent?: Maybe<Scalars['String']['output']>;
  groupIdentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCanceled?: Maybe<Scalars['Boolean']['output']>;
  originalPrice?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  priceRrp?: Maybe<Scalars['String']['output']>;
  priceTagRrp?: Maybe<Scalars['String']['output']>;
  productData?: Maybe<Product>;
  productQuantity?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Maybe<OrderProduct>>>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityCanceled?: Maybe<Scalars['Int']['output']>;
  quantityConfirmed?: Maybe<Scalars['Int']['output']>;
  quantityDelivered?: Maybe<Scalars['Int']['output']>;
  quantityProduction?: Maybe<Scalars['Int']['output']>;
  shopProductIdParent?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  subTotal?: Maybe<Scalars['String']['output']>;
  subTotalRrp?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Position einer Bestellung */
export type OrderPositionDeliveryDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Position einer Bestellung */
export type OrderPositionDeliveryDateWishArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Position einer Bestellung */
export type OrderPositionDiscountValueArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Position einer Bestellung */
export type OrderPositionExceptionDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Position einer Bestellung */
export type OrderPositionOriginalPriceArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Position einer Bestellung */
export type OrderPositionPriceArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Position einer Bestellung */
export type OrderPositionPriceRrpArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Position einer Bestellung */
export type OrderPositionPriceTagRrpArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Position einer Bestellung */
export type OrderPositionSubTotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Position einer Bestellung */
export type OrderPositionSubTotalRrpArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Produkt einer Bestellung */
export type OrderProduct = {
  __typename?: 'OrderProduct';
  customSku?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  deliveryDateLabel?: Maybe<Scalars['String']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  discountValue?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCanceled?: Maybe<Scalars['Boolean']['output']>;
  originalPrice?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  priceRrp?: Maybe<Scalars['String']['output']>;
  priceWithoutVat?: Maybe<Scalars['String']['output']>;
  productData?: Maybe<Product>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityCanceled?: Maybe<Scalars['Int']['output']>;
  quantityConfirmed?: Maybe<Scalars['Int']['output']>;
  quantityDelivered?: Maybe<Scalars['Int']['output']>;
  quantityProduction?: Maybe<Scalars['Int']['output']>;
  shopOrderId?: Maybe<Scalars['Int']['output']>;
  shopProductId?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['String']['output']>;
  subtotalRrp?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Produkt einer Bestellung */
export type OrderProductDeliveryDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Produkt einer Bestellung */
export type OrderProductDiscountValueArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Produkt einer Bestellung */
export type OrderProductOriginalPriceArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Produkt einer Bestellung */
export type OrderProductPriceArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Produkt einer Bestellung */
export type OrderProductPriceRrpArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Produkt einer Bestellung */
export type OrderProductPriceWithoutVatArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Produkt einer Bestellung */
export type OrderProductSubtotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Produkt einer Bestellung */
export type OrderProductSubtotalRrpArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Versand Bestellung */
export type OrderShipping = {
  __typename?: 'OrderShipping';
  id?: Maybe<Scalars['Int']['output']>;
  shippingCosts?: Maybe<Scalars['String']['output']>;
  shippingLabel?: Maybe<Scalars['String']['output']>;
  shippingMethodId?: Maybe<Scalars['Int']['output']>;
  shippingMethodLabel?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<Scalars['Int']['output']>;
  trackingLink?: Maybe<Scalars['String']['output']>;
};


/** Versand Bestellung */
export type OrderShippingShippingCostsArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

export const OrderSortByEnum = {
  /** shop_order.id ASC */
  IdAsc: 'ID_ASC',
  /** shop_order.id DESC */
  IdDesc: 'ID_DESC'
} as const;

export type OrderSortByEnum = typeof OrderSortByEnum[keyof typeof OrderSortByEnum];
export const OrderStatusEnum = {
  /** Cancelled */
  ShopOrderStatusCancelled: 'SHOP_ORDER_STATUS_CANCELLED',
  /** Closed */
  ShopOrderStatusClosed: 'SHOP_ORDER_STATUS_CLOSED',
  /** Complete */
  ShopOrderStatusComplete: 'SHOP_ORDER_STATUS_COMPLETE',
  /** Error */
  ShopOrderStatusError: 'SHOP_ORDER_STATUS_ERROR',
  /** On Hold */
  ShopOrderStatusOnHold: 'SHOP_ORDER_STATUS_ON_HOLD',
  /** Pending */
  ShopOrderStatusPending: 'SHOP_ORDER_STATUS_PENDING',
  /** Oustanding payment */
  ShopOrderStatusPendingPayment: 'SHOP_ORDER_STATUS_PENDING_PAYMENT',
  /** Preorder */
  ShopOrderStatusPreorder: 'SHOP_ORDER_STATUS_PREORDER',
  /** preorder-informed */
  ShopOrderStatusPreorderInformed: 'SHOP_ORDER_STATUS_PREORDER_INFORMED',
  /** Processing */
  ShopOrderStatusProcessing: 'SHOP_ORDER_STATUS_PROCESSING',
  /** Transmitted to ERP */
  ShopOrderStatusTransmittedErp: 'SHOP_ORDER_STATUS_TRANSMITTED_ERP'
} as const;

export type OrderStatusEnum = typeof OrderStatusEnum[keyof typeof OrderStatusEnum];
/** Mwst. Bestellung */
export type OrderTax = {
  __typename?: 'OrderTax';
  amount?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
  positionTaxes?: Maybe<Array<Maybe<OrderTaxPosition>>>;
  productTaxes?: Maybe<Array<Maybe<OrderTaxProduct>>>;
  shopOrderId?: Maybe<Scalars['Int']['output']>;
  shopVatTypeId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Mwst. Bestellung */
export type OrderTaxAmountArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Mwst. Position in Bestellung */
export type OrderTaxPosition = {
  __typename?: 'OrderTaxPosition';
  amount?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
  shopOrderPositionId?: Maybe<Scalars['Int']['output']>;
  shopOrderTaxId?: Maybe<Scalars['Int']['output']>;
  shopProductId?: Maybe<Scalars['Int']['output']>;
};


/** Mwst. Position in Bestellung */
export type OrderTaxPositionAmountArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Mwst. Produkt in Bestellung */
export type OrderTaxProduct = {
  __typename?: 'OrderTaxProduct';
  amount?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
  shopOrderProductId?: Maybe<Scalars['Int']['output']>;
  shopOrderTaxId?: Maybe<Scalars['Int']['output']>;
  shopProductId?: Maybe<Scalars['Int']['output']>;
};


/** Mwst. Produkt in Bestellung */
export type OrderTaxProductAmountArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

export const OrderTypeEnum = {
  /** Nach-Order */
  AfterOrder: 'AFTER_ORDER',
  /** All */
  All: 'ALL',
  /** Vor-Order */
  PreOrder: 'PRE_ORDER'
} as const;

export type OrderTypeEnum = typeof OrderTypeEnum[keyof typeof OrderTypeEnum];
/** Parent-Produkt mit Kindern */
export type ParentProduct = {
  __typename?: 'ParentProduct';
  children?: Maybe<Array<Maybe<Product>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productData?: Maybe<Product>;
  shopProductId?: Maybe<Scalars['Int']['output']>;
};

/** Zahlungsmethode */
export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  /** Liste von Ländern (Ids), die mit der Zahlungsmethode verknüpft sind  */
  countries?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  paymentMethodKey?: Maybe<Scalars['String']['output']>;
  shopPaymentMethodId?: Maybe<Scalars['Int']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Zahlungsmethode */
export type PaymentMethodMediasArgs = {
  targetAttr?: InputMaybe<Scalars['String']['input']>;
};


/** Zahlungsmethode */
export type PaymentMethodUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Zahlungsmethoden */
export type PaymentMethodList = {
  __typename?: 'PaymentMethodList';
  results?: Maybe<Array<Maybe<PaymentMethod>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Products */
export type Product = {
  __typename?: 'Product';
  /** BLOCK (Dynamisches Feld / Feature) */
  CUSTOMER_GROUPS_HIDE_BLOCK?: Maybe<Scalars['String']['output']>;
  /** NOS (Dynamisches Feld / Feature) */
  CUSTOMER_GROUPS_HIDE_NOS?: Maybe<Scalars['String']['output']>;
  /** HB_ADDITIONAL_PRODUCT_INFO (Dynamisches Feld / Feature) */
  HB_ADDITIONAL_PRODUCT_INFO?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_ADDITIONAL_RPG (Dynamisches Feld / Feature) */
  HB_ADDITIONAL_RPG?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_AREA (Dynamisches Feld / Feature) */
  HB_AREA?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_BELT_TYPE (Dynamisches Feld / Feature) */
  HB_BELT_TYPE?: Maybe<Array<Maybe<DropdownList>>>;
  /** Fit (Dynamisches Feld / Feature) */
  HB_BODY_TYPE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_BOTTOM_SPECIAL_CLOSURE (Dynamisches Feld / Feature) */
  HB_BOTTOM_SPECIAL_CLOSURE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_BOTTOM_STANDARD_CLOSURE (Dynamisches Feld / Feature) */
  HB_BOTTOM_STANDARD_CLOSURE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_BOTTOM_WAISTBAND_CLOSURE (Dynamisches Feld / Feature) */
  HB_BOTTOM_WAISTBAND_CLOSURE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_BW_COEXISTENCE (Dynamisches Feld / Feature) */
  HB_BW_COEXISTENCE?: Maybe<Array<Maybe<DropdownList>>>;
  /** Development Groups (Dynamisches Feld / Feature) */
  HB_CAPSULE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_CATALOG_GROUP (Dynamisches Feld / Feature) */
  HB_CATALOG_GROUP?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_COLLAR_TYPE (Dynamisches Feld / Feature) */
  HB_COLLAR_TYPE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_CONSTRUCTION (Dynamisches Feld / Feature) */
  HB_CONSTRUCTION?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_COO_STITCHINGOFUPPER (Dynamisches Feld / Feature) */
  HB_COO_STITCHINGOFUPPER?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_CUFF_TYPE (Dynamisches Feld / Feature) */
  HB_CUFF_TYPE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_CUPS (Dynamisches Feld / Feature) */
  HB_CUPS?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_CUT_WEFT_FABRIC_QUALITIES (Dynamisches Feld / Feature) */
  HB_CUT_WEFT_FABRIC_QUALITIES?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_FASHION_GRADE (Dynamisches Feld / Feature) */
  HB_FASHION_GRADE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_FASTENING_SLA (Dynamisches Feld / Feature) */
  HB_FASTENING_SLA?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_FASTENING_TOP (Dynamisches Feld / Feature) */
  HB_FASTENING_TOP?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_FINISHING_NAME (Dynamisches Feld / Feature) */
  HB_FINISHING_NAME?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_FIT_BACK_LENGTH (Dynamisches Feld / Feature) */
  HB_FIT_BACK_LENGTH?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_FIT_FOOT_WIDTH (Dynamisches Feld / Feature) */
  HB_FIT_FOOT_WIDTH?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_FIT_RISE (Dynamisches Feld / Feature) */
  HB_FIT_RISE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_FIT_SILHOUETTE (Dynamisches Feld / Feature) */
  HB_FIT_SILHOUETTE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_FRINGE_LENGTH (Dynamisches Feld / Feature) */
  HB_FRINGE_LENGTH?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_GAUGE_KNITWEAR (Dynamisches Feld / Feature) */
  HB_GAUGE_KNITWEAR?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_GAUGE_UNIT_KNITWEAR (Dynamisches Feld / Feature) */
  HB_GAUGE_UNIT_KNITWEAR?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_GENDER (Dynamisches Feld / Feature) */
  HB_GENDER?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_GIFT_BOX (Dynamisches Feld / Feature) */
  HB_GIFT_BOX?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_GLOVE_FIT (Dynamisches Feld / Feature) */
  HB_GLOVE_FIT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_GLOVE_WEIGHT (Dynamisches Feld / Feature) */
  HB_GLOVE_WEIGHT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_GRAIN_FABRIC_QUALITIES (Dynamisches Feld / Feature) */
  HB_GRAIN_FABRIC_QUALITIES?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_HANDLES (Dynamisches Feld / Feature) */
  HB_HANDLES?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_HARDWARE_FINISHING (Dynamisches Feld / Feature) */
  HB_HARDWARE_FINISHING?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_HAT_CLOSURE (Dynamisches Feld / Feature) */
  HB_HAT_CLOSURE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_HAT_FIT (Dynamisches Feld / Feature) */
  HB_HAT_FIT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_HAT_FIT_LENGTH (Dynamisches Feld / Feature) */
  HB_HAT_FIT_LENGTH?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_HAT_VISOR (Dynamisches Feld / Feature) */
  HB_HAT_VISOR?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_HEEL_HEIGHT (Dynamisches Feld / Feature) */
  HB_HEEL_HEIGHT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_HEEL_SHOES_CUSTOMS (Dynamisches Feld / Feature) */
  HB_HEEL_SHOES_CUSTOMS?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_HEM_TYPE (Dynamisches Feld / Feature) */
  HB_HEM_TYPE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_JEANS_COLOR_DIRECTION (Dynamisches Feld / Feature) */
  HB_JEANS_COLOR_DIRECTION?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_JEANS_TYPE (Dynamisches Feld / Feature) */
  HB_JEANS_TYPE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_JEANS_WASH_DIRECTION (Dynamisches Feld / Feature) */
  HB_JEANS_WASH_DIRECTION?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_JERSEY_TYPE (Dynamisches Feld / Feature) */
  HB_JERSEY_TYPE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_KNITTING_STRUCTURE (Dynamisches Feld / Feature) */
  HB_KNITTING_STRUCTURE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_KNIT_TO_SHAPE (Dynamisches Feld / Feature) */
  HB_KNIT_TO_SHAPE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_BILL_COMPARTMENT (Dynamisches Feld / Feature) */
  HB_LA_BILL_COMPARTMENT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_COIN_POCKET (Dynamisches Feld / Feature) */
  HB_LA_COIN_POCKET?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_CREDIT_CARD_SLOT (Dynamisches Feld / Feature) */
  HB_LA_CREDIT_CARD_SLOT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_DETACHABLE_KEY_HOOK (Dynamisches Feld / Feature) */
  HB_LA_DETACHABLE_KEY_HOOK?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_FLYING_POCKET_WITH_ZIP (Dynamisches Feld / Feature) */
  HB_LA_FLYING_POCKET_WITH_ZIP?: Maybe<Scalars['String']['output']>;
  /** HB_LA_ID_POCKET (Dynamisches Feld / Feature) */
  HB_LA_ID_POCKET?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_INSIDE_OPEN_POCKET (Dynamisches Feld / Feature) */
  HB_LA_INSIDE_OPEN_POCKET?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_INSIDE_ORGANIZER (Dynamisches Feld / Feature) */
  HB_LA_INSIDE_ORGANIZER?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_INSIDE_ZIP_POCKET (Dynamisches Feld / Feature) */
  HB_LA_INSIDE_ZIP_POCKET?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_KEY_HOOK (Dynamisches Feld / Feature) */
  HB_LA_KEY_HOOK?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_LAPTOP_COMPARTMENT (Dynamisches Feld / Feature) */
  HB_LA_LAPTOP_COMPARTMENT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_MAIN_COMPARTMENT (Dynamisches Feld / Feature) */
  HB_LA_MAIN_COMPARTMENT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_MONEY_CLIP (Dynamisches Feld / Feature) */
  HB_LA_MONEY_CLIP?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_OPEN_POCKET_BACK (Dynamisches Feld / Feature) */
  HB_LA_OPEN_POCKET_BACK?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_OPEN_POCKET_FRONT (Dynamisches Feld / Feature) */
  HB_LA_OPEN_POCKET_FRONT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_PHONE_POCKET (Dynamisches Feld / Feature) */
  HB_LA_PHONE_POCKET?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_SHOULDER_STRAP (Dynamisches Feld / Feature) */
  HB_LA_SHOULDER_STRAP?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_SIDE_COMPARTMENT (Dynamisches Feld / Feature) */
  HB_LA_SIDE_COMPARTMENT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_SMART_SLEEVE_BACK (Dynamisches Feld / Feature) */
  HB_LA_SMART_SLEEVE_BACK?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LA_TABLET_POCKET (Dynamisches Feld / Feature) */
  HB_LA_TABLET_POCKET?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LEFTOVER (Dynamisches Feld / Feature) */
  HB_LEFTOVER?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LEG_LENGTH (Dynamisches Feld / Feature) */
  HB_LEG_LENGTH?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LENGTH_PRODUCTS (Dynamisches Feld / Feature) */
  HB_LENGTH_PRODUCTS?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LENGTH_PRODUCTS_CUSTOM (Dynamisches Feld / Feature) */
  HB_LENGTH_PRODUCTS_CUSTOM?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LENGTH_TROUSERS (Dynamisches Feld / Feature) */
  HB_LENGTH_TROUSERS?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LINING_FINISHED_PRODUCT (Dynamisches Feld / Feature) */
  HB_LINING_FINISHED_PRODUCT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_LOGO (Dynamisches Feld / Feature) */
  HB_LOGO?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_MARA_MTART (Dynamisches Feld / Feature) */
  HB_MARA_MTART?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_MATCH_FABRIC_QUALITIES (Dynamisches Feld / Feature) */
  HB_MATCH_FABRIC_QUALITIES?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_MATERIAL_QUALITY (Dynamisches Feld / Feature) */
  HB_MATERIAL_QUALITY?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_MF_LABEL_FUNCTION (Dynamisches Feld / Feature) */
  HB_MF_LABEL_FUNCTION?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_MF_LABEL_MATERIAL (Dynamisches Feld / Feature) */
  HB_MF_LABEL_MATERIAL?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_MF_LABEL_ORIGIN (Dynamisches Feld / Feature) */
  HB_MF_LABEL_ORIGIN?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_MF_LABEL_SUPPLIER_LOGO (Dynamisches Feld / Feature) */
  HB_MF_LABEL_SUPPLIER_LOGO?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_MICRON_COUNT_CUSTOM (Dynamisches Feld / Feature) */
  HB_MICRON_COUNT_CUSTOM?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_MULTIPACK_COMPONENTS (Dynamisches Feld / Feature) */
  HB_MULTIPACK_COMPONENTS?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_NAME_SPECIES_CUSTOM (Dynamisches Feld / Feature) */
  HB_NAME_SPECIES_CUSTOM?: Maybe<Scalars['String']['output']>;
  /** HB_NECKLINE (Dynamisches Feld / Feature) */
  HB_NECKLINE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_NUMBER_OF_BUTTONS (Dynamisches Feld / Feature) */
  HB_NUMBER_OF_BUTTONS?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_NUMBER_OF_COMPONENTS (Dynamisches Feld / Feature) */
  HB_NUMBER_OF_COMPONENTS?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_NUMBER_OF_VENTS (Dynamisches Feld / Feature) */
  HB_NUMBER_OF_VENTS?: Maybe<Array<Maybe<DropdownList>>>;
  /** Occasion (Dynamisches Feld / Feature) */
  HB_OCCASION?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_OPENING (Dynamisches Feld / Feature) */
  HB_OPENING?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_PACKAGING (Dynamisches Feld / Feature) */
  HB_PACKAGING?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_PADDING (Dynamisches Feld / Feature) */
  HB_PADDING?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_PANEL (Dynamisches Feld / Feature) */
  HB_PANEL?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_PATTERN (Dynamisches Feld / Feature) */
  HB_PATTERN?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_PLEATS_TROUSERS (Dynamisches Feld / Feature) */
  HB_PLEATS_TROUSERS?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_POCKETS_BOTTOM_BACK (Dynamisches Feld / Feature) */
  HB_POCKETS_BOTTOM_BACK?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_POCKETS_BOTTOM_FRONT (Dynamisches Feld / Feature) */
  HB_POCKETS_BOTTOM_FRONT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_POCKETS_CHEST (Dynamisches Feld / Feature) */
  HB_POCKETS_CHEST?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_POCKETS_INSIDE (Dynamisches Feld / Feature) */
  HB_POCKETS_INSIDE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_POCKETS_TOP (Dynamisches Feld / Feature) */
  HB_POCKETS_TOP?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_POS_TYPE (Dynamisches Feld / Feature) */
  HB_POS_TYPE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_PRINT_PLACEMENT (Dynamisches Feld / Feature) */
  HB_PRINT_PLACEMENT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_PRINT_TECHNIQUE (Dynamisches Feld / Feature) */
  HB_PRINT_TECHNIQUE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_PRODUCT_AREA (Dynamisches Feld / Feature) */
  HB_PRODUCT_AREA?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_PRODUCT_HEIGHT (Dynamisches Feld / Feature) */
  HB_PRODUCT_HEIGHT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_PRODUCT_LENGTH (Dynamisches Feld / Feature) */
  HB_PRODUCT_LENGTH?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_PRODUCT_WIDTH (Dynamisches Feld / Feature) */
  HB_PRODUCT_WIDTH?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_PROTECT_SPECIES_CUSTOM (Dynamisches Feld / Feature) */
  HB_PROTECT_SPECIES_CUSTOM?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_QUALITY_CLASS (Dynamisches Feld / Feature) */
  HB_QUALITY_CLASS?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_QUALITY_GROUP (Dynamisches Feld / Feature) */
  HB_QUALITY_GROUP?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_QUALITY_WEIGHT_LEVEL (Dynamisches Feld / Feature) */
  HB_QUALITY_WEIGHT_LEVEL?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_REINFORCEMENT (Dynamisches Feld / Feature) */
  HB_REINFORCEMENT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_RETAIL_PRODUCT_GROUP (Dynamisches Feld / Feature) */
  HB_RETAIL_PRODUCT_GROUP?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_RETAIL_PRODUCT_GROUP_OLD (Dynamisches Feld / Feature) */
  HB_RETAIL_PRODUCT_GROUP_OLD?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_RT_NOT_STOCK_CONTROLLED (Dynamisches Feld / Feature) */
  HB_RT_NOT_STOCK_CONTROLLED?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_SCARVE_FIT (Dynamisches Feld / Feature) */
  HB_SCARVE_FIT?: Maybe<Scalars['String']['output']>;
  /** HB_SHOELEG_CUSTOMS (Dynamisches Feld / Feature) */
  HB_SHOELEG_CUSTOMS?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_SHOE_GROUP (Dynamisches Feld / Feature) */
  HB_SHOE_GROUP?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_SILHOUETTE (Dynamisches Feld / Feature) */
  HB_SILHOUETTE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_SIZE1 (Dynamisches Feld / Feature) */
  HB_SIZE1?: Maybe<Scalars['String']['output']>;
  /** HB_SIZE2 (Dynamisches Feld / Feature) */
  HB_SIZE2?: Maybe<Scalars['String']['output']>;
  /** HB_SLEEVE_LENGTH (Dynamisches Feld / Feature) */
  HB_SLEEVE_LENGTH?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_SLEEVE_TYPE (Dynamisches Feld / Feature) */
  HB_SLEEVE_TYPE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_SLIT_TYPE (Dynamisches Feld / Feature) */
  HB_SLIT_TYPE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_SOLE (Dynamisches Feld / Feature) */
  HB_SOLE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_SOLE_CUSTOMS (Dynamisches Feld / Feature) */
  HB_SOLE_CUSTOMS?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_SOLE_CUSTOMS_LIST (Dynamisches Feld / Feature) */
  HB_SOLE_CUSTOMS_LIST?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_SPARTE (Dynamisches Feld / Feature) */
  HB_SPARTE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_STITCHCOUNT_ROWS (Dynamisches Feld / Feature) */
  HB_STITCHCOUNT_ROWS?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_STITCHCOUNT_WALES (Dynamisches Feld / Feature) */
  HB_STITCHCOUNT_WALES?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_STRETCH_FABRIC_QUALITIES (Dynamisches Feld / Feature) */
  HB_STRETCH_FABRIC_QUALITIES?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_STRETCH_TYPE (Dynamisches Feld / Feature) */
  HB_STRETCH_TYPE?: Maybe<Array<Maybe<DropdownList>>>;
  /** Product Segmentation (Dynamisches Feld / Feature) */
  HB_STYLE_CLUSTER?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_SURFACE_COAT_CUSTOM (Dynamisches Feld / Feature) */
  HB_SURFACE_COAT_CUSTOM?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TECH_DESSIN_FABRIC_QUALITY (Dynamisches Feld / Feature) */
  HB_TECH_DESSIN_FABRIC_QUALITY?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_THICKNESS_FABRIC_QUALITIES (Dynamisches Feld / Feature) */
  HB_THICKNESS_FABRIC_QUALITIES?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_THREAD (Dynamisches Feld / Feature) */
  HB_THREAD?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TITER_YARN (Dynamisches Feld / Feature) */
  HB_TITER_YARN?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TREATMENT (Dynamisches Feld / Feature) */
  HB_TREATMENT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TROUSERS_LEG_SOLUTION (Dynamisches Feld / Feature) */
  HB_TROUSERS_LEG_SOLUTION?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TYPE_BLOUSE (Dynamisches Feld / Feature) */
  HB_TYPE_BLOUSE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TYPE_BOOT (Dynamisches Feld / Feature) */
  HB_TYPE_BOOT?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TYPE_FABRIC (Dynamisches Feld / Feature) */
  HB_TYPE_FABRIC?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TYPE_FABRIC_QUALITIES (Dynamisches Feld / Feature) */
  HB_TYPE_FABRIC_QUALITIES?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TYPE_FINISHING (Dynamisches Feld / Feature) */
  HB_TYPE_FINISHING?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TYPE_LAPEL (Dynamisches Feld / Feature) */
  HB_TYPE_LAPEL?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TYPE_LOAFER (Dynamisches Feld / Feature) */
  HB_TYPE_LOAFER?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TYPE_MARKER (Dynamisches Feld / Feature) */
  HB_TYPE_MARKER?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TYPE_MONK (Dynamisches Feld / Feature) */
  HB_TYPE_MONK?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TYPE_PUMP (Dynamisches Feld / Feature) */
  HB_TYPE_PUMP?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TYPE_SANDAL (Dynamisches Feld / Feature) */
  HB_TYPE_SANDAL?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_TYPE_SNEAKER (Dynamisches Feld / Feature) */
  HB_TYPE_SNEAKER?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_UPPER_CUSTOMS (Dynamisches Feld / Feature) */
  HB_UPPER_CUSTOMS?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_UPPER_CUSTOMS_LIST (Dynamisches Feld / Feature) */
  HB_UPPER_CUSTOMS_LIST?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_WAISTBAND_TYPE (Dynamisches Feld / Feature) */
  HB_WAISTBAND_TYPE?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_WAREHOUSE_PRODUCT_GROUP (Dynamisches Feld / Feature) */
  HB_WAREHOUSE_PRODUCT_GROUP?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_WEIGHT_DENIM (Dynamisches Feld / Feature) */
  HB_WEIGHT_DENIM?: Maybe<Array<Maybe<DropdownList>>>;
  /** HB_WIDTH_BELT (Dynamisches Feld / Feature) */
  HB_WIDTH_BELT?: Maybe<Array<Maybe<DropdownList>>>;
  /** MPG (Dynamisches Feld / Feature) */
  MPG?: Maybe<Scalars['String']['output']>;
  /** Product Area (Dynamisches Feld / Feature) */
  PRODUCT_AREA?: Maybe<Array<Maybe<DropdownList>>>;
  /** SPG (Dynamisches Feld / Feature) */
  SPG?: Maybe<Scalars['String']['output']>;
  allowShop?: Maybe<Scalars['Boolean']['output']>;
  allowWishlist?: Maybe<Scalars['Boolean']['output']>;
  appCatalogInformation?: Maybe<Scalars['String']['output']>;
  appDetailInformation?: Maybe<Scalars['String']['output']>;
  /** Core Range (Dynamisches Feld / Feature) */
  app_filter_core_range?: Maybe<Scalars['String']['output']>;
  /** Keylook (Dynamisches Feld / Feature) */
  app_filter_keylook?: Maybe<Scalars['String']['output']>;
  attributes: Array<Scalars['String']['output']>;
  /** Liste mit IDs verknüpfter Brands */
  brandIds: Array<Scalars['Int']['output']>;
  /** Kategorien für dieses Produkt */
  categories: Array<ProductCategory>;
  children: Array<Product>;
  childrenCount?: Maybe<Scalars['Int']['output']>;
  /** Farbe des Produkts */
  color?: Maybe<Color>;
  /** Produktspezifische Farbbezeichnung des Produkts oder der verknüpften Farbe. */
  colorName?: Maybe<Scalars['String']['output']>;
  /** Color Card (Dynamisches Feld / Feature) */
  color_card?: Maybe<Scalars['String']['output']>;
  /** Color (Dynamisches Feld / Feature) */
  color_name?: Maybe<Scalars['String']['output']>;
  /** Offertype (Dynamisches Feld / Feature) */
  color_offertype?: Maybe<Scalars['String']['output']>;
  /** Offertype Detail (Dynamisches Feld / Feature) */
  color_offertype_cust?: Maybe<Scalars['String']['output']>;
  /** Outtype (Dynamisches Feld / Feature) */
  color_outtype?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customData?: Maybe<Scalars['String']['output']>;
  customSku?: Maybe<Scalars['String']['output']>;
  defaultId?: Maybe<Scalars['Int']['output']>;
  /** Lieferdaten */
  deliveryDateFull: Array<DeliveryDate>;
  /** Lieferdaten */
  deliveryDates: Array<Scalars['String']['output']>;
  /** Delivery Window (Dynamisches Feld / Feature) */
  delivery_window?: Maybe<Array<Maybe<DropdownList>>>;
  description?: Maybe<Scalars['String']['output']>;
  dispo?: Maybe<Scalars['Int']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  emotionalColorName?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Liste mit Daten zu Features, die ShopProduct zugewiesen sind */
  featureValues: Array<DropdownList>;
  /** Liste mit Features, die ShopProduct zugewiesen sind */
  features: Array<Scalars['String']['output']>;
  filterIds: Array<Scalars['String']['output']>;
  filterOptions: Array<ProductFilterValue>;
  /** Form Usp Text (Dynamisches Feld / Feature) */
  form_usp_text?: Maybe<Scalars['String']['output']>;
  /** Verknüpfte Funktionen */
  functions: Array<Function>;
  futureStocks?: Maybe<FutureStockList>;
  /** Hanging List (Dynamisches Feld / Feature) */
  hl_hnr?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inStock?: Maybe<Scalars['Boolean']['output']>;
  information?: Maybe<Scalars['String']['output']>;
  inventoryAmountNotInStockStatus?: Maybe<Scalars['Int']['output']>;
  isDefaultColor?: Maybe<Scalars['Int']['output']>;
  isSale?: Maybe<Scalars['Boolean']['output']>;
  isTopProduct?: Maybe<Scalars['Boolean']['output']>;
  /** Keylook (Dynamisches Feld / Feature) */
  keylook?: Maybe<Array<Maybe<DropdownList>>>;
  lastOrderDate?: Maybe<Scalars['String']['output']>;
  /** Verknüpfte Looks */
  looks: Array<Looks>;
  /** Hauptfarbe des Produkts */
  mainColor?: Maybe<Color>;
  /** Material No. (Dynamisches Feld / Feature) */
  matnr?: Maybe<Scalars['String']['output']>;
  maxOrderAmount?: Maybe<Scalars['Int']['output']>;
  medias: Array<Media>;
  minOrderAmount?: Maybe<Scalars['Int']['output']>;
  moodImageType?: Maybe<Scalars['String']['output']>;
  nos?: Maybe<Scalars['Int']['output']>;
  originalPrice?: Maybe<Scalars['String']['output']>;
  originalPriceFormatted?: Maybe<Scalars['String']['output']>;
  overbookable?: Maybe<Scalars['Int']['output']>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceFormatted?: Maybe<Scalars['String']['output']>;
  productDetailInformation?: Maybe<Scalars['String']['output']>;
  productOverviewInformation?: Maybe<Scalars['String']['output']>;
  /** Liste verfügbarer Grössen */
  productSizes: Array<ProductSize>;
  productTags: Array<Scalars['Int']['output']>;
  /** Delivery Window (Dynamisches Feld / Feature) */
  product_info_delivery_windows?: Maybe<Scalars['String']['output']>;
  /** product_info_development_groups (Dynamisches Feld / Feature) */
  product_info_development_groups?: Maybe<Scalars['String']['output']>;
  /** Fit (Dynamisches Feld / Feature) */
  product_info_fit?: Maybe<Scalars['String']['output']>;
  /** Quality no. (Dynamisches Feld / Feature) */
  product_info_quality?: Maybe<Scalars['String']['output']>;
  /** SPG (Dynamisches Feld / Feature) */
  product_info_spg?: Maybe<Scalars['String']['output']>;
  /** product_segmentation_text (Dynamisches Feld / Feature) */
  product_segmentation_text?: Maybe<Scalars['String']['output']>;
  productlineId?: Maybe<Scalars['Int']['output']>;
  /** Quality Usp Text (Dynamisches Feld / Feature) */
  quality_usp_text?: Maybe<Scalars['String']['output']>;
  quantityIncrement?: Maybe<Scalars['Int']['output']>;
  /** Ähnliche Produkte für dieses Produkt */
  relatedProducts: Array<RelatedProduct>;
  relatedProductsCount?: Maybe<Scalars['Int']['output']>;
  /** Responsible (Dynamisches Feld / Feature) */
  responsible?: Maybe<Scalars['String']['output']>;
  /** responsible_usp_text (Dynamisches Feld / Feature) */
  responsible_usp_text?: Maybe<Scalars['String']['output']>;
  rrp?: Maybe<Scalars['Float']['output']>;
  rrpFormatted?: Maybe<Scalars['String']['output']>;
  salePercent?: Maybe<Scalars['String']['output']>;
  /** Liste mit IDs verknüpfter Saisons */
  seasonIds: Array<Scalars['Int']['output']>;
  /** Segment (Dynamisches Feld / Feature) */
  segment?: Maybe<Scalars['String']['output']>;
  shopCategoryDefaultId?: Maybe<Scalars['Int']['output']>;
  shopClientId?: Maybe<Scalars['Int']['output']>;
  shopProductId?: Maybe<Scalars['Int']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** Grösse des Produkts */
  size?: Maybe<Size>;
  sku?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  stock?: Maybe<Scalars['Int']['output']>;
  stockStatus?: Maybe<Scalars['Int']['output']>;
  /** Style Offertype (Dynamisches Feld / Feature) */
  style_offertype?: Maybe<Scalars['String']['output']>;
  /** Style Offertype 1 (Dynamisches Feld / Feature) */
  style_offertype_1?: Maybe<Scalars['String']['output']>;
  /** Style Usp Text (Dynamisches Feld / Feature) */
  style_usp_text?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Sustainable Detail (Dynamisches Feld / Feature) */
  sust_detail?: Maybe<Scalars['String']['output']>;
  tags: Array<ProductTag>;
  /** Verknüpfte Themenwelten  */
  themeworlds: Array<Themeworld>;
  title?: Maybe<Scalars['String']['output']>;
  totalOrderedQuantity?: Maybe<Scalars['Int']['output']>;
  upc?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Form (Dynamisches Feld / Feature) */
  zz_form?: Maybe<Scalars['String']['output']>;
  /** Material composition (Dynamisches Feld / Feature) */
  zz_mazu_text?: Maybe<Scalars['String']['output']>;
  /** Quality (Dynamisches Feld / Feature) */
  zz_quali?: Maybe<Scalars['String']['output']>;
  /** Quality function (Dynamisches Feld / Feature) */
  zz_quali_emotional?: Maybe<Scalars['String']['output']>;
};


/** Products */
export type ProductLooksArgs = {
  inB2b?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Products */
export type ProductMediasArgs = {
  targetAttr?: InputMaybe<Scalars['String']['input']>;
};


/** Products */
export type ProductThemeworldsArgs = {
  inB2b?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Products */
export type ProductUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Produkt-Kategorie */
export type ProductCategory = {
  __typename?: 'ProductCategory';
  /** Kategorie Breadcrumbs JSON */
  breadcrumbs?: Maybe<Scalars['String']['output']>;
  /** Liste mit Filtern dieser Kategorie */
  filters: Array<ProductCategoryFilter>;
  /** Google-Produktkategorie (Produkt-Taxonomie) Id */
  googleShoppingCategory?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  left?: Maybe<Scalars['Int']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  medias: Array<Media>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  /** Liste mit allen Produkten der Kategorie */
  products: Array<ProductCategoryProduct>;
  right?: Maybe<Scalars['Int']['output']>;
  shopCategoryId?: Maybe<Scalars['Int']['output']>;
  /** Liste mit Sortierungen dieser Kategorie */
  sorting: Array<ProductCategorySorting>;
  status?: Maybe<Scalars['Int']['output']>;
  sublabel?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Produkt-Kategorie */
export type ProductCategoryMediasArgs = {
  targetAttr?: InputMaybe<Scalars['String']['input']>;
};


/** Produkt-Kategorie */
export type ProductCategoryUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Kategorie-Filter */
export type ProductCategoryFilter = {
  __typename?: 'ProductCategoryFilter';
  additionalOption?: Maybe<Scalars['Int']['output']>;
  displayOnTop?: Maybe<Scalars['Int']['output']>;
  displayOption?: Maybe<Scalars['Int']['output']>;
  filterData?: Maybe<ProductFilter>;
  filterId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isFavorite?: Maybe<Scalars['Int']['output']>;
  shopCategoryId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Kategorie-Filter */
export type ProductCategoryFilterUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Produkt-Kategorien */
export type ProductCategoryList = {
  __typename?: 'ProductCategoryList';
  /** Kategoriebaum als JSON-String */
  categoryTree?: Maybe<Scalars['String']['output']>;
  results: Array<ProductCategory>;
  totalCount: Scalars['Int']['output'];
};

/** Kategorie-Produkte */
export type ProductCategoryProduct = {
  __typename?: 'ProductCategoryProduct';
  id?: Maybe<Scalars['Int']['output']>;
  isFavorite?: Maybe<Scalars['Int']['output']>;
  productData?: Maybe<Product>;
  shopCategoryId?: Maybe<Scalars['Int']['output']>;
  shopProductId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Kategorie-Produkte */
export type ProductCategoryProductUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Kategorie-Sortierung */
export type ProductCategorySorting = {
  __typename?: 'ProductCategorySorting';
  attribute?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDefault?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  shopCategoryId?: Maybe<Scalars['Int']['output']>;
  sortOption?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Kategorie-Sortierung */
export type ProductCategorySortingUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Produkt-Filter */
export type ProductFilter = {
  __typename?: 'ProductFilter';
  additionalDisplayOption?: Maybe<Scalars['String']['output']>;
  displayOnTop?: Maybe<Scalars['Boolean']['output']>;
  hasHits?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ident?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  maxValue?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Array<Maybe<ProductFilterValue>>>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Werte Produkt Filter */
export type ProductFilterValue = {
  __typename?: 'ProductFilterValue';
  /** Zusätzliche Filter-Werte als JSON-String */
  additionalValues?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  hasHits?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ident?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** Liste von Produkten */
export type ProductList = {
  __typename?: 'ProductList';
  filters: Array<ProductFilter>;
  productSortOptions: Array<ProductSortOption>;
  rawTotalCount: Scalars['Int']['output'];
  results: Array<Product>;
  searchResultCategoryIds: Array<Scalars['Int']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

/** Produkt-Notiz */
export type ProductNote = {
  __typename?: 'ProductNote';
  categoryIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  productNoteId?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Maybe<Product>>>;
  shopClientId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Produkt-Notiz */
export type ProductNoteDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Produkt-Notiz */
export type ProductNoteUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Produkt-Notiz Kategorie */
export type ProductNoteCategory = {
  __typename?: 'ProductNoteCategory';
  id?: Maybe<Scalars['Int']['output']>;
  productNoteCategoryId?: Maybe<Scalars['Int']['output']>;
  productNoteIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Produkt-Notiz Kategorie */
export type ProductNoteCategoryUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Produkt-Notizen Kategorien */
export type ProductNoteCategoryList = {
  __typename?: 'ProductNoteCategoryList';
  results?: Maybe<Array<Maybe<ProductNoteCategory>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Liste von Produkt-Notizen */
export type ProductNoteList = {
  __typename?: 'ProductNoteList';
  results?: Maybe<Array<Maybe<ProductNote>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Produkt-Preis */
export type ProductPrice = {
  __typename?: 'ProductPrice';
  price?: Maybe<Scalars['String']['output']>;
  priceRrp?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  salePrice?: Maybe<Scalars['String']['output']>;
  shopProductId?: Maybe<Scalars['Int']['output']>;
  subTotal?: Maybe<Scalars['String']['output']>;
  subTotalRrp?: Maybe<Scalars['String']['output']>;
};


/** Produkt-Preis */
export type ProductPricePriceArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Produkt-Preis */
export type ProductPricePriceRrpArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Produkt-Preis */
export type ProductPriceSalePriceArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Produkt-Preis */
export type ProductPriceSubTotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Produkt-Preis */
export type ProductPriceSubTotalRrpArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input-Werte für Produkt-Preis Berechnungen */
export type ProductPriceInputType = {
  quantity: Scalars['Int']['input'];
  shop_product_id: Scalars['Int']['input'];
};

/** Liste von berechneten Produkt-Preisen */
export type ProductPriceList = {
  __typename?: 'ProductPriceList';
  results?: Maybe<Array<Maybe<ProductPrice>>>;
  total?: Maybe<Scalars['String']['output']>;
  totalRrp?: Maybe<Scalars['String']['output']>;
};


/** Liste von berechneten Produkt-Preisen */
export type ProductPriceListTotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Liste von berechneten Produkt-Preisen */
export type ProductPriceListTotalRrpArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Verfügbare Grösse */
export type ProductSize = {
  __typename?: 'ProductSize';
  futureStocks?: Maybe<FutureStockList>;
  inStock?: Maybe<Scalars['Boolean']['output']>;
  shopProductId?: Maybe<Scalars['Int']['output']>;
  sizeGridId?: Maybe<Scalars['Int']['output']>;
  sizeGridSortOrder?: Maybe<Scalars['Int']['output']>;
  sizeGridTitle?: Maybe<Scalars['String']['output']>;
  sizeId?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  stock?: Maybe<Scalars['Int']['output']>;
  stockStatus?: Maybe<Scalars['Int']['output']>;
  /** Titel der Grösse oder der hinterlegten Size-Conversion */
  title?: Maybe<Scalars['String']['output']>;
};

export const ProductSortByEnum = {
  /** shop_category_product.shop_category_id, shop_category_product.sort_order ASC */
  CategoryAsc: 'CATEGORY_ASC',
  /** shop_category_product.shop_category_id DESC, shop_category_product.sort_order DESC */
  CategoryDesc: 'CATEGORY_DESC',
  /** last_order_date DESC */
  LastOrderDateDesc: 'LAST_ORDER_DATE_DESC',
  /** i18n.new DESC */
  NewDesc: 'NEW_DESC',
  /** price_sort ASC */
  PriceAsc: 'PRICE_ASC',
  /** price_sort DESC */
  PriceDesc: 'PRICE_DESC',
  /** price ASC */
  PriceRrpAsc: 'PRICE_RRP_ASC',
  /** price DESC */
  PriceRrpDesc: 'PRICE_RRP_DESC',
  /** sale ASC */
  SaleAsc: 'SALE_ASC',
  /** commerce_fashion_seasoni18n.sort_order ASC, shop_product.custom_sku ASC */
  SeasonAsc: 'SEASON_ASC',
  /** shop_product.custom_sku ASC */
  SkuAsc: 'SKU_ASC',
  /** shop_product.custom_sku DESC */
  SkuDesc: 'SKU_DESC',
  /** i18n.title ASC */
  TitleAsc: 'TITLE_ASC',
  /** i18n.title DESC */
  TitleDesc: 'TITLE_DESC',
  /** app_filter_core_range_ASC */
  AppFilterCoreRangeAsc: 'app_filter_core_range_ASC',
  /** app_filter_core_range_DESC */
  AppFilterCoreRangeDesc: 'app_filter_core_range_DESC',
  /** app_filter_keylook_ASC */
  AppFilterKeylookAsc: 'app_filter_keylook_ASC',
  /** app_filter_keylook_DESC */
  AppFilterKeylookDesc: 'app_filter_keylook_DESC',
  /** color_name_ASC */
  ColorNameAsc: 'color_name_ASC',
  /** color_name_DESC */
  ColorNameDesc: 'color_name_DESC',
  /** color_offertype_ASC */
  ColorOffertypeAsc: 'color_offertype_ASC',
  /** color_offertype_DESC */
  ColorOffertypeDesc: 'color_offertype_DESC',
  /** color_offertype_cust_ASC */
  ColorOffertypeCustAsc: 'color_offertype_cust_ASC',
  /** color_offertype_cust_DESC */
  ColorOffertypeCustDesc: 'color_offertype_cust_DESC',
  /** color_outtype_ASC */
  ColorOuttypeAsc: 'color_outtype_ASC',
  /** color_outtype_DESC */
  ColorOuttypeDesc: 'color_outtype_DESC',
  /** hl_hnr_ASC */
  HlHnrAsc: 'hl_hnr_ASC',
  /** hl_hnr_DESC */
  HlHnrDesc: 'hl_hnr_DESC',
  /** matnr_ASC */
  MatnrAsc: 'matnr_ASC',
  /** matnr_DESC */
  MatnrDesc: 'matnr_DESC',
  /** product_info_delivery_windows_ASC */
  ProductInfoDeliveryWindowsAsc: 'product_info_delivery_windows_ASC',
  /** product_info_delivery_windows_DESC */
  ProductInfoDeliveryWindowsDesc: 'product_info_delivery_windows_DESC',
  /** product_info_development_groups_ASC */
  ProductInfoDevelopmentGroupsAsc: 'product_info_development_groups_ASC',
  /** product_info_development_groups_DESC */
  ProductInfoDevelopmentGroupsDesc: 'product_info_development_groups_DESC',
  /** product_info_fit_ASC */
  ProductInfoFitAsc: 'product_info_fit_ASC',
  /** product_info_fit_DESC */
  ProductInfoFitDesc: 'product_info_fit_DESC',
  /** product_info_quality_ASC */
  ProductInfoQualityAsc: 'product_info_quality_ASC',
  /** product_info_quality_DESC */
  ProductInfoQualityDesc: 'product_info_quality_DESC',
  /** product_info_spg_ASC */
  ProductInfoSpgAsc: 'product_info_spg_ASC',
  /** product_info_spg_DESC */
  ProductInfoSpgDesc: 'product_info_spg_DESC',
  /** product_segmentation_text_ASC */
  ProductSegmentationTextAsc: 'product_segmentation_text_ASC',
  /** product_segmentation_text_DESC */
  ProductSegmentationTextDesc: 'product_segmentation_text_DESC',
  /** responsible_ASC */
  ResponsibleAsc: 'responsible_ASC',
  /** responsible_DESC */
  ResponsibleDesc: 'responsible_DESC',
  /** segment_ASC */
  SegmentAsc: 'segment_ASC',
  /** segment_DESC */
  SegmentDesc: 'segment_DESC',
  /** zz_form_ASC */
  ZzFormAsc: 'zz_form_ASC',
  /** zz_form_DESC */
  ZzFormDesc: 'zz_form_DESC',
  /** zz_quali_ASC */
  ZzQualiAsc: 'zz_quali_ASC',
  /** zz_quali_DESC */
  ZzQualiDesc: 'zz_quali_DESC',
  /** zz_quali_emotional_ASC */
  ZzQualiEmotionalAsc: 'zz_quali_emotional_ASC',
  /** zz_quali_emotional_DESC */
  ZzQualiEmotionalDesc: 'zz_quali_emotional_DESC'
} as const;

export type ProductSortByEnum = typeof ProductSortByEnum[keyof typeof ProductSortByEnum];
/** Sortierung Produkte */
export type ProductSortOption = {
  __typename?: 'ProductSortOption';
  enumValue?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** Produkt-Tag */
export type ProductTag = {
  __typename?: 'ProductTag';
  id?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  productIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  productTagId?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Maybe<Product>>>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Produkt-Tag */
export type ProductTagMediasArgs = {
  targetAttr?: InputMaybe<Scalars['String']['input']>;
};


/** Produkt-Tag */
export type ProductTagUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Produkt-Tags */
export type ProductTagList = {
  __typename?: 'ProductTagList';
  results?: Maybe<Array<Maybe<ProductTag>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Produktlinie */
export type Productline = {
  __typename?: 'Productline';
  id?: Maybe<Scalars['Int']['output']>;
  mark?: Maybe<Scalars['String']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  productlineId?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Maybe<Product>>>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  urlSlug?: Maybe<Scalars['String']['output']>;
};


/** Produktlinie */
export type ProductlineMediasArgs = {
  targetAttr?: InputMaybe<Scalars['String']['input']>;
};


/** Produktlinie */
export type ProductlineUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Produktlinien */
export type ProductlineList = {
  __typename?: 'ProductlineList';
  results?: Maybe<Array<Maybe<Productline>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Open Orders */
  basket?: Maybe<Basket>;
  /** Blog Daten für übergebene ID */
  blog?: Maybe<Blog>;
  /** Liste von Blog Kategorien */
  blogCategories: BlogCategoryList;
  /** Liste von Blogs */
  blogs?: Maybe<BlogList>;
  /** Daten Brand für übergebene ID */
  brand?: Maybe<Brand>;
  /** Brands */
  brands?: Maybe<BrandList>;
  /** Katalog-Einstellungen */
  catalogSettings: CatalogSettings;
  /** Daten Mandant für übergebene ID */
  client: Client;
  /** Mandanten */
  clients?: Maybe<ClientList>;
  /** Colors */
  colorGroups?: Maybe<ColorGroupList>;
  /** Color */
  colors?: Maybe<ColorList>;
  /** Liste von Ländern */
  countries?: Maybe<CountryList>;
  /** Credits */
  creditMemos?: Maybe<CreditMemoList>;
  /** List of currencies */
  currencies?: Maybe<CurrencyList>;
  /** Daten Kunde für übergebene ID */
  customer?: Maybe<Customer>;
  /** Liste von Benutzern, die mit dem Kunden verknüpft sind */
  customerUsers: FrontenduserList;
  /** Kunden */
  customers?: Maybe<CustomerList>;
  /** Sendungen */
  deliveryNotes?: Maybe<DeliveryNoteList>;
  /** Download Daten für übergebene ID */
  download?: Maybe<Download>;
  /** Liste von Downloads */
  downloads?: Maybe<DownloadList>;
  /** Footer Navigation */
  footerNavigation: NavigationConfiguration;
  /** Formular (Formgenerator) */
  formgenerator: FormGenerator;
  /** Formulare */
  forms: FormGeneratorList;
  /** Daten zu eingeloggtem Frontenduser */
  frontenduser: Frontenduser;
  /** Funktions Daten für übergebene ID */
  function?: Maybe<Function>;
  /** List of functions */
  functions?: Maybe<FunctionList>;
  /** Liste von Glossare */
  glossaries?: Maybe<GlossaryList>;
  /** Glossary Daten für übergebene ID */
  glossary?: Maybe<Glossary>;
  /** Liste von Glossare mit gewähltem Anfangsbuchstaben */
  glossaryByChar?: Maybe<GlossaryList>;
  /** Header Navigation */
  headerNavigation: NavigationConfiguration;
  hello?: Maybe<Scalars['String']['output']>;
  /** Invoices */
  invoices?: Maybe<InvoiceList>;
  /** Look-Daten für übergebene ID */
  look: Looks;
  /** Liste von Looks */
  looks: LooksList;
  /** Liste von Looks Kategorien */
  looksCategories: LooksCategoryList;
  /** Daten Bestellung für übergebene ID */
  order?: Maybe<Order>;
  /** Daten einer Position einer Bestellung für übergebene ID */
  orderPosition?: Maybe<OrderPosition>;
  /** Liste von Bestellungen */
  orders?: Maybe<OrderList>;
  /** Daten für Parent-Produkt mit Kindern */
  parentProduct?: Maybe<ParentProduct>;
  /** Zahlungsmethode für übergebene ID */
  paymentMethod?: Maybe<PaymentMethod>;
  /** Liste von Zahlungsmethoden */
  paymentMethods?: Maybe<PaymentMethodList>;
  /** Produkt Daten für übergebene ID */
  product: Product;
  /** Produkt-Kategorien */
  productCategories: ProductCategoryList;
  /** Kategorie-Daten für übergebene ID */
  productCategory: ProductCategory;
  /** Daten Produkt-Notiz für übergebene ID */
  productNote?: Maybe<ProductNote>;
  /** Liste mit Produkt-Notizen Kategorien */
  productNoteCategories?: Maybe<ProductNoteCategoryList>;
  /** Liste mit Produkt-Notizen */
  productNotes?: Maybe<ProductNoteList>;
  /** Liste mit berechneten Preisdaten für Produkte (Mengenrabatte etc. werden berücksichtigt) */
  productPrices?: Maybe<ProductPriceList>;
  /** Daten Produkt-Tag für übergebene ID */
  productTag?: Maybe<ProductTag>;
  /** Liste mit Produkt-Tags */
  productTags?: Maybe<ProductTagList>;
  /** Funktions Daten für übergebene ID */
  productline?: Maybe<Productline>;
  /** List of product lines */
  productlines?: Maybe<ProductlineList>;
  /** Liste von Produkten */
  products: ProductList;
  /** Vertriebsapp Daten für übergebene ID */
  salesApp?: Maybe<SalesApp>;
  /** Season Daten für übergebene ID */
  season: Season;
  /** Liste von Seasons */
  seasons: SeasonList;
  /** Liste von Segmenten */
  segments?: Maybe<SegmentList>;
  /** Versandmethode für übergebene ID */
  shippingMethod?: Maybe<ShippingMethod>;
  /** Liste von Versandmethoden */
  shippingMethods?: Maybe<ShippingMethodList>;
  /** ShowroomIntro Daten für übergebene ID */
  showroomIntro?: Maybe<ShowroomIntro>;
  /** Liste von ShowroomIntro Kategorien */
  showroomIntroCategories?: Maybe<ShowroomIntroCategoryList>;
  /** Liste von ShowroomIntros */
  showroomIntros?: Maybe<ShowroomIntroList>;
  /** Size grid data for transferred ID */
  sizeGrid: SizeGrid;
  /** List of size grids */
  sizeGrids: SizeGridList;
  /** Supportcenter Daten für übergebene ID */
  supportcenter?: Maybe<Supportcenter>;
  /** Liste von Supportcenter Kategorien */
  supportcentercategories?: Maybe<SupportcenterCategoryList>;
  /** Liste von Supportcenter Einträgen */
  supportcenters?: Maybe<SupportcenterList>;
  /** Liste von Team Kategorien */
  teamCategories: TeamCategoryList;
  /** Liste von Teams */
  teams: TeamList;
  /** Returns Themeworld by themeworld_id */
  themeworld: Themeworld;
  /** Liste von Themenwelt Kategorien */
  themeworldCategories: ThemeworldCategoryList;
  /** Returns list of Themeworlds */
  themeworlds: ThemeworldList;
  /** Liste von Website-Sprachen */
  websiteLocales?: Maybe<WebsiteLocaleList>;
  /** Daten / Eintellungen der Webseite */
  websiteSettings?: Maybe<WebsiteSettings>;
  /** Daten Merkliste für übergebene ID */
  wishlist: Wishlist;
  /** Wishlists */
  wishlists: WishlistList;
};


export type QueryBasketArgs = {
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBlogArgs = {
  blogId: Scalars['ID']['input'];
};


export type QueryBlogCategoriesArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBlogsArgs = {
  blogAuthorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<BlogSortByEnum>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryBrandArgs = {
  brandId: Scalars['Int']['input'];
};


export type QueryBrandsArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
};


export type QueryCatalogSettingsArgs = {
  orderType?: InputMaybe<OrderTypeEnum>;
  productLineId?: InputMaybe<Scalars['Int']['input']>;
  rootCategoryId?: InputMaybe<Scalars['Int']['input']>;
  seasonId?: InputMaybe<Scalars['Int']['input']>;
  shopClientId: Scalars['Int']['input'];
};


export type QueryClientArgs = {
  shopClientId: Scalars['Int']['input'];
};


export type QueryClientsArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
};


export type QueryColorGroupsArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
};


export type QueryColorsArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
  sortBy?: InputMaybe<ColorSortByEnum>;
};


export type QueryCountriesArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
};


export type QueryCurrenciesArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
};


export type QueryCustomerArgs = {
  customerId: Scalars['Int']['input'];
};


export type QueryCustomerUsersArgs = {
  customerId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomersArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  lastId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
  sortBy?: InputMaybe<CustomerSortByEnum>;
};


export type QueryDownloadArgs = {
  downloadId: Scalars['Int']['input'];
};


export type QueryDownloadsArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  downloadIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
  selectedDownload?: InputMaybe<Scalars['Int']['input']>;
  shopClientIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryFooterNavigationArgs = {
  shopClientId: Scalars['Int']['input'];
};


export type QueryFormgeneratorArgs = {
  ident: FormGeneratorIdentEnum;
};


export type QueryFormsArgs = {
  idents?: InputMaybe<Array<InputMaybe<FormGeneratorIdentEnum>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryFunctionArgs = {
  functionId: Scalars['Int']['input'];
};


export type QueryFunctionsArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
};


export type QueryGlossariesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<GlossarySortByEnum>;
};


export type QueryGlossaryArgs = {
  glossaryId: Scalars['ID']['input'];
};


export type QueryGlossaryByCharArgs = {
  char?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<GlossarySortByEnum>;
};


export type QueryHeaderNavigationArgs = {
  bannerWidth?: InputMaybe<Scalars['Int']['input']>;
  shopClientId: Scalars['Int']['input'];
};


export type QueryLookArgs = {
  looksId: Scalars['Int']['input'];
};


export type QueryLooksArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  inB2B?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  looksIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
  productLineIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  seasonIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  shopClientIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortBy?: InputMaybe<LooksSortByEnum>;
};


export type QueryLooksCategoriesArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  inB2B?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
  productLineIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  seasonIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  shopClientIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryOrderArgs = {
  shopOrderId: Scalars['Int']['input'];
};


export type QueryOrderPositionArgs = {
  orderPositionId: Scalars['Int']['input'];
};


export type QueryOrdersArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  excludeB2BOrders?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  lastId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyOwnOrders?: InputMaybe<Scalars['Boolean']['input']>;
  operator?: InputMaybe<OperatorEnum>;
  orderStatus?: InputMaybe<OrderStatusEnum>;
  orderType?: InputMaybe<OrderTypeEnum>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  shopClientIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortBy?: InputMaybe<OrderSortByEnum>;
};


export type QueryParentProductArgs = {
  parentId: Scalars['Int']['input'];
};


export type QueryPaymentMethodArgs = {
  shopPaymentMethodId: Scalars['ID']['input'];
};


export type QueryPaymentMethodsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryProductCategoriesArgs = {
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductCategoryArgs = {
  categoryId: Scalars['Int']['input'];
};


export type QueryProductNoteArgs = {
  productNoteId: Scalars['Int']['input'];
};


export type QueryProductNoteCategoriesArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
};


export type QueryProductNotesArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
};


export type QueryProductPricesArgs = {
  priceData: Array<InputMaybe<ProductPriceInputType>>;
};


export type QueryProductTagArgs = {
  productTagId: Scalars['Int']['input'];
};


export type QueryProductTagsArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
};


export type QueryProductlineArgs = {
  productlineId: Scalars['Int']['input'];
};


export type QueryProductlinesArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
};


export type QueryProductsArgs = {
  afterOrder?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  displayFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableFuzziness?: InputMaybe<Scalars['Boolean']['input']>;
  inStockOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mainColorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
  preOrder?: InputMaybe<Scalars['Boolean']['input']>;
  priceRange?: InputMaybe<Scalars['String']['input']>;
  priceRangeRrp?: InputMaybe<Scalars['String']['input']>;
  productsFromOrders?: InputMaybe<Scalars['Boolean']['input']>;
  productsFromOrdersDateFrom?: InputMaybe<Scalars['String']['input']>;
  productsFromOrdersDateTo?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  selectedFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shopClientIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  shopProductIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortBy?: InputMaybe<ProductSortByEnum>;
  topProductsAmount?: InputMaybe<Scalars['Int']['input']>;
  topProductsMonths?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySalesAppArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<OperatorEnum>;
  salesAppId: Scalars['Int']['input'];
};


export type QuerySeasonArgs = {
  seasonId: Scalars['Int']['input'];
};


export type QuerySeasonsArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
};


export type QuerySegmentsArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
  type?: InputMaybe<SegmentTypeEnum>;
};


export type QueryShippingMethodArgs = {
  shopShippingMethodId: Scalars['ID']['input'];
};


export type QueryShippingMethodsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryShowroomIntroArgs = {
  showroomIntroId: Scalars['Int']['input'];
};


export type QueryShowroomIntroCategoriesArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
};


export type QueryShowroomIntrosArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
  productLineIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  seasonIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  shopClientIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  showroomIntroIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortBy?: InputMaybe<ShowroomIntroSortByEnum>;
};


export type QuerySizeGridArgs = {
  sizeGridId: Scalars['Int']['input'];
};


export type QuerySizeGridsArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
};


export type QuerySupportcenterArgs = {
  supportcenterId: Scalars['ID']['input'];
};


export type QuerySupportcentercategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupportcentersArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTeamCategoriesArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
  shopClientIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryTeamsArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  shopClientIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortBy?: InputMaybe<TeamSortByEnum>;
};


export type QueryThemeworldArgs = {
  themeworldId: Scalars['Int']['input'];
};


export type QueryThemeworldCategoriesArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  inB2B?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
  productLineIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  seasonIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  shopClientIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryThemeworldsArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  inB2B?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
  productLineIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  seasonIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  shopClientIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortBy?: InputMaybe<ThemeworldSortByEnum>;
  themeworldIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryWebsiteLocalesArgs = {
  dateValueEnd?: InputMaybe<Scalars['String']['input']>;
  dateValueStart?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<OperatorEnum>;
};


export type QueryWishlistArgs = {
  includeSubCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  loadSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
  wishlistId: Scalars['Int']['input'];
};


export type QueryWishlistsArgs = {
  includeSubCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  loadSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pendingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  seasonIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  shopClientId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** Änliche Produkte */
export type RelatedProduct = {
  __typename?: 'RelatedProduct';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  isFavorite?: Maybe<Scalars['Int']['output']>;
  productData?: Maybe<Product>;
  shopProductId?: Maybe<Scalars['Int']['output']>;
  shopProductIdRelated?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** Daten Vertriebsapp */
export type SalesApp = {
  __typename?: 'SalesApp';
  configuration?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Liste mit Filtern der Vertriebsapp */
  filters?: Maybe<Array<Maybe<SalesAppFilter>>>;
  id?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  status?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  websiteLocales?: Maybe<Array<Maybe<WebsiteLocale>>>;
};


/** Daten Vertriebsapp */
export type SalesAppMediasArgs = {
  targetAttr?: InputMaybe<Scalars['String']['input']>;
};


/** Daten Vertriebsapp */
export type SalesAppUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Filter Vertriebsapp */
export type SalesAppFilter = {
  __typename?: 'SalesAppFilter';
  additionalOption?: Maybe<Scalars['Int']['output']>;
  displayOnTop?: Maybe<Scalars['Int']['output']>;
  displayOption?: Maybe<Scalars['Int']['output']>;
  displayShowroom?: Maybe<Scalars['Int']['output']>;
  filterData?: Maybe<CatalogFilter>;
  filterId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isFavorite?: Maybe<Scalars['Int']['output']>;
  salesAppId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Filter Vertriebsapp */
export type SalesAppFilterUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export const SalutationEnum = {
  /** Ms. */
  F: 'f',
  /** Mr. */
  M: 'm'
} as const;

export type SalutationEnum = typeof SalutationEnum[keyof typeof SalutationEnum];
/** Season */
export type Season = {
  __typename?: 'Season';
  analyticsFrom?: Maybe<Scalars['String']['output']>;
  analyticsTo?: Maybe<Scalars['String']['output']>;
  checkStock?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** List with Features that are attached to Product */
  features: Array<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ident?: Maybe<Scalars['String']['output']>;
  importEnabled?: Maybe<Scalars['Int']['output']>;
  isAftersale?: Maybe<Scalars['Int']['output']>;
  isPresale?: Maybe<Scalars['Int']['output']>;
  medias: Array<Media>;
  products: Array<SeasonProduct>;
  saleStart?: Maybe<Scalars['String']['output']>;
  saleable?: Maybe<Scalars['Boolean']['output']>;
  saleableFrom?: Maybe<Scalars['String']['output']>;
  saleableTo?: Maybe<Scalars['String']['output']>;
  seasonId?: Maybe<Scalars['Int']['output']>;
  showStock?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  urlSlug?: Maybe<Scalars['String']['output']>;
};


/** Season */
export type SeasonAnalyticsFromArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Season */
export type SeasonAnalyticsToArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Season */
export type SeasonDescriptionArgs = {
  format?: InputMaybe<ContentFormatEnum>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
};


/** Season */
export type SeasonMediasArgs = {
  targetAttr?: InputMaybe<Scalars['ID']['input']>;
};


/** Season */
export type SeasonSaleStartArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Season */
export type SeasonSaleableFromArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Season */
export type SeasonSaleableToArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Season */
export type SeasonUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** List of Seasons */
export type SeasonList = {
  __typename?: 'SeasonList';
  results: Array<Season>;
  totalCount: Scalars['Int']['output'];
};

/** Season Products */
export type SeasonProduct = {
  __typename?: 'SeasonProduct';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  isFavorite?: Maybe<Scalars['Int']['output']>;
  productData?: Maybe<Product>;
  seasonId?: Maybe<Scalars['Int']['output']>;
  shopProductId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export const SectionTypeEnum = {
  /** Content */
  Content: 'CONTENT',
  /** Vor-Order */
  PreOrder: 'PRE_ORDER',
  /** Nach-Order */
  ReOrder: 'RE_ORDER'
} as const;

export type SectionTypeEnum = typeof SectionTypeEnum[keyof typeof SectionTypeEnum];
/** Segment */
export type Segment = {
  __typename?: 'Segment';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ident?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  segmentId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Segment */
export type SegmentLastUpdatedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Segment */
export type SegmentUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Segmenten */
export type SegmentList = {
  __typename?: 'SegmentList';
  results?: Maybe<Array<Maybe<Segment>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export const SegmentTypeEnum = {
  None: 'None'
} as const;

export type SegmentTypeEnum = typeof SegmentTypeEnum[keyof typeof SegmentTypeEnum];
/** Versandmethode */
export type ShippingMethod = {
  __typename?: 'ShippingMethod';
  /** Liste von Ländern (Ids), die mit der Versandmethode verknüpft sind  */
  countries?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  shopShippingMethodId?: Maybe<Scalars['Int']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Versandmethode */
export type ShippingMethodMediasArgs = {
  targetAttr?: InputMaybe<Scalars['String']['input']>;
};


/** Versandmethode */
export type ShippingMethodUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Versandmethoden */
export type ShippingMethodList = {
  __typename?: 'ShippingMethodList';
  results?: Maybe<Array<Maybe<ShippingMethod>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** ShowroomIntro */
export type ShowroomIntro = {
  __typename?: 'ShowroomIntro';
  /** Liste mit IDs verknüpfter Brands */
  brands?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  categories?: Maybe<Array<Maybe<ShowroomIntroCategory>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hueLight?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isScreensaver?: Maybe<Scalars['Int']['output']>;
  leftAutoplay?: Maybe<Scalars['Int']['output']>;
  leftCaption?: Maybe<Scalars['String']['output']>;
  leftLoop?: Maybe<Scalars['Int']['output']>;
  leftMuted?: Maybe<Scalars['Int']['output']>;
  leftSubtitle?: Maybe<Scalars['String']['output']>;
  leftTitle?: Maybe<Scalars['String']['output']>;
  leftView?: Maybe<Scalars['String']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  middleAutoplay?: Maybe<Scalars['Int']['output']>;
  middleCaption?: Maybe<Scalars['String']['output']>;
  middleLoop?: Maybe<Scalars['Int']['output']>;
  middleMuted?: Maybe<Scalars['Int']['output']>;
  middleSubtitle?: Maybe<Scalars['String']['output']>;
  middleTitle?: Maybe<Scalars['String']['output']>;
  middleView?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Liste mit IDs verknüpfter Produktlinien */
  productlines?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  rightAutoplay?: Maybe<Scalars['Int']['output']>;
  rightCaption?: Maybe<Scalars['String']['output']>;
  rightLoop?: Maybe<Scalars['Int']['output']>;
  rightMuted?: Maybe<Scalars['Int']['output']>;
  rightSubtitle?: Maybe<Scalars['String']['output']>;
  rightTitle?: Maybe<Scalars['String']['output']>;
  rightView?: Maybe<Scalars['String']['output']>;
  /** Liste mit IDs verknüpfter Saisons */
  seasons?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Liste mit IDs verknüpfter Mandanten */
  shopClients?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  showroomEffect?: Maybe<Scalars['String']['output']>;
  showroomIntroId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** ShowroomIntro */
export type ShowroomIntroMediasArgs = {
  targetAttr?: InputMaybe<Scalars['ID']['input']>;
};


/** ShowroomIntro */
export type ShowroomIntroUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** ShowroomIntro Kategorien */
export type ShowroomIntroCategory = {
  __typename?: 'ShowroomIntroCategory';
  id?: Maybe<Scalars['Int']['output']>;
  showroomIntroCategoryId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Liste von ShowroomIntro Kategorien */
export type ShowroomIntroCategoryList = {
  __typename?: 'ShowroomIntroCategoryList';
  results?: Maybe<Array<Maybe<ShowroomIntroCategory>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Liste von ShowroomIntros */
export type ShowroomIntroList = {
  __typename?: 'ShowroomIntroList';
  results?: Maybe<Array<Maybe<ShowroomIntro>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export const ShowroomIntroSortByEnum = {
  /** i18n.showroom_intro_id ASC */
  ShowroomIntroIdAsc: 'SHOWROOM_INTRO_ID_ASC',
  /** i18n.showroom_intro_id DESC */
  ShowroomIntroIdDesc: 'SHOWROOM_INTRO_ID_DESC',
  /** i18n.name ASC */
  ShowroomIntroNameAsc: 'SHOWROOM_INTRO_NAME_ASC',
  /** i18n.name DESC */
  ShowroomIntroNameDesc: 'SHOWROOM_INTRO_NAME_DESC'
} as const;

export type ShowroomIntroSortByEnum = typeof ShowroomIntroSortByEnum[keyof typeof ShowroomIntroSortByEnum];
/** Grössen */
export type Size = {
  __typename?: 'Size';
  /** Liste mit Features, die CommerceFashionSize zugewiesen sind */
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  sizeConversions?: Maybe<Array<Maybe<SizeConversion>>>;
  sizeGrid?: Maybe<SizeGrid>;
  sizeGridId?: Maybe<Scalars['Int']['output']>;
  sizeGridSortOrder?: Maybe<Scalars['Int']['output']>;
  sizeGridTitle?: Maybe<Scalars['String']['output']>;
  sizeId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Grössenumwandlung */
export type SizeConversion = {
  __typename?: 'SizeConversion';
  id?: Maybe<Scalars['Int']['output']>;
  ident?: Maybe<Scalars['String']['output']>;
  sizeConversionId?: Maybe<Scalars['Int']['output']>;
  sizeId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Grössenumwandlung */
export type SizeConversionUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Grössenraster */
export type SizeGrid = {
  __typename?: 'SizeGrid';
  countries: Array<Scalars['Int']['output']>;
  /** Liste mit Features, die CommerceFashionSizeGrid zugewiesen sind */
  features: Array<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  sizeGridId?: Maybe<Scalars['Int']['output']>;
  sizes: Array<Size>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** List of Size Grids */
export type SizeGridList = {
  __typename?: 'SizeGridList';
  results: Array<SizeGrid>;
  totalCount: Scalars['Int']['output'];
};

export const StateEnum = {
  /** Active (active) */
  Active: 'active',
  /** Inactive (inactive) */
  Inactive: 'inactive'
} as const;

export type StateEnum = typeof StateEnum[keyof typeof StateEnum];
export const StyleTypeEnum = {
  /** Fett */
  Bold: 'BOLD',
  /** Normal */
  Normal: 'NORMAL',
  /** Rot */
  Red: 'RED'
} as const;

export type StyleTypeEnum = typeof StyleTypeEnum[keyof typeof StyleTypeEnum];
/** Supportcenter */
export type Supportcenter = {
  __typename?: 'Supportcenter';
  answer?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Maybe<SupportcenterCategory>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  isHighlight?: Maybe<Scalars['Int']['output']>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  supportcenterId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Aktuelles Benutzer Feedback (session abhängig) */
  userFeedback?: Maybe<Supportcenterfeedback>;
};


/** Supportcenter */
export type SupportcenterAnswerArgs = {
  format?: InputMaybe<ContentFormatEnum>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
};


/** Supportcenter */
export type SupportcenterUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Supportcenter Kategorien */
export type SupportcenterCategory = {
  __typename?: 'SupportcenterCategory';
  id?: Maybe<Scalars['Int']['output']>;
  isHighlight?: Maybe<Scalars['Int']['output']>;
  lft?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  supportcenterCategoryId?: Maybe<Scalars['ID']['output']>;
  /** List aller verknüpfter Supportcenters */
  supportcenters?: Maybe<Array<Maybe<Supportcenter>>>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Supportcenter Kategorien */
export type SupportcenterCategoryMediasArgs = {
  targetAttr?: InputMaybe<Scalars['ID']['input']>;
};

/** Liste von Support Kategorien */
export type SupportcenterCategoryList = {
  __typename?: 'SupportcenterCategoryList';
  /** Kategoriebaum als JSON-String */
  categoryTree?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<SupportcenterCategory>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Input-Werte für Supportcenterfeedback */
export type SupportcenterFeedbackInputType = {
  email: Scalars['String']['input'];
  feedback: Scalars['Int']['input'];
  frontenduser_id?: InputMaybe<Scalars['Int']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Int']['input']>;
  supportcenter_id: Scalars['Int']['input'];
};

/** Supportcenter */
export type SupportcenterList = {
  __typename?: 'SupportcenterList';
  results?: Maybe<Array<Maybe<Supportcenter>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Supportcenterfeedback */
export type Supportcenterfeedback = {
  __typename?: 'Supportcenterfeedback';
  email?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  feedback?: Maybe<Scalars['Int']['output']>;
  frontenduserId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  modelErrors?: Maybe<Array<Maybe<AttributeError>>>;
  sessionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  supportcenterId?: Maybe<Scalars['Int']['output']>;
};

export const TargetTypeEnum = {
  /** Neues Fenster */
  Blank: '_BLANK',
  /** Frame eine ebene oberhalb vom aktuellen Frame */
  Parent: '_PARENT',
  /** Aktuelles Frame */
  Self: '_SELF',
  /** Oberstes Frame vom aktuellen Fenster */
  Top: '_TOP'
} as const;

export type TargetTypeEnum = typeof TargetTypeEnum[keyof typeof TargetTypeEnum];
/** Teams */
export type Team = {
  __typename?: 'Team';
  categories: Array<TeamCategory>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  medias: Array<Media>;
  phone?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Teams */
export type TeamDescriptionArgs = {
  format?: InputMaybe<ContentFormatEnum>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
};


/** Teams */
export type TeamMediasArgs = {
  targetAttr?: InputMaybe<Scalars['ID']['input']>;
};

/** Team Kategorie */
export type TeamCategory = {
  __typename?: 'TeamCategory';
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  teamCategoryId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  urlSlug?: Maybe<Scalars['String']['output']>;
};

/** Liste von Team Kategorien */
export type TeamCategoryList = {
  __typename?: 'TeamCategoryList';
  results: Array<TeamCategory>;
  totalCount: Scalars['Int']['output'];
};

/** Liste von Teams */
export type TeamList = {
  __typename?: 'TeamList';
  results: Array<Team>;
  teamSortOptions: Array<TeamSortOption>;
  totalCount: Scalars['Int']['output'];
};

export const TeamSortByEnum = {
  /** i18n.firstname ASC */
  FirstNameAsc: 'FIRST_NAME_ASC',
  /** i18n.firstname DESC */
  FirstNameDesc: 'FIRST_NAME_DESC',
  /** i18n.function ASC */
  FunctionAsc: 'FUNCTION_ASC',
  /** i18n.function DESC */
  FunctionDesc: 'FUNCTION_DESC',
  /** i18n.lastname ASC */
  LastNameAsc: 'LAST_NAME_ASC',
  /** i18n.lastname DESC */
  LastNameDesc: 'LAST_NAME_DESC',
  /** i18n.sort_order ASC */
  SortOrderAsc: 'SORT_ORDER_ASC',
  /** i18n.sort_order DESC */
  SortOrderDesc: 'SORT_ORDER_DESC'
} as const;

export type TeamSortByEnum = typeof TeamSortByEnum[keyof typeof TeamSortByEnum];
/** Sortierung Team */
export type TeamSortOption = {
  __typename?: 'TeamSortOption';
  enumValue?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export const TemplateTypeEnum = {
  /** Standard Navigation */
  DefaultNavigation: 'DEFAULT_NAVIGATION',
  /** Unterteilte Navigation */
  TabNavigation: 'TAB_NAVIGATION'
} as const;

export type TemplateTypeEnum = typeof TemplateTypeEnum[keyof typeof TemplateTypeEnum];
/** Themeworld */
export type Themeworld = {
  __typename?: 'Themeworld';
  /** Liste mit IDs verknüpfter Brands */
  brands: Array<Scalars['Int']['output']>;
  categories: Array<ThemeworldCategory>;
  description?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  isFilter?: Maybe<Scalars['Int']['output']>;
  light?: Maybe<Scalars['String']['output']>;
  medias: Array<Media>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  /** Liste mit IDs verknüpfter Produktlinien */
  productlines: Array<Scalars['Int']['output']>;
  /** Returns list of all products in themeworld */
  products: Array<ThemeworldProduct>;
  saison?: Maybe<Scalars['String']['output']>;
  /** Liste mit IDs verknüpfter Saisons */
  seasons: Array<Scalars['Int']['output']>;
  shopClientId?: Maybe<Scalars['Int']['output']>;
  showDetails?: Maybe<Scalars['Int']['output']>;
  showInB2b?: Maybe<Scalars['Int']['output']>;
  showroomEffect?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  themeworldId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Themeworld */
export type ThemeworldMediasArgs = {
  targetAttr?: InputMaybe<Scalars['ID']['input']>;
};


/** Themeworld */
export type ThemeworldProductsArgs = {
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Themeworld */
export type ThemeworldUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Themenwelt Kategorien */
export type ThemeworldCategory = {
  __typename?: 'ThemeworldCategory';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  medias: Array<Media>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  themeworldCategoryId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  urlSlug?: Maybe<Scalars['String']['output']>;
};


/** Themenwelt Kategorien */
export type ThemeworldCategoryMediasArgs = {
  targetAttr?: InputMaybe<Scalars['ID']['input']>;
};

/** Liste von Themenwelt Kategorien */
export type ThemeworldCategoryList = {
  __typename?: 'ThemeworldCategoryList';
  results: Array<ThemeworldCategory>;
  totalCount: Scalars['Int']['output'];
};

/** List of Themeworlds */
export type ThemeworldList = {
  __typename?: 'ThemeworldList';
  results: Array<Themeworld>;
  totalCount: Scalars['Int']['output'];
};

/** Themeworld Products */
export type ThemeworldProduct = {
  __typename?: 'ThemeworldProduct';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  isFavorite?: Maybe<Scalars['Int']['output']>;
  productData: Product;
  shopProductId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  themeworldId?: Maybe<Scalars['Int']['output']>;
};

export const ThemeworldSortByEnum = {
  /** i18n.sort_order ASC */
  SortOrderAsc: 'SORT_ORDER_ASC',
  /** i18n.sort_order DESC */
  SortOrderDesc: 'SORT_ORDER_DESC',
  /** i18n.themeworld_id ASC */
  ThemeworldIdAsc: 'THEMEWORLD_ID_ASC',
  /** i18n.themeworld_id DESC */
  ThemeworldIdDesc: 'THEMEWORLD_ID_DESC',
  /** i18n.title ASC */
  ThemeworldTitleAsc: 'THEMEWORLD_TITLE_ASC',
  /** i18n.title DESC */
  ThemeworldTitleDesc: 'THEMEWORLD_TITLE_DESC'
} as const;

export type ThemeworldSortByEnum = typeof ThemeworldSortByEnum[keyof typeof ThemeworldSortByEnum];
/** Website Locales */
export type WebsiteLocale = {
  __typename?: 'WebsiteLocale';
  /** Locale ID */
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  shortLabel?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  statusBackend?: Maybe<Scalars['Int']['output']>;
  statusFrontend?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Website Locales */
export type WebsiteLocaleUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Website-Sprachen */
export type WebsiteLocaleList = {
  __typename?: 'WebsiteLocaleList';
  results?: Maybe<Array<Maybe<WebsiteLocale>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Daten / Einstellungen Webseite */
export type WebsiteSettings = {
  __typename?: 'WebsiteSettings';
  contactEmail?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  linkBlog?: Maybe<Scalars['String']['output']>;
  linkFacebook?: Maybe<Scalars['String']['output']>;
  linkInstagram?: Maybe<Scalars['String']['output']>;
  linkLinkedin?: Maybe<Scalars['String']['output']>;
  linkTikTok?: Maybe<Scalars['String']['output']>;
  linkTwitter?: Maybe<Scalars['String']['output']>;
  linkXing?: Maybe<Scalars['String']['output']>;
  linkYoutube?: Maybe<Scalars['String']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  websiteDataId?: Maybe<Scalars['Int']['output']>;
};


/** Daten / Einstellungen Webseite */
export type WebsiteSettingsMediasArgs = {
  targetAttr?: InputMaybe<Scalars['ID']['input']>;
};


/** Daten / Einstellungen Webseite */
export type WebsiteSettingsUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Merkliste */
export type Wishlist = {
  __typename?: 'Wishlist';
  comment?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Kunde */
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  frontendUserName?: Maybe<Scalars['String']['output']>;
  frontenduserId?: Maybe<Scalars['Int']['output']>;
  /** Zusammenfassungen der Gruppen in der Merkliste / Submission */
  groupSummary: Array<WishlistGroupSummary>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Ausgeschlossene Merkliste */
  isExcluded?: Maybe<Scalars['Int']['output']>;
  /** Liste aller Positionen in Merkliste */
  positions: Array<WishlistPosition>;
  preOrder?: Maybe<Scalars['Int']['output']>;
  productCount?: Maybe<Scalars['Int']['output']>;
  releaseComment?: Maybe<Scalars['String']['output']>;
  salesAppUserId?: Maybe<Scalars['Int']['output']>;
  salesAppUserName?: Maybe<Scalars['String']['output']>;
  /** Verknüpfte Saison */
  season?: Maybe<Season>;
  seasonId?: Maybe<Scalars['Int']['output']>;
  shippingDate?: Maybe<Scalars['String']['output']>;
  /** Mandant */
  shopClient?: Maybe<Client>;
  shopClientId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  /** Zusammenfassung der Merkliste / Submission */
  summary: WishlistSummary;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Merkliste */
export type WishlistCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Merkliste */
export type WishlistShippingDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Merkliste */
export type WishlistUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Zusammenfassung einer Gruppe in der Merkliste / Submission */
export type WishlistGroupSummary = {
  __typename?: 'WishlistGroupSummary';
  /** Bezeichnung der Gruppe */
  groupIdent?: Maybe<Scalars['String']['output']>;
  /** Eindeutige Identifikation der Gruppe */
  groupIdentId?: Maybe<Scalars['String']['output']>;
  /** Anzahl Positionen in Merkliste / Submission */
  positionCount?: Maybe<Scalars['Int']['output']>;
  /** Anzahl Produkte (Grössen / Kind-Produkte) in Merkliste / Submission */
  productCount?: Maybe<Scalars['Int']['output']>;
  /** Gesamtmenge von Produkten (Grössen / Kind-Produkte) im Merkliste / Submission */
  productQty?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['String']['output']>;
  totalRrp?: Maybe<Scalars['String']['output']>;
};


/** Zusammenfassung einer Gruppe in der Merkliste / Submission */
export type WishlistGroupSummaryTotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Zusammenfassung einer Gruppe in der Merkliste / Submission */
export type WishlistGroupSummaryTotalRrpArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input-Werte für Merklisten */
export type WishlistInputType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  commerce_fashion_season_id?: InputMaybe<Scalars['Int']['input']>;
  commission?: InputMaybe<Scalars['String']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** ID der Merkliste (wenn leer / nicht übermittelt wird neue Merkliste erstellt) */
  id?: InputMaybe<Scalars['Int']['input']>;
  pre_order?: InputMaybe<Scalars['Int']['input']>;
  shipping_date?: InputMaybe<Scalars['String']['input']>;
  shop_client_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Liste von Merklisten */
export type WishlistList = {
  __typename?: 'WishlistList';
  results: Array<Wishlist>;
  totalCount: Scalars['Int']['output'];
};

/** Position Merkliste */
export type WishlistPosition = {
  __typename?: 'WishlistPosition';
  comment?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  deliveryDateLabel?: Maybe<Scalars['String']['output']>;
  deliveryDateWish?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  groupIdent?: Maybe<Scalars['String']['output']>;
  groupIdentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  priceTagRrp?: Maybe<Scalars['Float']['output']>;
  productData?: Maybe<Product>;
  productQty?: Maybe<Scalars['Int']['output']>;
  /** Liste verfügbarer Grössen */
  productSizes: Array<ProductSize>;
  /** Liste der Produkte einer Position in Merkliste */
  products?: Maybe<Array<Maybe<WishlistProduct>>>;
  shopProductIdParent?: Maybe<Scalars['Int']['output']>;
  subTotal?: Maybe<Scalars['String']['output']>;
  /** @deprecated Ursprungs-Feld ist als Preis-Feld implementiert und verfügt über Argument zur Formatierung */
  subTotalFormatted?: Maybe<Scalars['String']['output']>;
  subTotalRrp?: Maybe<Scalars['String']['output']>;
  wishlistId?: Maybe<Scalars['Int']['output']>;
};


/** Position Merkliste */
export type WishlistPositionSubTotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Position Merkliste */
export type WishlistPositionSubTotalRrpArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input-Werte für die Positionen einer Merkliste */
export type WishlistPositionInputType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  commission?: InputMaybe<Scalars['String']['input']>;
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  delivery_date_label?: InputMaybe<Scalars['String']['input']>;
  delivery_date_wish?: InputMaybe<Scalars['String']['input']>;
  group_ident?: InputMaybe<Scalars['String']['input']>;
  group_ident_id?: InputMaybe<Scalars['String']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  price_tag_rrp?: InputMaybe<Scalars['Float']['input']>;
  products?: InputMaybe<Array<InputMaybe<WishlistProductInputType>>>;
  shop_product_id_parent?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Produkt einer Merkliste */
export type WishlistProduct = {
  __typename?: 'WishlistProduct';
  deliveryDate?: Maybe<Scalars['String']['output']>;
  deliveryDateLabel?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  productData?: Maybe<Product>;
  quantity?: Maybe<Scalars['Int']['output']>;
  shopProductId?: Maybe<Scalars['Int']['output']>;
  subTotal?: Maybe<Scalars['String']['output']>;
  /** @deprecated Ursprungs-Feld ist als Preis-Feld implementiert und verfügt über Argument zur Formatierung */
  subTotalFormatted?: Maybe<Scalars['String']['output']>;
  subTotalRrp?: Maybe<Scalars['String']['output']>;
  wishlistId?: Maybe<Scalars['Int']['output']>;
  wishlistPositionId?: Maybe<Scalars['Int']['output']>;
};


/** Produkt einer Merkliste */
export type WishlistProductSubTotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Produkt einer Merkliste */
export type WishlistProductSubTotalRrpArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input-Werte für die Produkte einer Merkliste */
export type WishlistProductInputType = {
  delivery_date?: InputMaybe<Scalars['String']['input']>;
  delivery_date_label?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  shop_product_id: Scalars['Int']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** Zusammenfassung Merkliste / Submission */
export type WishlistSummary = {
  __typename?: 'WishlistSummary';
  /** Anzahl verschiedener Gruppen in Merkliste / Submission */
  groupCount?: Maybe<Scalars['Int']['output']>;
  /** Anzahl Positionen in Merkliste / Submission */
  positionCount?: Maybe<Scalars['Int']['output']>;
  /** Anzahl Produkte (Grössen / Kind-Produkte) in Merkliste / Submission */
  productCount?: Maybe<Scalars['Int']['output']>;
  /** Gesamtmenge von Produkten (Grössen / Kind-Produkte) im Merkliste / Submission */
  productQty?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['String']['output']>;
  totalRrp?: Maybe<Scalars['String']['output']>;
};


/** Zusammenfassung Merkliste / Submission */
export type WishlistSummaryTotalArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Zusammenfassung Merkliste / Submission */
export type WishlistSummaryTotalRrpArgs = {
  formatted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductListProductsQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
  selectedFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  sortBy?: InputMaybe<ProductSortByEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductListProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductList', totalCount: number, results: Array<{ __typename?: 'Product', id?: number | null, shopProductId?: number | null, title?: string | null, customSku?: string | null, stockStatus?: number | null, relatedProductsCount?: number | null, customData?: string | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, colorName?: string | null, smallThumb: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, largeThumb: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, relatedProducts: Array<{ __typename?: 'RelatedProduct', id?: number | null, productData?: { __typename?: 'Product', shopProductId?: number | null, colorName?: string | null, image: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> } | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> }> } };

export type CustomerAddressesQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
}>;


export type CustomerAddressesQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id?: number | null, name?: string | null, nameAddition?: string | null, customerNumber?: string | null, addresses?: Array<{ __typename?: 'CustomerAddress', id?: number | null, company?: string | null, companyAddition?: string | null, companyAddition2?: string | null, typeLabel?: string | null, street?: string | null, number?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, countryLabel?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null, email?: string | null } | null> | null, subCustomers?: Array<{ __typename?: 'Customer', id?: number | null, name?: string | null, nameAddition?: string | null, customerNumber?: string | null, addresses?: Array<{ __typename?: 'CustomerAddress', id?: number | null, company?: string | null, companyAddition?: string | null, companyAddition2?: string | null, typeLabel?: string | null, street?: string | null, number?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, countryLabel?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null, email?: string | null } | null> | null } | null> | null } | null };

export type ChangePasswordInAccountMutationVariables = Exact<{
  password: Scalars['String']['input'];
  passwordRepeat: Scalars['String']['input'];
}>;


export type ChangePasswordInAccountMutation = { __typename?: 'Mutation', changePassword?: { __typename?: 'Frontenduser', id?: number | null, errors?: Array<string | null> | null } | null };

export type OpenOrdersQueryVariables = Exact<{
  shopClientId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  loadSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  pendingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  includeSubCustomers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OpenOrdersQuery = { __typename?: 'Query', wishlists: { __typename?: 'WishlistList', totalCount: number, results: Array<{ __typename?: 'Wishlist', id?: number | null, title?: string | null, createdAt?: string | null, salesAppUserName?: string | null, status?: number | null, shopClient?: { __typename?: 'Client', id?: number | null, shopClientId?: number | null, title?: string | null, brandColor?: string | null, color?: string | null, medias: Array<{ __typename?: 'Media', targetAttr?: string | null, path?: string | null, filename?: string | null }> } | null, summary: { __typename?: 'WishlistSummary', positionCount?: number | null, productCount?: number | null, productQty?: number | null, groupCount?: number | null, total?: string | null, totalRrp?: string | null } }> } };

export type OrderHistoryDetailQueryVariables = Exact<{
  shopOrderId: Scalars['Int']['input'];
}>;


export type OrderHistoryDetailQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id?: number | null, shopClientId?: number | null, orderStatus?: string | null, updatedAt?: string | null, totalWithVat?: string | null, commission?: string | null, positions?: Array<{ __typename?: 'OrderPosition', id?: number | null, price?: string | null, priceRrp?: string | null, productQuantity?: number | null, quantityCanceled?: number | null, subTotal?: string | null, subTotalRrp?: string | null, deliveryDate?: string | null, isCanceled?: boolean | null, productData?: { __typename?: 'Product', title?: string | null, customSku?: string | null, colorName?: string | null, medias: Array<{ __typename?: 'Media', thumbnail?: string | null }> } | null } | null> | null } | null };

export type OrderHistoryDetailPositionQueryVariables = Exact<{
  orderPositionId: Scalars['Int']['input'];
}>;


export type OrderHistoryDetailPositionQuery = { __typename?: 'Query', orderPosition?: { __typename?: 'OrderPosition', id?: number | null, price?: string | null, priceRrp?: string | null, productQuantity?: number | null, quantityCanceled?: number | null, subTotal?: string | null, subTotalRrp?: string | null, deliveryDate?: string | null, isCanceled?: boolean | null, products?: Array<{ __typename?: 'OrderProduct', id?: number | null, quantity?: number | null, quantityCanceled?: number | null, isCanceled?: boolean | null, productData?: { __typename?: 'Product', size?: { __typename?: 'Size', title?: string | null } | null } | null } | null> | null, productData?: { __typename?: 'Product', title?: string | null, customSku?: string | null, colorName?: string | null, medias: Array<{ __typename?: 'Media', path?: string | null, thumbnail?: string | null }> } | null } | null };

export type OrderHistoryQueryVariables = Exact<{
  shopClientIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sortBy: OrderSortByEnum;
  includeSubCustomers: Scalars['Boolean']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  cutOffDateIso?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderHistoryQuery = { __typename?: 'Query', orders?: { __typename?: 'OrderList', totalCount?: number | null, results?: Array<{ __typename?: 'Order', id?: number | null, shopClientId?: number | null, orderStatus?: string | null, updatedAt?: string | null, totalWithVat?: string | null, commission?: string | null, positions?: Array<{ __typename?: 'OrderPosition', id?: number | null, productQuantity?: number | null, quantityCanceled?: number | null } | null> | null } | null> | null } | null };

export type CustomerUsersQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CustomerUsersQuery = { __typename?: 'Query', customerUsers: { __typename?: 'FrontenduserList', totalCount: number, results: Array<{ __typename?: 'Frontenduser', id?: number | null, username?: string | null, email?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null, position?: string | null, salutation?: string | null, salutationCode?: string | null, status?: number | null }> } };

export type CreateFrontenduserMutationVariables = Exact<{
  customerId: Scalars['Int']['input'];
  frontenduserData?: InputMaybe<FrontenduserInputType>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateFrontenduserMutation = { __typename?: 'Mutation', createFrontenduser?: { __typename?: 'Frontenduser', id?: number | null, username?: string | null, email?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null, position?: string | null, salutation?: string | null, salutationCode?: string | null, status?: number | null } | null };

export type DeleteFrontenduserMutationVariables = Exact<{
  frontenduserId: Scalars['Int']['input'];
}>;


export type DeleteFrontenduserMutation = { __typename?: 'Mutation', deleteFrontenduser?: { __typename?: 'Frontenduser', id?: number | null } | null };

export type UpdateFrontenduserMutationVariables = Exact<{
  frontenduserId: Scalars['Int']['input'];
  frontenduserData?: InputMaybe<FrontenduserInputType>;
}>;


export type UpdateFrontenduserMutation = { __typename?: 'Mutation', updateFrontenduser?: { __typename?: 'Frontenduser', id?: number | null, username?: string | null, email?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null, position?: string | null, salutation?: string | null, salutationCode?: string | null, status?: number | null } | null };

export type AccountWishlistsQueryVariables = Exact<{
  shopClientId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  loadSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AccountWishlistsQuery = { __typename?: 'Query', wishlists: { __typename?: 'WishlistList', totalCount: number, results: Array<{ __typename?: 'Wishlist', id?: number | null, title?: string | null, comment?: string | null, frontendUserName?: string | null, frontenduserId?: number | null, createdAt?: string | null, updatedAt?: string | null, summary: { __typename?: 'WishlistSummary', positionCount?: number | null, productQty?: number | null, total?: string | null }, shopClient?: { __typename?: 'Client', id?: number | null, shopClientId?: number | null, title?: string | null, brandColor?: string | null, color?: string | null, medias: Array<{ __typename?: 'Media', targetAttr?: string | null, path?: string | null, filename?: string | null }> } | null }> } };

export type BasketDetailQueryVariables = Exact<{
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BasketDetailQuery = { __typename?: 'Query', basket?: { __typename?: 'Basket', id?: number | null, positions?: Array<{ __typename?: 'BasketPosition', id?: number | null, shopProductIdParent?: number | null, productQty?: number | null, subTotal?: string | null, comment?: string | null, commission?: string | null, deliveryDate?: string | null, products?: Array<{ __typename?: 'BasketProduct', id?: number | null, shopProductId?: number | null, quantity?: number | null, subTotal?: string | null } | null> | null, productData?: { __typename?: 'Product', id?: number | null, shopProductId?: number | null, title?: string | null, customSku?: string | null, seasonIds: Array<number>, inStock?: boolean | null, quantityIncrement?: number | null, pageUrl?: string | null, customData?: string | null, relatedProductsCount?: number | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, colorName?: string | null, medias: Array<{ __typename?: 'Media', thumbnail?: string | null }>, productSizes: Array<{ __typename?: 'ProductSize', shopProductId?: number | null, sku?: string | null, sizeId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, sizeGridId?: number | null, sizeGridTitle?: string | null, sizeGridSortOrder?: number | null, stock?: number | null, stockStatus?: number | null }>, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null } | null } | null> | null, summary?: { __typename?: 'BasketSummary', currency?: string | null, positionCount?: number | null, productCount?: number | null, productQty?: number | null, subTotal?: string | null, subTotalRrp?: string | null, total?: string | null } | null } | null };

export type BasketCheckoutQueryVariables = Exact<{
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BasketCheckoutQuery = { __typename?: 'Query', basket?: { __typename?: 'Basket', id?: number | null, positions?: Array<{ __typename?: 'BasketPosition', id?: number | null, productQty?: number | null, subTotal?: string | null, productData?: { __typename?: 'Product', shopProductId?: number | null, title?: string | null, customSku?: string | null, pageUrl?: string | null, colorName?: string | null, image: Array<{ __typename?: 'Media', thumbnail?: string | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> } | null } | null> | null, summary?: { __typename?: 'BasketSummary', currency?: string | null, positionCount?: number | null, productCount?: number | null, productQty?: number | null, subTotal?: string | null, subTotalRrp?: string | null, total?: string | null } | null } | null };

export type RemoveBasketPositionMutationVariables = Exact<{
  basketPositionId?: InputMaybe<Scalars['Int']['input']>;
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RemoveBasketPositionMutation = { __typename?: 'Mutation', removeBasketPosition?: { __typename?: 'Basket', id?: number | null, errors?: Array<string | null> | null, positions?: Array<{ __typename?: 'BasketPosition', id?: number | null, shopProductIdParent?: number | null } | null> | null, summary?: { __typename?: 'BasketSummary', currency?: string | null, positionCount?: number | null, productCount?: number | null, productQty?: number | null, subTotal?: string | null, subTotalRrp?: string | null, total?: string | null } | null } | null };

export type UpdateBasketMutationVariables = Exact<{
  basketPositionData?: InputMaybe<BasketInputType>;
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateBasketMutation = { __typename?: 'Mutation', updateBasket?: { __typename?: 'Basket', id?: number | null, positions?: Array<{ __typename?: 'BasketPosition', id?: number | null, shopProductIdParent?: number | null, productQty?: number | null, subTotal?: string | null, products?: Array<{ __typename?: 'BasketProduct', shopProductId?: number | null, quantity?: number | null } | null> | null } | null> | null, summary?: { __typename?: 'BasketSummary', currency?: string | null, positionCount?: number | null, productCount?: number | null, productQty?: number | null, subTotal?: string | null, subTotalRrp?: string | null, total?: string | null } | null } | null };

export type UpdateBasketPositionMutationVariables = Exact<{
  basketPositionData?: InputMaybe<BasketInputType>;
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateBasketPositionMutation = { __typename?: 'Mutation', updateBasketPosition?: { __typename?: 'BasketPosition', id?: number | null, shopProductIdParent?: number | null, productQty?: number | null, subTotal?: string | null, subTotalRrp?: string | null, products?: Array<{ __typename?: 'BasketProduct', shopProductId?: number | null, quantity?: number | null } | null> | null, basketSummary?: { __typename?: 'BasketSummary', currency?: string | null, positionCount?: number | null, productCount?: number | null, productQty?: number | null, subTotal?: string | null, subTotalRrp?: string | null, total?: string | null } | null } | null };

export type BasketCountQueryVariables = Exact<{
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BasketCountQuery = { __typename?: 'Query', basket?: { __typename?: 'Basket', id?: number | null, positions?: Array<{ __typename?: 'BasketPosition', id?: number | null, shopProductIdParent?: number | null, productQty?: number | null } | null> | null, summary?: { __typename?: 'BasketSummary', productCount?: number | null, productQty?: number | null, positionCount?: number | null } | null } | null };

export type BlogCategoriesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;


export type BlogCategoriesQuery = { __typename?: 'Query', blogCategories: { __typename?: 'BlogCategoryList', totalCount: number, results?: Array<{ __typename?: 'BlogCategory', blogCategoryId?: number | null, id?: number | null, title?: string | null, description?: string | null, pageUrl?: string | null, subtitle?: string | null } | null> | null } };

export type BlogDetailPageQueryVariables = Exact<{
  blogId: Scalars['ID']['input'];
  thumbnailWidth: Scalars['Int']['input'];
}>;


export type BlogDetailPageQuery = { __typename?: 'Query', blog?: { __typename?: 'Blog', id?: number | null, blogId?: number | null, title?: string | null, teaser?: string | null, description?: string | null, date?: string | null, updatedAt?: string | null, pageUrl?: string | null, blogAuthor?: { __typename?: 'BlogAuthor', id?: number | null, fullName?: string | null } | null, categories?: Array<{ __typename?: 'BlogCategory', blogCategoryId?: number | null, title?: string | null } | null> | null, tags?: Array<{ __typename?: 'BlogTag', blogTagId?: number | null, title?: string | null } | null> | null, medias?: Array<{ __typename?: 'Media', sortOrder?: number | null, alt?: string | null, thumbnail?: string | null, mime?: string | null, width?: number | null, height?: number | null } | null> | null } | null };

export type BlogOverviewListQueryVariables = Exact<{
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<BlogSortByEnum>;
  thumbnailWidth: Scalars['Int']['input'];
}>;


export type BlogOverviewListQuery = { __typename?: 'Query', blogs?: { __typename?: 'BlogList', totalCount?: number | null, results?: Array<{ __typename?: 'Blog', id?: number | null, blogId?: number | null, title?: string | null, teaser?: string | null, date?: string | null, pageUrl?: string | null, sortOrder?: number | null, categories?: Array<{ __typename?: 'BlogCategory', blogCategoryId?: number | null, title?: string | null } | null> | null, medias?: Array<{ __typename?: 'Media', sortOrder?: number | null, alt?: string | null, thumbnail?: string | null, mime?: string | null } | null> | null } | null> | null } | null };

export type ShopClientsQueryVariables = Exact<{
  brandImageWidth: Scalars['Int']['input'];
  landingPageHeroImageWidth: Scalars['Int']['input'];
}>;


export type ShopClientsQuery = { __typename?: 'Query', clients?: { __typename?: 'ClientList', totalCount: number, results: Array<{ __typename?: 'Client', id?: number | null, shopClientId?: number | null, title?: string | null, brandColor?: string | null, status?: number | null, sortOrder?: number | null, fallbackColor?: string | null, logoHeader: Array<{ __typename?: 'Media', path?: string | null, alt?: string | null }>, logoFooter: Array<{ __typename?: 'Media', path?: string | null, alt?: string | null }>, brandImage: Array<{ __typename?: 'Media', thumbnail?: string | null, alt?: string | null }>, brandLogo: Array<{ __typename?: 'Media', path?: string | null, alt?: string | null }>, landingpagePreOrderHeroImages: Array<{ __typename?: 'Media', alt?: string | null, label?: string | null, link?: string | null, linkTitle?: string | null, sortOrder?: number | null, thumbnail?: string | null }>, landingpagePreOrderHeroImagesMobile: Array<{ __typename?: 'Media', alt?: string | null, label?: string | null, link?: string | null, linkTitle?: string | null, sortOrder?: number | null, thumbnail?: string | null }>, landingpageReOrderHeroImages: Array<{ __typename?: 'Media', alt?: string | null, label?: string | null, link?: string | null, linkTitle?: string | null, sortOrder?: number | null, thumbnail?: string | null }>, landingpageReOrderHeroImagesMobile: Array<{ __typename?: 'Media', alt?: string | null, label?: string | null, link?: string | null, linkTitle?: string | null, sortOrder?: number | null, thumbnail?: string | null }> }> } | null };

export type ThemeworldByIdQueryVariables = Exact<{
  themeworldId: Scalars['Int']['input'];
  thumbnailWidth: Scalars['Int']['input'];
}>;


export type ThemeworldByIdQuery = { __typename?: 'Query', themeworld: { __typename?: 'Themeworld', id?: number | null, themeworldId?: number | null, shopClientId?: number | null, seasons: Array<number>, productlines: Array<number>, title?: string | null, subtitle?: string | null, description?: string | null, status?: number | null, categories: Array<{ __typename?: 'ThemeworldCategory', id?: number | null, themeworldCategoryId?: number | null }>, products: Array<{ __typename?: 'ThemeworldProduct', id?: number | null, shopProductId?: number | null }>, images: Array<{ __typename?: 'Media', id?: number | null, targetAttr?: string | null, thumbnail?: string | null, width?: number | null, height?: number | null }> } };

export type ThemeworldKeyPiecesQueryVariables = Exact<{
  themeworldId: Scalars['Int']['input'];
}>;


export type ThemeworldKeyPiecesQuery = { __typename?: 'Query', themeworld: { __typename?: 'Themeworld', id?: number | null, themeworldId?: number | null, keyPieces: Array<{ __typename?: 'ThemeworldProduct', id?: number | null, shopProductId?: number | null, sortOrder?: number | null, productData: { __typename?: 'Product', id?: number | null, shopProductId?: number | null, title?: string | null, image: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> } }> } };

export type ThemeworldsByCategoryQueryVariables = Exact<{
  shopClientIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  seasonIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  productLineIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  sortBy?: InputMaybe<ThemeworldSortByEnum>;
  thumbnailWidth: Scalars['Int']['input'];
}>;


export type ThemeworldsByCategoryQuery = { __typename?: 'Query', themeworlds: { __typename?: 'ThemeworldList', totalCount: number, results: Array<{ __typename?: 'Themeworld', id?: number | null, themeworldId?: number | null, title?: string | null, status?: number | null, overviewImage: Array<{ __typename?: 'Media', thumbnail?: string | null }>, mainImage: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }> }> } };

export type ThemeworldCategoriesQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
  seasonIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  productLineIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  themeworldSortBy: ThemeworldSortByEnum;
}>;


export type ThemeworldCategoriesQuery = { __typename?: 'Query', themeworldCategories: { __typename?: 'ThemeworldCategoryList', totalCount: number, results: Array<{ __typename?: 'ThemeworldCategory', id?: number | null, themeworldCategoryId?: number | null, sortOrder?: number | null, title?: string | null, description?: string | null, urlSlug?: string | null, status?: number | null, image: Array<{ __typename?: 'Media', id?: number | null, targetAttr?: string | null, thumbnail?: string | null }> }> }, themeworlds: { __typename?: 'ThemeworldList', totalCount: number, results: Array<{ __typename?: 'Themeworld', id?: number | null, themeworldId?: number | null, sortOrder?: number | null, title?: string | null, description?: string | null, status?: number | null, categories: Array<{ __typename?: 'ThemeworldCategory', id?: number | null, themeworldCategoryId?: number | null }>, products: Array<{ __typename?: 'ThemeworldProduct', id?: number | null, shopProductId?: number | null }>, categoryFallbackImage: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null, alt?: string | null, sortOrder?: number | null }>, overviewImage: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null, alt?: string | null, sortOrder?: number | null }>, productImage: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null, alt?: string | null, sortOrder?: number | null }>, leftImage: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null, alt?: string | null, sortOrder?: number | null }>, mainImage: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null, alt?: string | null, sortOrder?: number | null }>, rightImage: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null, alt?: string | null, sortOrder?: number | null }> }> } };

export type CartAllocationPositionProductDataFragment = { __typename?: 'Product', shopProductId?: number | null, title?: string | null, sku?: string | null, customSku?: string | null, customData?: string | null, stockStatus?: number | null, seasonIds: Array<number>, id?: number | null, colorName?: string | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, mainImage: Array<{ __typename?: 'Media', thumbnail?: string | null }>, productSizes: Array<{ __typename?: 'ProductSize', shopProductId?: number | null, sku?: string | null, sizeId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, sizeGridId?: number | null, sizeGridTitle?: string | null, sizeGridSortOrder?: number | null, stock?: number | null, stockStatus?: number | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> };

export type CartAllocationWishlistsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  loadSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  pendingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  seasonIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  shopClientId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type CartAllocationWishlistsQuery = { __typename?: 'Query', wishlists: { __typename?: 'WishlistList', totalCount: number, results: Array<{ __typename?: 'Wishlist', id?: number | null, title?: string | null, productCount?: number | null, positions: Array<{ __typename?: 'WishlistPosition', id?: number | null, wishlistId?: number | null, shopProductIdParent?: number | null, groupIdent?: string | null, groupIdentId?: string | null, products?: Array<{ __typename?: 'WishlistProduct', shopProductId?: number | null, quantity?: number | null } | null> | null }> }> } };

export type CartAllocationGetProductQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type CartAllocationGetProductQuery = { __typename?: 'Query', product: { __typename?: 'Product', seasonIds: Array<number>, relatedProductsCount?: number | null, shopProductId?: number | null, title?: string | null, sku?: string | null, customSku?: string | null, customData?: string | null, stockStatus?: number | null, id?: number | null, colorName?: string | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, themeworlds: Array<{ __typename?: 'Themeworld', themeworldId?: number | null }>, looks: Array<{ __typename?: 'Looks', looksId?: number | null }>, mainImage: Array<{ __typename?: 'Media', thumbnail?: string | null }>, featureValues: Array<{ __typename?: 'DropdownList', label?: string | null, value?: string | null }>, productSizes: Array<{ __typename?: 'ProductSize', shopProductId?: number | null, sku?: string | null, sizeId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, sizeGridId?: number | null, sizeGridTitle?: string | null, sizeGridSortOrder?: number | null, stock?: number | null, stockStatus?: number | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> } };

export type CartAllocationProductsByFilterQueryVariables = Exact<{
  selectedFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  preOrder?: InputMaybe<Scalars['Boolean']['input']>;
  shopClientIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type CartAllocationProductsByFilterQuery = { __typename?: 'Query', products: { __typename?: 'ProductList', totalCount: number, results: Array<{ __typename?: 'Product', shopProductId?: number | null, title?: string | null, sku?: string | null, customSku?: string | null, customData?: string | null, stockStatus?: number | null, seasonIds: Array<number>, id?: number | null, colorName?: string | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, mainImage: Array<{ __typename?: 'Media', thumbnail?: string | null }>, productSizes: Array<{ __typename?: 'ProductSize', shopProductId?: number | null, sku?: string | null, sizeId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, sizeGridId?: number | null, sizeGridTitle?: string | null, sizeGridSortOrder?: number | null, stock?: number | null, stockStatus?: number | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> }> } };

export type CartAllocationRelatedProductsQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type CartAllocationRelatedProductsQuery = { __typename?: 'Query', product: { __typename?: 'Product', seasonIds: Array<number>, relatedProducts: Array<{ __typename?: 'RelatedProduct', shopProductId?: number | null, productData?: { __typename?: 'Product', shopProductId?: number | null, title?: string | null, sku?: string | null, customSku?: string | null, customData?: string | null, stockStatus?: number | null, seasonIds: Array<number>, id?: number | null, colorName?: string | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, mainImage: Array<{ __typename?: 'Media', thumbnail?: string | null }>, productSizes: Array<{ __typename?: 'ProductSize', shopProductId?: number | null, sku?: string | null, sizeId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, sizeGridId?: number | null, sizeGridTitle?: string | null, sizeGridSortOrder?: number | null, stock?: number | null, stockStatus?: number | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> } | null }> } };

export type ProductPricesQueryVariables = Exact<{
  priceData: Array<InputMaybe<ProductPriceInputType>> | InputMaybe<ProductPriceInputType>;
}>;


export type ProductPricesQuery = { __typename?: 'Query', productPrices?: { __typename?: 'ProductPriceList', total?: string | null, totalRrp?: string | null, results?: Array<{ __typename?: 'ProductPrice', quantity?: number | null, shopProductId?: number | null } | null> | null } | null };

export type CatalogSettingsQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
  seasonId?: InputMaybe<Scalars['Int']['input']>;
  productLineId?: InputMaybe<Scalars['Int']['input']>;
  orderType?: InputMaybe<OrderTypeEnum>;
}>;


export type CatalogSettingsQuery = { __typename?: 'Query', catalogSettings: { __typename?: 'CatalogSettings', categoryTree?: string | null, sorting: Array<{ __typename?: 'CatalogSorting', id?: number | null, attribute?: string | null, label?: string | null, sortOrder?: number | null, sortOption?: number | null, isDefault?: number | null }>, defaultTopFilters: Array<{ __typename?: 'CatalogFilter', id?: string | null, ident?: string | null, label?: string | null, type?: string | null }>, defaultFilters: Array<{ __typename?: 'CatalogFilter', id?: string | null, ident?: string | null, label?: string | null, type?: string | null }> } };

export type CatalogProductsQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
  preOrder: Scalars['Boolean']['input'];
  afterOrder: Scalars['Boolean']['input'];
  categoryIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  displayFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  searchQuery: Scalars['String']['input'];
  selectedFilters: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  priceRange?: InputMaybe<Scalars['String']['input']>;
  priceRangeRrp?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sortBy: ProductSortByEnum;
  mainColorsOnly: Scalars['Boolean']['input'];
}>;


export type CatalogProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductList', totalCount: number, searchResultCategoryIds: Array<number>, results: Array<{ __typename?: 'Product', id?: number | null, shopProductId?: number | null, title?: string | null, customSku?: string | null, stockStatus?: number | null, childrenCount?: number | null, relatedProductsCount?: number | null, customData?: string | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, colorName?: string | null, smallThumb: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, largeThumb: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, relatedProducts: Array<{ __typename?: 'RelatedProduct', id?: number | null, productData?: { __typename?: 'Product', shopProductId?: number | null, colorName?: string | null, image: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> } | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> }>, filters: Array<{ __typename?: 'ProductFilter', id?: string | null, ident?: string | null, label?: string | null, type?: string | null, additionalDisplayOption?: string | null, displayOnTop?: boolean | null, sortOrder?: number | null, minValue?: number | null, maxValue?: number | null, hasHits?: boolean | null, options?: Array<{ __typename?: 'ProductFilterValue', id?: string | null, label?: string | null, ident?: string | null, count?: number | null, hasHits?: boolean | null, additionalValues?: string | null } | null> | null }> } };

export type SearchResultCategoryIdsQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
  preOrder: Scalars['Boolean']['input'];
  afterOrder: Scalars['Boolean']['input'];
  selectedFilters: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  searchQuery: Scalars['String']['input'];
}>;


export type SearchResultCategoryIdsQuery = { __typename?: 'Query', products: { __typename?: 'ProductList', totalCount: number, searchResultCategoryIds: Array<number>, results: Array<{ __typename?: 'Product', id?: number | null, shopProductId?: number | null }> } };

export type CheckoutDeliveryAddressesQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
}>;


export type CheckoutDeliveryAddressesQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id?: number | null, customerNumber?: string | null, addresses?: Array<{ __typename?: 'CustomerAddress', id?: number | null, firstname?: string | null, lastname?: string | null, street?: string | null, zipCode?: string | null, city?: string | null, countryLabel?: string | null, company?: string | null } | null> | null, subCustomers?: Array<{ __typename?: 'Customer', id?: number | null, customerNumber?: string | null, name?: string | null, addresses?: Array<{ __typename?: 'CustomerAddress', id?: number | null, firstname?: string | null, lastname?: string | null, street?: string | null, zipCode?: string | null, city?: string | null, countryLabel?: string | null, company?: string | null } | null> | null } | null> | null } | null };

export type SubmitBasketMutationVariables = Exact<{
  deliveryOrderAddress: OrderAddressInputType;
  invoiceOrderAddress: OrderAddressInputType;
  orderData: OrderInputType;
  orderAsSubCustomer?: InputMaybe<Scalars['Int']['input']>;
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SubmitBasketMutation = { __typename?: 'Mutation', submitBasket?: Array<{ __typename?: 'Order', id?: number | null, commission?: string | null, customerName?: string | null, customerNumber?: string | null, errors?: Array<string | null> | null } | null> | null };

export type CheckoutWishlistQueryVariables = Exact<{
  wishlistId: Scalars['Int']['input'];
  loadSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubCustomers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CheckoutWishlistQuery = { __typename?: 'Query', wishlist: { __typename?: 'Wishlist', id?: number | null, title?: string | null, customerName?: string | null, salesAppUserName?: string | null, productCount?: number | null, createdAt?: string | null, comment?: string | null, releaseComment?: string | null, commission?: string | null, status?: number | null, positions: Array<{ __typename?: 'WishlistPosition', id?: number | null, shopProductIdParent?: number | null, groupIdent?: string | null, groupIdentId?: string | null, productQty?: number | null, subTotal?: string | null, subTotalRrp?: string | null, wishlistId?: number | null, productData?: { __typename?: 'Product', id?: number | null, title?: string | null, customSku?: string | null, shopProductId?: number | null, colorName?: string | null, image: Array<{ __typename?: 'Media', thumbnail?: string | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> } | null }>, groupSummary: Array<{ __typename?: 'WishlistGroupSummary', groupIdent?: string | null, groupIdentId?: string | null, positionCount?: number | null, productCount?: number | null, productQty?: number | null, total?: string | null, totalRrp?: string | null }>, summary: { __typename?: 'WishlistSummary', positionCount?: number | null, productCount?: number | null, productQty?: number | null, groupCount?: number | null, total?: string | null, totalRrp?: string | null } } };

export type ApproveWishlistMutationVariables = Exact<{
  wishlistId: Scalars['Int']['input'];
  commission?: InputMaybe<Scalars['String']['input']>;
  releaseComment?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApproveWishlistMutation = { __typename?: 'Mutation', approveWishlist?: { __typename?: 'Wishlist', errors?: Array<string | null> | null } | null };

export type FormsByIdentsQueryVariables = Exact<{
  idents: Array<FormGeneratorIdentEnum> | FormGeneratorIdentEnum;
}>;


export type FormsByIdentsQuery = { __typename?: 'Query', forms: { __typename?: 'FormGeneratorList', results: Array<{ __typename?: 'FormGenerator', id?: number | null, webFormId?: number | null, ident?: string | null, title?: string | null, formData?: string | null }> } };

export type LookQueryVariables = Exact<{
  looksId: Scalars['Int']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LookQuery = { __typename?: 'Query', look: { __typename?: 'Looks', id?: number | null, looksId?: number | null, shopClientId?: number | null, title?: string | null, subtitle?: string | null, customTitle?: string | null, status?: number | null, saison?: string | null, description?: string | null, sortOrder?: number | null, seasons: Array<number>, products: Array<{ __typename?: 'LooksProduct', shopProductId?: number | null, isFavorite?: number | null, productData: { __typename?: 'Product', title?: string | null, customSku?: string | null, priceFormatted?: string | null, rrpFormatted?: string | null, relatedProductsCount?: number | null, color?: { __typename?: 'Color', title?: string | null, hexCode?: string | null, number?: string | null } | null, medias: Array<{ __typename?: 'Media', thumbnail?: string | null, alt?: string | null, targetAttr?: string | null, sortOrder?: number | null, mime?: string | null }> } }>, medias: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, thumbnail?: string | null, mime?: string | null, alt?: string | null }> } };

export type ThemeworlsQueryVariables = Exact<{
  themeworldId: Scalars['Int']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ThemeworlsQuery = { __typename?: 'Query', themeworld: { __typename?: 'Themeworld', id?: number | null, themeworldId?: number | null, title?: string | null, subtitle?: string | null, status?: number | null, description?: string | null, sortOrder?: number | null, seasons: Array<number>, medias: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, thumbnail?: string | null, mime?: string | null, alt?: string | null }> } };

export type ThemeworldsByProductQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type ThemeworldsByProductQuery = { __typename?: 'Query', product: { __typename?: 'Product', themeworlds: Array<{ __typename?: 'Themeworld', themeworldId?: number | null }> } };

export type WishlistsCountQueryVariables = Exact<{
  loadSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  pendingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  seasonIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  shopClientId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type WishlistsCountQuery = { __typename?: 'Query', wishlists: { __typename?: 'WishlistList', totalCount: number } };

export type HeaderSearchProductsQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  searchQuery: Scalars['String']['input'];
  sortBy: ProductSortByEnum;
  preOrder: Scalars['Boolean']['input'];
  afterOrder: Scalars['Boolean']['input'];
}>;


export type HeaderSearchProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductList', totalCount: number, results: Array<{ __typename?: 'Product', id?: number | null, shopProductId?: number | null, title?: string | null, customSku?: string | null, stockStatus?: number | null, customData?: string | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, colorName?: string | null, smallThumb: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, largeThumb: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> }> } };

export type HeaderSearchProductsByIdsQueryVariables = Exact<{
  shopProductIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  shopClientId: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type HeaderSearchProductsByIdsQuery = { __typename?: 'Query', products: { __typename?: 'ProductList', totalCount: number, results: Array<{ __typename?: 'Product', id?: number | null, shopProductId?: number | null, title?: string | null, customSku?: string | null, stockStatus?: number | null, customData?: string | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, colorName?: string | null, smallThumb: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, largeThumb: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> }> } };

export type LandingPageLookCategoriesQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
  sortBy: LooksSortByEnum;
  thumbnailWidth: Scalars['Int']['input'];
}>;


export type LandingPageLookCategoriesQuery = { __typename?: 'Query', looksCategories: { __typename?: 'LooksCategoryList', results: Array<{ __typename?: 'LooksCategory', id?: number | null, looksCategoryId?: number | null, sortOrder?: number | null, status?: number | null }> }, looks: { __typename?: 'LooksList', results: Array<{ __typename?: 'Looks', id?: number | null, looksId?: number | null, title?: string | null, customTitle?: string | null, status?: number | null, categories: Array<{ __typename?: 'LooksCategory', id?: number | null, looksCategoryId?: number | null }>, overviewImage: Array<{ __typename?: 'Media', thumbnail?: string | null }> }> } };

export type LandingPageThemeworldCategoriesQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
  sortBy: ThemeworldSortByEnum;
  thumbnailWidth: Scalars['Int']['input'];
}>;


export type LandingPageThemeworldCategoriesQuery = { __typename?: 'Query', themeworldCategories: { __typename?: 'ThemeworldCategoryList', results: Array<{ __typename?: 'ThemeworldCategory', id?: number | null, themeworldCategoryId?: number | null, sortOrder?: number | null, status?: number | null }> }, themeworlds: { __typename?: 'ThemeworldList', results: Array<{ __typename?: 'Themeworld', id?: number | null, themeworldId?: number | null, title?: string | null, status?: number | null, categories: Array<{ __typename?: 'ThemeworldCategory', id?: number | null, themeworldCategoryId?: number | null }>, overviewImage: Array<{ __typename?: 'Media', thumbnail?: string | null }>, mainImage: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }> }> } };

export type LookDetailPageQueryVariables = Exact<{
  lookId: Scalars['Int']['input'];
  galleryThumbnailWidth: Scalars['Int']['input'];
  productThumbSmallWidth: Scalars['Int']['input'];
  productThumbLargeWidth: Scalars['Int']['input'];
}>;


export type LookDetailPageQuery = { __typename?: 'Query', look: { __typename?: 'Looks', id?: number | null, looksId?: number | null, shopClientId?: number | null, title?: string | null, subtitle?: string | null, customTitle?: string | null, status?: number | null, saison?: string | null, description?: string | null, sortOrder?: number | null, headerProducts: Array<{ __typename?: 'LooksProduct', id?: number | null, shopProductId?: number | null, productData: { __typename?: 'Product', title?: string | null, customSku?: string | null, stockStatus?: number | null, priceFormatted?: string | null, rrpFormatted?: string | null, originalPriceFormatted?: string | null, colorName?: string | null, relatedProductsCount?: number | null, color?: { __typename?: 'Color', number?: string | null, hexCode?: string | null } | null, smallThumb: Array<{ __typename?: 'Media', thumbnail?: string | null }>, largeThumb: Array<{ __typename?: 'Media', thumbnail?: string | null }>, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> } }>, medias: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, thumbnail?: string | null, width?: number | null, height?: number | null, mime?: string | null, alt?: string | null }>, categories: Array<{ __typename?: 'LooksCategory', id?: number | null, looksCategoryId?: number | null }> } };

export type LookDetailRelatedLooksQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
  categoryIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  thumbnailWidth: Scalars['Int']['input'];
}>;


export type LookDetailRelatedLooksQuery = { __typename?: 'Query', looks: { __typename?: 'LooksList', totalCount: number, results: Array<{ __typename?: 'Looks', id?: number | null, looksId?: number | null, title?: string | null, customTitle?: string | null, sortOrder?: number | null, overviewImage: Array<{ __typename?: 'Media', targetAttr?: string | null, thumbnail?: string | null }> }> } };

export type LookCategoriesQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
  seasonIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  productLineIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  categoryThumbnailWidth: Scalars['Int']['input'];
  overviewThumbnailWidth: Scalars['Int']['input'];
  productThumbnailWidth: Scalars['Int']['input'];
}>;


export type LookCategoriesQuery = { __typename?: 'Query', looksCategories: { __typename?: 'LooksCategoryList', results: Array<{ __typename?: 'LooksCategory', id?: number | null, looksCategoryId?: number | null, title?: string | null, description?: string | null, sortOrder?: number | null, status?: number | null, urlSlug?: string | null, image: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, thumbnail?: string | null, mime?: string | null, alt?: string | null }> }> }, looks: { __typename?: 'LooksList', totalCount: number, results: Array<{ __typename?: 'Looks', id?: number | null, looksId?: number | null, status?: number | null, title?: string | null, subtitle?: string | null, customTitle?: string | null, sortOrder?: number | null, categories: Array<{ __typename?: 'LooksCategory', id?: number | null, title?: string | null, looksCategoryId?: number | null }>, categoryFallbackImage: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, thumbnail?: string | null, mime?: string | null, alt?: string | null }>, overviewImage: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, thumbnail?: string | null, mime?: string | null, alt?: string | null }>, products: Array<{ __typename?: 'LooksProduct', productData: { __typename?: 'Product', shopProductId?: number | null, title?: string | null, image: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, thumbnail?: string | null, mime?: string | null, alt?: string | null }>, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> } }> }> } };

export type DownloadsQueryVariables = Exact<{
  shopClientIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  limit: Scalars['Int']['input'];
  thumbnailWidth: Scalars['Int']['input'];
}>;


export type DownloadsQuery = { __typename?: 'Query', downloads?: { __typename?: 'DownloadList', totalCount?: number | null, downloadTree?: string | null, results?: Array<{ __typename?: 'Download', id?: number | null, downloadId?: number | null, title?: string | null, status?: number | null, parentId?: string | null, categoryIds?: Array<number | null> | null, updatedAt?: string | null, medias?: Array<{ __typename?: 'Media', id?: number | null, filename?: string | null, mime?: string | null, size?: number | null, thumbnail?: string | null, updatedAt?: string | null, path?: string | null, alt?: string | null, token?: string | null } | null> | null } | null> | null } | null };

export type FooterNavigationQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
}>;


export type FooterNavigationQuery = { __typename?: 'Query', footerNavigation: { __typename?: 'NavigationConfiguration', errors?: Array<string | null> | null, navigation?: Array<{ __typename?: 'Navigation', label?: string | null, path?: string | null, children?: Array<{ __typename?: 'Navigation', label?: string | null, path?: string | null } | null> | null } | null> | null } };

export type HeaderNavigationQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
  bannerWidth?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HeaderNavigationQuery = { __typename?: 'Query', headerNavigation: { __typename?: 'NavigationConfiguration', template?: TemplateTypeEnum | null, errors?: Array<string | null> | null, navigation?: Array<{ __typename?: 'Navigation', label?: string | null, target?: TargetTypeEnum | null, path?: string | null, menu?: { __typename?: 'Menu', type?: ListTypeEnum | null, columns?: number | null } | null, banner?: Array<{ __typename?: 'Banner', label?: string | null, path?: string | null, image?: string | null } | null> | null, children?: Array<{ __typename?: 'Navigation', label?: string | null, target?: TargetTypeEnum | null, path?: string | null, style?: StyleTypeEnum | null, menu?: { __typename?: 'Menu', type?: ListTypeEnum | null, columns?: number | null } | null, children?: Array<{ __typename?: 'Navigation', label?: string | null, path?: string | null, target?: TargetTypeEnum | null, style?: StyleTypeEnum | null } | null> | null } | null> | null } | null> | null } };

export type FetchProductThemeworldsAndLooksQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
  largeImageWidth: Scalars['Int']['input'];
  thumbWidth: Scalars['Int']['input'];
}>;


export type FetchProductThemeworldsAndLooksQuery = { __typename?: 'Query', product: { __typename?: 'Product', themeworlds: Array<{ __typename?: 'Themeworld', id?: number | null, themeworldId?: number | null, title?: string | null, description?: string | null, status?: number | null, medias: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, thumbnail?: string | null, alt?: string | null, mime?: string | null }>, products: Array<{ __typename?: 'ThemeworldProduct', id?: number | null, shopProductId?: number | null, productData: { __typename?: 'Product', medias: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, mime?: string | null, alt?: string | null, thumbnail?: string | null }>, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> } }> }>, looks: Array<{ __typename?: 'Looks', id?: number | null, looksId?: number | null, title?: string | null, customTitle?: string | null, status?: number | null, sortOrder?: number | null, productImage: Array<{ __typename?: 'Media', thumbnail?: string | null }>, overviewImage: Array<{ __typename?: 'Media', thumbnail?: string | null }>, video: Array<{ __typename?: 'Media', path?: string | null }>, products: Array<{ __typename?: 'LooksProduct', id?: number | null, shopProductId?: number | null, productData: { __typename?: 'Product', title?: string | null, medias: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, mime?: string | null, alt?: string | null, thumbnail?: string | null }>, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> } }> }> } };

export type ProductsByFeatureQueryVariables = Exact<{
  shopClientIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  selectedFilters: Array<Scalars['String']['input']> | Scalars['String']['input'];
  sortBy?: InputMaybe<ProductSortByEnum>;
}>;


export type ProductsByFeatureQuery = { __typename?: 'Query', products: { __typename?: 'ProductList', totalCount: number, results: Array<{ __typename?: 'Product', id?: number | null, shopProductId?: number | null, title?: string | null, customSku?: string | null, stockStatus?: number | null, relatedProductsCount?: number | null, customData?: string | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, colorName?: string | null, smallThumb: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, largeThumb: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, relatedProducts: Array<{ __typename?: 'RelatedProduct', id?: number | null, productData?: { __typename?: 'Product', shopProductId?: number | null, colorName?: string | null, image: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> } | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> }> } };

export type ProductsByIdsQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
  shopProductIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  selectedFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  sortBy?: InputMaybe<ProductSortByEnum>;
}>;


export type ProductsByIdsQuery = { __typename?: 'Query', products: { __typename?: 'ProductList', totalCount: number, results: Array<{ __typename?: 'Product', id?: number | null, shopProductId?: number | null, title?: string | null, customSku?: string | null, stockStatus?: number | null, customData?: string | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, colorName?: string | null, smallThumb: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, largeThumb: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> }> } };

export type CountProductsByFeaturesQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
  selectedFilters: Array<Scalars['String']['input']> | Scalars['String']['input'];
  sortBy?: InputMaybe<ProductSortByEnum>;
}>;


export type CountProductsByFeaturesQuery = { __typename?: 'Query', products: { __typename?: 'ProductList', totalCount: number, results: Array<{ __typename?: 'Product', shopProductId?: number | null }> } };

export type CountProductsFromLooksQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type CountProductsFromLooksQuery = { __typename?: 'Query', product: { __typename?: 'Product', looks: Array<{ __typename?: 'Looks', looksId?: number | null, products: Array<{ __typename?: 'LooksProduct', shopProductId?: number | null, productData: { __typename?: 'Product', seasonIds: Array<number> } }> }> } };

export type CountProductsFromThemeworldsQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type CountProductsFromThemeworldsQuery = { __typename?: 'Query', product: { __typename?: 'Product', themeworlds: Array<{ __typename?: 'Themeworld', themeworldId?: number | null, products: Array<{ __typename?: 'ThemeworldProduct', shopProductId?: number | null, productData: { __typename?: 'Product', seasonIds: Array<number> } }> }> } };

export type ProductSizesQueryVariables = Exact<{
  shopProductId: Scalars['Int']['input'];
}>;


export type ProductSizesQuery = { __typename?: 'Query', product: { __typename?: 'Product', id?: number | null, shopProductId?: number | null, productSizes: Array<{ __typename?: 'ProductSize', shopProductId?: number | null, sku?: string | null, sizeId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, sizeGridId?: number | null, sizeGridTitle?: string | null, sizeGridSortOrder?: number | null, stock?: number | null, stockStatus?: number | null }> } };

export type ProductsSizesForIdsQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
  shopProductIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ProductsSizesForIdsQuery = { __typename?: 'Query', products: { __typename?: 'ProductList', totalCount: number, results: Array<{ __typename?: 'Product', id?: number | null, shopProductId?: number | null, productSizes: Array<{ __typename?: 'ProductSize', shopProductId?: number | null, sku?: string | null, sizeId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, sizeGridId?: number | null, sizeGridTitle?: string | null, sizeGridSortOrder?: number | null, stock?: number | null, stockStatus?: number | null }> }> } };

export type SeasonsQueryVariables = Exact<{
  thumbnailWidth: Scalars['Int']['input'];
}>;


export type SeasonsQuery = { __typename?: 'Query', seasons: { __typename?: 'SeasonList', totalCount: number, results: Array<{ __typename?: 'Season', id?: number | null, seasonId?: number | null, ident?: string | null, title?: string | null, description?: string | null, sortOrder?: number | null, status?: number | null, thumbnail: Array<{ __typename?: 'Media', thumbnail?: string | null }> }> } };

export type TeamCategoryListQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
}>;


export type TeamCategoryListQuery = { __typename?: 'Query', teamCategories: { __typename?: 'TeamCategoryList', totalCount: number, results: Array<{ __typename?: 'TeamCategory', id?: number | null, teamCategoryId?: number | null, title?: string | null, status?: number | null, urlSlug?: string | null }> } };

export type TeamsQueryVariables = Exact<{
  shopClientId: Scalars['Int']['input'];
  categoryIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  sortBy: TeamSortByEnum;
  thumbnailWidth: Scalars['Int']['input'];
}>;


export type TeamsQuery = { __typename?: 'Query', teams: { __typename?: 'TeamList', totalCount: number, results: Array<{ __typename?: 'Team', id?: number | null, teamId?: number | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, function?: string | null, phone?: string | null, email?: string | null, location?: string | null, medias: Array<{ __typename?: 'Media', sortOrder?: number | null, alt?: string | null, thumbnail?: string | null, mime?: string | null }>, categories: Array<{ __typename?: 'TeamCategory', id?: number | null, title?: string | null, status?: number | null, urlSlug?: string | null }> }> } };

export type AddWishlistToBasketMutationVariables = Exact<{
  wishlistId: Scalars['Int']['input'];
}>;


export type AddWishlistToBasketMutation = { __typename?: 'Mutation', addWishlistToBasket?: { __typename?: 'Basket', id?: number | null, errors?: Array<string | null> | null, summary?: { __typename?: 'BasketSummary', currency?: string | null, positionCount?: number | null, productCount?: number | null, productQty?: number | null, subTotal?: string | null, subTotalRrp?: string | null, total?: string | null } | null } | null };

export type CopyWishlistMutationVariables = Exact<{
  wishlistId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
}>;


export type CopyWishlistMutation = { __typename?: 'Mutation', copyWishlist?: { __typename?: 'Wishlist', id?: number | null, title?: string | null, comment?: string | null, frontendUserName?: string | null, frontenduserId?: number | null, createdAt?: string | null, updatedAt?: string | null, summary: { __typename?: 'WishlistSummary', positionCount?: number | null, productQty?: number | null, total?: string | null }, shopClient?: { __typename?: 'Client', id?: number | null, shopClientId?: number | null, title?: string | null, brandColor?: string | null, color?: string | null, medias: Array<{ __typename?: 'Media', targetAttr?: string | null, path?: string | null, filename?: string | null }> } | null } | null };

export type CreateWishlistMutationVariables = Exact<{
  wishlistData: WishlistInputType;
}>;


export type CreateWishlistMutation = { __typename?: 'Mutation', updateWishlist?: { __typename?: 'Wishlist', id?: number | null, title?: string | null, comment?: string | null, frontendUserName?: string | null, frontenduserId?: number | null, createdAt?: string | null, updatedAt?: string | null, summary: { __typename?: 'WishlistSummary', positionCount?: number | null, productQty?: number | null, total?: string | null }, shopClient?: { __typename?: 'Client', id?: number | null, shopClientId?: number | null, title?: string | null, brandColor?: string | null, color?: string | null, medias: Array<{ __typename?: 'Media', targetAttr?: string | null, path?: string | null, filename?: string | null }> } | null } | null };

export type ResetWishlistMutationVariables = Exact<{
  wishlistId: Scalars['Int']['input'];
}>;


export type ResetWishlistMutation = { __typename?: 'Mutation', resetWishlist?: { __typename?: 'Wishlist', id?: number | null, title?: string | null, comment?: string | null, frontendUserName?: string | null, frontenduserId?: number | null, createdAt?: string | null, updatedAt?: string | null, summary: { __typename?: 'WishlistSummary', positionCount?: number | null, productQty?: number | null, total?: string | null }, shopClient?: { __typename?: 'Client', id?: number | null, shopClientId?: number | null, title?: string | null, brandColor?: string | null, color?: string | null, medias: Array<{ __typename?: 'Media', targetAttr?: string | null, path?: string | null, filename?: string | null }> } | null } | null };

export type WishlistsOverviewQueryVariables = Exact<{
  shopClientId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  loadSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubCustomers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WishlistsOverviewQuery = { __typename?: 'Query', wishlists: { __typename?: 'WishlistList', totalCount: number, results: Array<{ __typename?: 'Wishlist', id?: number | null, title?: string | null, comment?: string | null, frontendUserName?: string | null, frontenduserId?: number | null, createdAt?: string | null, updatedAt?: string | null, positions: Array<{ __typename?: 'WishlistPosition', products?: Array<{ __typename?: 'WishlistProduct', shopProductId?: number | null, quantity?: number | null, productData?: { __typename?: 'Product', title?: string | null } | null } | null> | null }>, summary: { __typename?: 'WishlistSummary', positionCount?: number | null, productQty?: number | null, total?: string | null }, shopClient?: { __typename?: 'Client', id?: number | null, shopClientId?: number | null, title?: string | null, brandColor?: string | null, color?: string | null, medias: Array<{ __typename?: 'Media', targetAttr?: string | null, path?: string | null, filename?: string | null }> } | null }> } };

export type DeleteWishlistMutationVariables = Exact<{
  wishlistId: Scalars['Int']['input'];
}>;


export type DeleteWishlistMutation = { __typename?: 'Mutation', deleteWishlist?: { __typename?: 'Wishlist', id?: number | null, title?: string | null } | null };

export type WishlistDetailQueryVariables = Exact<{
  wishlistId: Scalars['Int']['input'];
  loadSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WishlistDetailQuery = { __typename?: 'Query', wishlist: { __typename?: 'Wishlist', id?: number | null, title?: string | null, customerName?: string | null, salesAppUserName?: string | null, productCount?: number | null, createdAt?: string | null, status?: number | null, comment?: string | null, season?: { __typename?: 'Season', seasonId?: number | null, title?: string | null } | null, positions: Array<{ __typename?: 'WishlistPosition', id?: number | null, shopProductIdParent?: number | null, groupIdent?: string | null, groupIdentId?: string | null, productQty?: number | null, subTotal?: string | null, subTotalRrp?: string | null, products?: Array<{ __typename?: 'WishlistProduct', shopProductId?: number | null, quantity?: number | null } | null> | null, productData?: { __typename?: 'Product', id?: number | null, shopProductId?: number | null, title?: string | null, customSku?: string | null, seasonIds: Array<number>, inStock?: boolean | null, quantityIncrement?: number | null, pageUrl?: string | null, customData?: string | null, relatedProductsCount?: number | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, colorName?: string | null, medias: Array<{ __typename?: 'Media', thumbnail?: string | null }>, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null } | null, productSizes: Array<{ __typename?: 'ProductSize', shopProductId?: number | null, sku?: string | null, sizeId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, sizeGridId?: number | null, sizeGridTitle?: string | null, sizeGridSortOrder?: number | null, stock?: number | null, stockStatus?: number | null }> }>, groupSummary: Array<{ __typename?: 'WishlistGroupSummary', groupIdent?: string | null, groupIdentId?: string | null, positionCount?: number | null, productCount?: number | null, productQty?: number | null, total?: string | null, totalRrp?: string | null }>, summary: { __typename?: 'WishlistSummary', positionCount?: number | null, productCount?: number | null, productQty?: number | null, groupCount?: number | null, total?: string | null, totalRrp?: string | null } } };

export type RemoveWishlistPositionMutationVariables = Exact<{
  wishlistPositionId: Scalars['Int']['input'];
}>;


export type RemoveWishlistPositionMutation = { __typename?: 'Mutation', removeWishlistPosition?: { __typename?: 'Wishlist', id?: number | null, title?: string | null, errors?: Array<string | null> | null, groupSummary: Array<{ __typename?: 'WishlistGroupSummary', groupIdent?: string | null, groupIdentId?: string | null, positionCount?: number | null, productCount?: number | null, productQty?: number | null, total?: string | null, totalRrp?: string | null }>, summary: { __typename?: 'WishlistSummary', positionCount?: number | null, productCount?: number | null, productQty?: number | null, groupCount?: number | null, total?: string | null, totalRrp?: string | null } } | null };

export type WishlistsForAddToWishlistQueryVariables = Exact<{
  shopClientId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  loadSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WishlistsForAddToWishlistQuery = { __typename?: 'Query', wishlists: { __typename?: 'WishlistList', totalCount: number, results: Array<{ __typename?: 'Wishlist', id?: number | null, title?: string | null, positions: Array<{ __typename?: 'WishlistPosition', id?: number | null, shopProductIdParent?: number | null }> }> } };

export type AddToWishlistMutationVariables = Exact<{
  wishlistData: WishlistInputType;
  wishlistPosition?: InputMaybe<WishlistPositionInputType>;
}>;


export type AddToWishlistMutation = { __typename?: 'Mutation', updateWishlist?: { __typename?: 'Wishlist', id?: number | null, title?: string | null, comment?: string | null, frontendUserName?: string | null, frontenduserId?: number | null, createdAt?: string | null, updatedAt?: string | null, positions: Array<{ __typename?: 'WishlistPosition', id?: number | null, shopProductIdParent?: number | null }>, summary: { __typename?: 'WishlistSummary', positionCount?: number | null, productQty?: number | null, total?: string | null }, shopClient?: { __typename?: 'Client', id?: number | null, shopClientId?: number | null, title?: string | null, brandColor?: string | null, color?: string | null, medias: Array<{ __typename?: 'Media', targetAttr?: string | null, path?: string | null, filename?: string | null }> } | null } | null };

export type RemoveFromWishlistMutationVariables = Exact<{
  wishlistPositionId: Scalars['Int']['input'];
}>;


export type RemoveFromWishlistMutation = { __typename?: 'Mutation', removeWishlistPosition?: { __typename?: 'Wishlist', id?: number | null, title?: string | null, comment?: string | null, frontendUserName?: string | null, frontenduserId?: number | null, createdAt?: string | null, updatedAt?: string | null, summary: { __typename?: 'WishlistSummary', positionCount?: number | null, productQty?: number | null, total?: string | null }, shopClient?: { __typename?: 'Client', id?: number | null, shopClientId?: number | null, title?: string | null, brandColor?: string | null, color?: string | null, medias: Array<{ __typename?: 'Media', targetAttr?: string | null, path?: string | null, filename?: string | null }> } | null } | null };

export type UpdateWishlistModalPositionMutationVariables = Exact<{
  wishlistId: Scalars['Int']['input'];
  wishlistPosition?: InputMaybe<WishlistPositionInputType>;
  shopClientId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateWishlistModalPositionMutation = { __typename?: 'Mutation', updateWishlistPosition?: { __typename?: 'WishlistPosition', id?: number | null, wishlistId?: number | null, subTotal?: string | null, subTotalRrp?: string | null, productQty?: number | null, errors?: Array<string | null> | null, products?: Array<{ __typename?: 'WishlistProduct', shopProductId?: number | null, quantity?: number | null } | null> | null } | null };

export type WishlistsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  loadSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  pendingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  seasonIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  shopClientId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type WishlistsQuery = { __typename?: 'Query', wishlists: { __typename?: 'WishlistList', totalCount: number, results: Array<{ __typename?: 'Wishlist', id?: number | null, title?: string | null, productCount?: number | null, customerName?: string | null, salesAppUserName?: string | null, createdAt?: string | null, season?: { __typename?: 'Season', seasonId?: number | null, title?: string | null } | null, summary: { __typename?: 'WishlistSummary', positionCount?: number | null, productCount?: number | null, productQty?: number | null, groupCount?: number | null, total?: string | null, totalRrp?: string | null }, positions: Array<{ __typename?: 'WishlistPosition', products?: Array<{ __typename?: 'WishlistProduct', shopProductId?: number | null, quantity?: number | null, productData?: { __typename?: 'Product', title?: string | null } | null } | null> | null }> }> } };

export type WishlistPositionUpdateMutationVariables = Exact<{
  wishlistData: WishlistInputType;
  wishlistPosition?: InputMaybe<WishlistPositionInputType>;
}>;


export type WishlistPositionUpdateMutation = { __typename?: 'Mutation', updateWishlist?: { __typename?: 'Wishlist', id?: number | null, errors?: Array<string | null> | null, positions: Array<{ __typename?: 'WishlistPosition', id?: number | null, productQty?: number | null, subTotal?: string | null, subTotalRrp?: string | null }>, groupSummary: Array<{ __typename?: 'WishlistGroupSummary', groupIdent?: string | null, groupIdentId?: string | null, positionCount?: number | null, productCount?: number | null, productQty?: number | null, total?: string | null, totalRrp?: string | null }>, summary: { __typename?: 'WishlistSummary', positionCount?: number | null, productCount?: number | null, productQty?: number | null, groupCount?: number | null, total?: string | null, totalRrp?: string | null } } | null };

export type CustomerAddressFragment = { __typename?: 'CustomerAddress', id?: number | null, company?: string | null, companyAddition?: string | null, companyAddition2?: string | null, typeLabel?: string | null, street?: string | null, number?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, countryLabel?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null, email?: string | null };

export type FrontenduserFragment = { __typename?: 'Frontenduser', id?: number | null, username?: string | null, email?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null, position?: string | null, salutation?: string | null, salutationCode?: string | null, status?: number | null };

export type ProductColorFragment = { __typename?: 'Product', colorName?: string | null, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null };

export type ProductCustomDataFragment = { __typename?: 'Product', customData?: string | null };

export type ProductDetailPageFragment = { __typename?: 'Product', shopProductId?: number | null, title?: string | null, subtitle?: string | null, customSku?: string | null, description?: string | null, status?: number | null, stockStatus?: number | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, customData?: string | null, colorName?: string | null, childrenCount?: number | null, featureValues: Array<{ __typename?: 'DropdownList', value?: string | null, label?: string | null }>, themeworlds: Array<{ __typename?: 'Themeworld', id?: number | null, themeworldId?: number | null }>, looks: Array<{ __typename?: 'Looks', id?: number | null, looksId?: number | null }>, thumbnail: Array<{ __typename?: 'Media', thumbnail?: string | null }>, mainImage: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, thumbnail?: string | null, width?: number | null, height?: number | null, alt?: string | null }>, imageGallery: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, thumbnail?: string | null, width?: number | null, height?: number | null, alt?: string | null }>, relatedProducts: Array<{ __typename?: 'RelatedProduct', shopProductId?: number | null, productData?: { __typename?: 'Product', shopProductId?: number | null } | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> };

export type ProductDetailPageMoodVideoFragment = { __typename?: 'Product', moodVideo: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, path?: string | null, alt?: string | null }> };

export type ProductFeatureValuesFragment = { __typename?: 'Product', featureValues: Array<{ __typename?: 'DropdownList', label?: string | null, value?: string | null }> };

export type ProductListItemFragment = { __typename?: 'Product', id?: number | null, shopProductId?: number | null, title?: string | null, customSku?: string | null, stockStatus?: number | null, customData?: string | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, colorName?: string | null, smallThumb: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, largeThumb: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> };

export type ProductListItemRelatedFragment = { __typename?: 'Product', relatedProductsCount?: number | null, relatedProducts: Array<{ __typename?: 'RelatedProduct', id?: number | null, productData?: { __typename?: 'Product', shopProductId?: number | null, colorName?: string | null, image: Array<{ __typename?: 'Media', id?: number | null, thumbnail?: string | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> } | null }> };

export type ProductPriceFragment = { __typename?: 'Product', price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null };

export type ProductSizeFieldsFragment = { __typename?: 'ProductSize', shopProductId?: number | null, sku?: string | null, sizeId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, sizeGridId?: number | null, sizeGridTitle?: string | null, sizeGridSortOrder?: number | null, stock?: number | null, stockStatus?: number | null };

export type ProductSizesFragment = { __typename?: 'Product', id?: number | null, shopProductId?: number | null, productSizes: Array<{ __typename?: 'ProductSize', shopProductId?: number | null, sku?: string | null, sizeId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, sizeGridId?: number | null, sizeGridTitle?: string | null, sizeGridSortOrder?: number | null, stock?: number | null, stockStatus?: number | null }> };

export type ProductSizesCountFragment = { __typename?: 'Product', childrenCount?: number | null };

export type ProductSizesWishlistFragment = { __typename?: 'WishlistPosition', id?: number | null, productSizes: Array<{ __typename?: 'ProductSize', shopProductId?: number | null, sku?: string | null, sizeId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, sizeGridId?: number | null, sizeGridTitle?: string | null, sizeGridSortOrder?: number | null, stock?: number | null, stockStatus?: number | null }> };

export type ProductTagsFragment = { __typename?: 'Product', tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> };

export type WishlistGroupSummaryFragment = { __typename?: 'Wishlist', groupSummary: Array<{ __typename?: 'WishlistGroupSummary', groupIdent?: string | null, groupIdentId?: string | null, positionCount?: number | null, productCount?: number | null, productQty?: number | null, total?: string | null, totalRrp?: string | null }> };

export type WishlistOverviewItemFragment = { __typename?: 'Wishlist', id?: number | null, title?: string | null, comment?: string | null, frontendUserName?: string | null, frontenduserId?: number | null, createdAt?: string | null, updatedAt?: string | null, summary: { __typename?: 'WishlistSummary', positionCount?: number | null, productQty?: number | null, total?: string | null }, shopClient?: { __typename?: 'Client', id?: number | null, shopClientId?: number | null, title?: string | null, brandColor?: string | null, color?: string | null, medias: Array<{ __typename?: 'Media', targetAttr?: string | null, path?: string | null, filename?: string | null }> } | null };

export type WishlistPositionsProductsFragmentFragment = { __typename?: 'WishlistPosition', products?: Array<{ __typename?: 'WishlistProduct', shopProductId?: number | null, quantity?: number | null } | null> | null };

export type WishlistSummaryFragment = { __typename?: 'Wishlist', summary: { __typename?: 'WishlistSummary', positionCount?: number | null, productCount?: number | null, productQty?: number | null, groupCount?: number | null, total?: string | null, totalRrp?: string | null } };

export type ActiveProductsQueryVariables = Exact<{
  shopProductId: Scalars['Int']['input'];
}>;


export type ActiveProductsQuery = { __typename?: 'Query', product: { __typename?: 'Product', shopProductId?: number | null, title?: string | null, subtitle?: string | null, customSku?: string | null, description?: string | null, status?: number | null, stockStatus?: number | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, customData?: string | null, colorName?: string | null, childrenCount?: number | null, relatedProducts: Array<{ __typename?: 'RelatedProduct', id?: number | null, shopProductId?: number | null, productData?: { __typename?: 'Product', shopProductId?: number | null, title?: string | null, subtitle?: string | null, customSku?: string | null, description?: string | null, status?: number | null, stockStatus?: number | null, price?: number | null, rrp?: number | null, isSale?: boolean | null, originalPrice?: string | null, customData?: string | null, colorName?: string | null, childrenCount?: number | null, featureValues: Array<{ __typename?: 'DropdownList', value?: string | null, label?: string | null }>, themeworlds: Array<{ __typename?: 'Themeworld', id?: number | null, themeworldId?: number | null }>, looks: Array<{ __typename?: 'Looks', id?: number | null, looksId?: number | null }>, thumbnail: Array<{ __typename?: 'Media', thumbnail?: string | null }>, mainImage: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, thumbnail?: string | null, width?: number | null, height?: number | null, alt?: string | null }>, imageGallery: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, thumbnail?: string | null, width?: number | null, height?: number | null, alt?: string | null }>, relatedProducts: Array<{ __typename?: 'RelatedProduct', shopProductId?: number | null, productData?: { __typename?: 'Product', shopProductId?: number | null } | null }>, moodVideo: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, path?: string | null, alt?: string | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> } | null }>, featureValues: Array<{ __typename?: 'DropdownList', value?: string | null, label?: string | null }>, themeworlds: Array<{ __typename?: 'Themeworld', id?: number | null, themeworldId?: number | null }>, looks: Array<{ __typename?: 'Looks', id?: number | null, looksId?: number | null }>, thumbnail: Array<{ __typename?: 'Media', thumbnail?: string | null }>, mainImage: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, thumbnail?: string | null, width?: number | null, height?: number | null, alt?: string | null }>, imageGallery: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, thumbnail?: string | null, width?: number | null, height?: number | null, alt?: string | null }>, moodVideo: Array<{ __typename?: 'Media', targetAttr?: string | null, sortOrder?: number | null, path?: string | null, alt?: string | null }>, color?: { __typename?: 'Color', id?: number | null, hexCode?: string | null, number?: string | null, sortOrder?: number | null } | null, tags: Array<{ __typename?: 'ProductTag', id?: number | null, productTagId?: number | null, title?: string | null, status?: number | null, sortOrder?: number | null, logo?: Array<{ __typename?: 'Media', path?: string | null } | null> | null }> } };

export type WishlistCountProductsQueryVariables = Exact<{
  loadSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  pendingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  shopClientId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type WishlistCountProductsQuery = { __typename?: 'Query', wishlists: { __typename?: 'WishlistList', results: Array<{ __typename?: 'Wishlist', positions: Array<{ __typename?: 'WishlistPosition', shopProductIdParent?: number | null }> }> } };

export type FrontendUserQueryVariables = Exact<{ [key: string]: never; }>;


export type FrontendUserQuery = { __typename?: 'Query', frontenduser: { __typename?: 'Frontenduser', id?: number | null, salutation?: string | null, firstname?: string | null, lastname?: string | null, email?: string | null, activeCustomer: { __typename?: 'Customer', customerId?: number | null, customerNumber?: string | null, name?: string | null, country?: { __typename?: 'Country', countryId?: number | null, countryCode?: string | null, name?: string | null, termsOfService?: string | null, popupTermsOfService?: string | null, imprint?: string | null, privacyPolicy?: string | null } | null, currency?: { __typename?: 'Currency', currencyId?: number | null, title?: string | null, isoCode?: string | null } | null, currencyRrp?: { __typename?: 'Currency', currencyId?: number | null, title?: string | null, isoCode?: string | null } | null } } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const ProductSizeFieldsFragmentDoc = new TypedDocumentString(`
    fragment ProductSizeFields on ProductSize {
  shopProductId
  sku
  sizeId
  title
  status
  sortOrder
  sizeGridId
  sizeGridTitle
  sizeGridSortOrder
  stock
  stockStatus
}
    `, {"fragmentName":"ProductSizeFields"}) as unknown as TypedDocumentString<ProductSizeFieldsFragment, unknown>;
export const ProductSizesFragmentDoc = new TypedDocumentString(`
    fragment ProductSizes on Product {
  id
  shopProductId
  productSizes {
    ...ProductSizeFields
  }
}
    fragment ProductSizeFields on ProductSize {
  shopProductId
  sku
  sizeId
  title
  status
  sortOrder
  sizeGridId
  sizeGridTitle
  sizeGridSortOrder
  stock
  stockStatus
}`, {"fragmentName":"ProductSizes"}) as unknown as TypedDocumentString<ProductSizesFragment, unknown>;
export const ProductColorFragmentDoc = new TypedDocumentString(`
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
    `, {"fragmentName":"ProductColor"}) as unknown as TypedDocumentString<ProductColorFragment, unknown>;
export const ProductPriceFragmentDoc = new TypedDocumentString(`
    fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
    `, {"fragmentName":"ProductPrice"}) as unknown as TypedDocumentString<ProductPriceFragment, unknown>;
export const ProductTagsFragmentDoc = new TypedDocumentString(`
    fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}
    `, {"fragmentName":"ProductTags"}) as unknown as TypedDocumentString<ProductTagsFragment, unknown>;
export const CartAllocationPositionProductDataFragmentDoc = new TypedDocumentString(`
    fragment CartAllocationPositionProductData on Product {
  shopProductId
  title
  sku
  customSku
  customData
  stockStatus
  seasonIds
  mainImage: medias(targetAttr: "image") {
    thumbnail(width: 800, height: 800)
  }
  ...ProductSizes
  ...ProductColor
  ...ProductPrice
  ...ProductTags
}
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
fragment ProductSizeFields on ProductSize {
  shopProductId
  sku
  sizeId
  title
  status
  sortOrder
  sizeGridId
  sizeGridTitle
  sizeGridSortOrder
  stock
  stockStatus
}
fragment ProductSizes on Product {
  id
  shopProductId
  productSizes {
    ...ProductSizeFields
  }
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`, {"fragmentName":"CartAllocationPositionProductData"}) as unknown as TypedDocumentString<CartAllocationPositionProductDataFragment, unknown>;
export const CustomerAddressFragmentDoc = new TypedDocumentString(`
    fragment CustomerAddress on CustomerAddress {
  id
  company
  companyAddition
  companyAddition2
  typeLabel
  street
  number
  zipCode
  city
  countryCode
  countryLabel
  firstname
  lastname
  phone
  email
}
    `, {"fragmentName":"CustomerAddress"}) as unknown as TypedDocumentString<CustomerAddressFragment, unknown>;
export const FrontenduserFragmentDoc = new TypedDocumentString(`
    fragment Frontenduser on Frontenduser {
  id
  username
  email
  firstname
  lastname
  phone
  position
  salutation
  salutationCode
  status
}
    `, {"fragmentName":"Frontenduser"}) as unknown as TypedDocumentString<FrontenduserFragment, unknown>;
export const ProductCustomDataFragmentDoc = new TypedDocumentString(`
    fragment ProductCustomData on Product {
  customData
}
    `, {"fragmentName":"ProductCustomData"}) as unknown as TypedDocumentString<ProductCustomDataFragment, unknown>;
export const ProductSizesCountFragmentDoc = new TypedDocumentString(`
    fragment ProductSizesCount on Product {
  childrenCount
}
    `, {"fragmentName":"ProductSizesCount"}) as unknown as TypedDocumentString<ProductSizesCountFragment, unknown>;
export const ProductDetailPageFragmentDoc = new TypedDocumentString(`
    fragment ProductDetailPage on Product {
  shopProductId
  title
  subtitle
  customSku
  description
  status
  stockStatus
  title
  featureValues {
    value
    label
  }
  themeworlds(inB2b: true) {
    id
    themeworldId
  }
  looks(inB2b: true) {
    id
    looksId
  }
  thumbnail: medias(targetAttr: "image") {
    thumbnail(width: 400)
  }
  mainImage: medias(targetAttr: "image") {
    targetAttr
    sortOrder
    thumbnail(width: 2000)
    width
    height
    alt
  }
  imageGallery: medias(targetAttr: "image_gallery") {
    targetAttr
    sortOrder
    thumbnail(width: 2000)
    width
    height
    alt
  }
  relatedProducts {
    shopProductId
    productData {
      shopProductId
    }
  }
  ...ProductPrice
  ...ProductCustomData
  ...ProductColor
  ...ProductTags
  ...ProductSizesCount
}
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductCustomData on Product {
  customData
}
fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
fragment ProductSizesCount on Product {
  childrenCount
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`, {"fragmentName":"ProductDetailPage"}) as unknown as TypedDocumentString<ProductDetailPageFragment, unknown>;
export const ProductDetailPageMoodVideoFragmentDoc = new TypedDocumentString(`
    fragment ProductDetailPageMoodVideo on Product {
  moodVideo: medias(targetAttr: "mood_video") {
    targetAttr
    sortOrder
    path
    alt
  }
}
    `, {"fragmentName":"ProductDetailPageMoodVideo"}) as unknown as TypedDocumentString<ProductDetailPageMoodVideoFragment, unknown>;
export const ProductFeatureValuesFragmentDoc = new TypedDocumentString(`
    fragment ProductFeatureValues on Product {
  featureValues {
    label
    value
  }
}
    `, {"fragmentName":"ProductFeatureValues"}) as unknown as TypedDocumentString<ProductFeatureValuesFragment, unknown>;
export const ProductListItemFragmentDoc = new TypedDocumentString(`
    fragment ProductListItem on Product {
  id
  shopProductId
  title
  customSku
  stockStatus
  smallThumb: medias(targetAttr: "image") {
    id
    thumbnail(width: 400)
  }
  largeThumb: medias(targetAttr: "image") {
    id
    thumbnail(width: 800)
  }
  ...ProductCustomData
  ...ProductPrice
  ...ProductColor
  ...ProductTags
}
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductCustomData on Product {
  customData
}
fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`, {"fragmentName":"ProductListItem"}) as unknown as TypedDocumentString<ProductListItemFragment, unknown>;
export const ProductListItemRelatedFragmentDoc = new TypedDocumentString(`
    fragment ProductListItemRelated on Product {
  relatedProductsCount
  relatedProducts {
    id
    productData {
      shopProductId
      image: medias(targetAttr: "image") {
        id
        thumbnail(width: 400)
      }
      ...ProductColor
      ...ProductTags
    }
  }
}
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`, {"fragmentName":"ProductListItemRelated"}) as unknown as TypedDocumentString<ProductListItemRelatedFragment, unknown>;
export const ProductSizesWishlistFragmentDoc = new TypedDocumentString(`
    fragment ProductSizesWishlist on WishlistPosition {
  id
  productSizes {
    ...ProductSizeFields
  }
}
    fragment ProductSizeFields on ProductSize {
  shopProductId
  sku
  sizeId
  title
  status
  sortOrder
  sizeGridId
  sizeGridTitle
  sizeGridSortOrder
  stock
  stockStatus
}`, {"fragmentName":"ProductSizesWishlist"}) as unknown as TypedDocumentString<ProductSizesWishlistFragment, unknown>;
export const WishlistGroupSummaryFragmentDoc = new TypedDocumentString(`
    fragment WishlistGroupSummary on Wishlist {
  groupSummary {
    groupIdent
    groupIdentId
    positionCount
    productCount
    productQty
    total
    totalRrp
  }
}
    `, {"fragmentName":"WishlistGroupSummary"}) as unknown as TypedDocumentString<WishlistGroupSummaryFragment, unknown>;
export const WishlistOverviewItemFragmentDoc = new TypedDocumentString(`
    fragment WishlistOverviewItem on Wishlist {
  id
  title
  comment
  frontendUserName
  frontenduserId
  createdAt(format: "Y-m-d H:i:s")
  updatedAt(format: "Y-m-d H:i:s")
  summary {
    positionCount
    productQty
    total
  }
  shopClient {
    id
    shopClientId
    title
    brandColor
    color
    medias(targetAttr: "logo") {
      targetAttr
      path
      filename
    }
  }
}
    `, {"fragmentName":"WishlistOverviewItem"}) as unknown as TypedDocumentString<WishlistOverviewItemFragment, unknown>;
export const WishlistPositionsProductsFragmentFragmentDoc = new TypedDocumentString(`
    fragment WishlistPositionsProductsFragment on WishlistPosition {
  products {
    shopProductId
    quantity
  }
}
    `, {"fragmentName":"WishlistPositionsProductsFragment"}) as unknown as TypedDocumentString<WishlistPositionsProductsFragmentFragment, unknown>;
export const WishlistSummaryFragmentDoc = new TypedDocumentString(`
    fragment WishlistSummary on Wishlist {
  summary {
    positionCount
    productCount
    productQty
    groupCount
    total
    totalRrp
  }
}
    `, {"fragmentName":"WishlistSummary"}) as unknown as TypedDocumentString<WishlistSummaryFragment, unknown>;
export const ProductListProductsDocument = new TypedDocumentString(`
    query ProductListProducts($shopClientId: Int!, $selectedFilters: [String], $sortBy: ProductSortByEnum, $limit: Int) {
  products(
    shopClientIds: [$shopClientId]
    selectedFilters: $selectedFilters
    sortBy: $sortBy
    limit: $limit
  ) {
    totalCount
    results {
      ...ProductListItem
      ...ProductListItemRelated
    }
  }
}
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductCustomData on Product {
  customData
}
fragment ProductListItem on Product {
  id
  shopProductId
  title
  customSku
  stockStatus
  smallThumb: medias(targetAttr: "image") {
    id
    thumbnail(width: 400)
  }
  largeThumb: medias(targetAttr: "image") {
    id
    thumbnail(width: 800)
  }
  ...ProductCustomData
  ...ProductPrice
  ...ProductColor
  ...ProductTags
}
fragment ProductListItemRelated on Product {
  relatedProductsCount
  relatedProducts {
    id
    productData {
      shopProductId
      image: medias(targetAttr: "image") {
        id
        thumbnail(width: 400)
      }
      ...ProductColor
      ...ProductTags
    }
  }
}
fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<ProductListProductsQuery, ProductListProductsQueryVariables>;
export const CustomerAddressesDocument = new TypedDocumentString(`
    query customerAddresses($customerId: Int!) {
  customer(customerId: $customerId) {
    id
    name
    nameAddition
    customerNumber
    addresses {
      ...CustomerAddress
    }
    subCustomers {
      id
      name
      nameAddition
      customerNumber
      addresses {
        ...CustomerAddress
      }
    }
  }
}
    fragment CustomerAddress on CustomerAddress {
  id
  company
  companyAddition
  companyAddition2
  typeLabel
  street
  number
  zipCode
  city
  countryCode
  countryLabel
  firstname
  lastname
  phone
  email
}`) as unknown as TypedDocumentString<CustomerAddressesQuery, CustomerAddressesQueryVariables>;
export const ChangePasswordInAccountDocument = new TypedDocumentString(`
    mutation ChangePasswordInAccount($password: String!, $passwordRepeat: String!) {
  changePassword(password: $password, passwordRepeat: $passwordRepeat) {
    id
    errors
  }
}
    `) as unknown as TypedDocumentString<ChangePasswordInAccountMutation, ChangePasswordInAccountMutationVariables>;
export const OpenOrdersDocument = new TypedDocumentString(`
    query openOrders($shopClientId: [Int], $loadSubmissions: Boolean, $pendingOnly: Boolean, $limit: Int, $offset: Int, $includeSubCustomers: Boolean) {
  wishlists(
    shopClientId: $shopClientId
    loadSubmissions: $loadSubmissions
    pendingOnly: $pendingOnly
    limit: $limit
    offset: $offset
    includeSubCustomers: $includeSubCustomers
  ) {
    totalCount
    results {
      id
      title
      createdAt
      salesAppUserName
      status
      shopClient {
        id
        shopClientId
        title
        brandColor
        color
        medias(targetAttr: "logo") {
          targetAttr
          path
          filename
        }
      }
      summary {
        positionCount
        productCount
        productQty
        groupCount
        total
        totalRrp
      }
    }
  }
}
    `) as unknown as TypedDocumentString<OpenOrdersQuery, OpenOrdersQueryVariables>;
export const OrderHistoryDetailDocument = new TypedDocumentString(`
    query orderHistoryDetail($shopOrderId: Int!) {
  order(shopOrderId: $shopOrderId) {
    id
    shopClientId
    orderStatus
    updatedAt
    totalWithVat
    commission
    positions {
      id
      price
      priceRrp
      productQuantity
      quantityCanceled
      subTotal
      subTotalRrp
      deliveryDate
      isCanceled
      productData {
        title
        customSku
        colorName
        medias(targetAttr: "image") {
          thumbnail(width: 200)
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<OrderHistoryDetailQuery, OrderHistoryDetailQueryVariables>;
export const OrderHistoryDetailPositionDocument = new TypedDocumentString(`
    query orderHistoryDetailPosition($orderPositionId: Int!) {
  orderPosition(orderPositionId: $orderPositionId) {
    id
    price
    priceRrp
    productQuantity
    quantityCanceled
    subTotal
    subTotalRrp
    deliveryDate
    isCanceled
    products {
      id
      quantity
      quantityCanceled
      isCanceled
      productData {
        size {
          title
        }
      }
    }
    productData {
      title
      customSku
      colorName
      medias(targetAttr: "image") {
        path
        thumbnail(width: 800, height: 800)
      }
    }
  }
}
    `) as unknown as TypedDocumentString<OrderHistoryDetailPositionQuery, OrderHistoryDetailPositionQueryVariables>;
export const OrderHistoryDocument = new TypedDocumentString(`
    query OrderHistory($shopClientIds: [Int!]!, $limit: Int!, $offset: Int!, $sortBy: OrderSortByEnum!, $includeSubCustomers: Boolean!, $searchQuery: String, $cutOffDateIso: String) {
  orders(
    shopClientIds: $shopClientIds
    limit: $limit
    offset: $offset
    sortBy: $sortBy
    searchQuery: $searchQuery
    includeSubCustomers: $includeSubCustomers
    dateValueStart: $cutOffDateIso
  ) {
    totalCount
    results {
      id
      shopClientId
      orderStatus
      updatedAt
      positions {
        id
        productQuantity
        quantityCanceled
      }
      totalWithVat
      commission
    }
  }
}
    `) as unknown as TypedDocumentString<OrderHistoryQuery, OrderHistoryQueryVariables>;
export const CustomerUsersDocument = new TypedDocumentString(`
    query customerUsers($customerId: Int!, $limit: Int, $offset: Int) {
  customerUsers(customerId: $customerId, limit: $limit, offset: $offset) {
    totalCount
    results {
      ...Frontenduser
    }
  }
}
    fragment Frontenduser on Frontenduser {
  id
  username
  email
  firstname
  lastname
  phone
  position
  salutation
  salutationCode
  status
}`) as unknown as TypedDocumentString<CustomerUsersQuery, CustomerUsersQueryVariables>;
export const CreateFrontenduserDocument = new TypedDocumentString(`
    mutation createFrontenduser($customerId: Int!, $frontenduserData: FrontenduserInputType, $sendEmail: Boolean) {
  createFrontenduser(
    customerId: $customerId
    frontenduserData: $frontenduserData
    sendEmail: $sendEmail
  ) {
    ...Frontenduser
  }
}
    fragment Frontenduser on Frontenduser {
  id
  username
  email
  firstname
  lastname
  phone
  position
  salutation
  salutationCode
  status
}`) as unknown as TypedDocumentString<CreateFrontenduserMutation, CreateFrontenduserMutationVariables>;
export const DeleteFrontenduserDocument = new TypedDocumentString(`
    mutation deleteFrontenduser($frontenduserId: Int!) {
  deleteFrontenduser(frontenduserId: $frontenduserId) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteFrontenduserMutation, DeleteFrontenduserMutationVariables>;
export const UpdateFrontenduserDocument = new TypedDocumentString(`
    mutation updateFrontenduser($frontenduserId: Int!, $frontenduserData: FrontenduserInputType) {
  updateFrontenduser(
    frontenduserId: $frontenduserId
    frontenduserData: $frontenduserData
  ) {
    ...Frontenduser
  }
}
    fragment Frontenduser on Frontenduser {
  id
  username
  email
  firstname
  lastname
  phone
  position
  salutation
  salutationCode
  status
}`) as unknown as TypedDocumentString<UpdateFrontenduserMutation, UpdateFrontenduserMutationVariables>;
export const AccountWishlistsDocument = new TypedDocumentString(`
    query AccountWishlists($shopClientId: [Int], $loadSubmissions: Boolean, $limit: Int, $offset: Int) {
  wishlists(
    shopClientId: $shopClientId
    loadSubmissions: $loadSubmissions
    limit: $limit
    offset: $offset
  ) {
    totalCount
    results {
      ...WishlistOverviewItem
    }
  }
}
    fragment WishlistOverviewItem on Wishlist {
  id
  title
  comment
  frontendUserName
  frontenduserId
  createdAt(format: "Y-m-d H:i:s")
  updatedAt(format: "Y-m-d H:i:s")
  summary {
    positionCount
    productQty
    total
  }
  shopClient {
    id
    shopClientId
    title
    brandColor
    color
    medias(targetAttr: "logo") {
      targetAttr
      path
      filename
    }
  }
}`) as unknown as TypedDocumentString<AccountWishlistsQuery, AccountWishlistsQueryVariables>;
export const BasketDetailDocument = new TypedDocumentString(`
    query BasketDetail($shopClientId: Int) {
  basket(shopClientId: $shopClientId) {
    id
    positions {
      id
      shopProductIdParent
      productQty
      subTotal
      products {
        id
        shopProductId
        quantity
        subTotal
      }
      productData {
        id
        shopProductId
        title
        customSku
        seasonIds
        inStock
        quantityIncrement
        pageUrl
        customData
        medias(targetAttr: "image") {
          thumbnail(width: 800)
        }
        relatedProductsCount
        ...ProductSizes
        ...ProductPrice
        ...ProductTags
        ...ProductColor
      }
      comment
      commission
      deliveryDate
    }
    summary {
      currency
      positionCount
      productCount
      productQty
      subTotal(formatted: true)
      subTotalRrp(formatted: true)
      total(formatted: true)
    }
  }
}
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
fragment ProductSizeFields on ProductSize {
  shopProductId
  sku
  sizeId
  title
  status
  sortOrder
  sizeGridId
  sizeGridTitle
  sizeGridSortOrder
  stock
  stockStatus
}
fragment ProductSizes on Product {
  id
  shopProductId
  productSizes {
    ...ProductSizeFields
  }
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<BasketDetailQuery, BasketDetailQueryVariables>;
export const BasketCheckoutDocument = new TypedDocumentString(`
    query BasketCheckout($shopClientId: Int) {
  basket(shopClientId: $shopClientId) {
    id
    positions {
      id
      productQty
      subTotal
      productData {
        shopProductId
        title
        customSku
        pageUrl
        image: medias(targetAttr: "image") {
          thumbnail(width: 800)
        }
        ...ProductColor
        ...ProductTags
      }
    }
    summary {
      currency
      positionCount
      productCount
      productQty
      subTotal(formatted: true)
      subTotalRrp(formatted: true)
      total(formatted: true)
    }
  }
}
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<BasketCheckoutQuery, BasketCheckoutQueryVariables>;
export const RemoveBasketPositionDocument = new TypedDocumentString(`
    mutation RemoveBasketPosition($basketPositionId: Int, $shopClientId: Int) {
  removeBasketPosition(
    basketPositionId: $basketPositionId
    shopClientId: $shopClientId
  ) {
    id
    positions {
      id
      shopProductIdParent
    }
    summary {
      currency
      positionCount
      productCount
      productQty
      subTotal(formatted: true)
      subTotalRrp(formatted: true)
      total(formatted: true)
    }
    errors
  }
}
    `) as unknown as TypedDocumentString<RemoveBasketPositionMutation, RemoveBasketPositionMutationVariables>;
export const UpdateBasketDocument = new TypedDocumentString(`
    mutation UpdateBasket($basketPositionData: BasketInputType, $shopClientId: Int) {
  updateBasket(
    basketPositionData: $basketPositionData
    shopClientId: $shopClientId
  ) {
    id
    positions {
      id
      shopProductIdParent
      productQty
      subTotal
      products {
        shopProductId
        quantity
      }
    }
    summary {
      currency
      positionCount
      productCount
      productQty
      subTotal(formatted: true)
      subTotalRrp(formatted: true)
      total(formatted: true)
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateBasketMutation, UpdateBasketMutationVariables>;
export const UpdateBasketPositionDocument = new TypedDocumentString(`
    mutation UpdateBasketPosition($basketPositionData: BasketInputType, $shopClientId: Int) {
  updateBasketPosition(
    basketPositionData: $basketPositionData
    shopClientId: $shopClientId
  ) {
    id
    shopProductIdParent
    productQty
    subTotal
    subTotalRrp
    products {
      shopProductId
      quantity
    }
    basketSummary {
      currency
      positionCount
      productCount
      productQty
      subTotal(formatted: true)
      subTotalRrp(formatted: true)
      total(formatted: true)
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateBasketPositionMutation, UpdateBasketPositionMutationVariables>;
export const BasketCountDocument = new TypedDocumentString(`
    query BasketCount($shopClientId: Int) {
  basket(shopClientId: $shopClientId) {
    id
    positions {
      id
      shopProductIdParent
      productQty
    }
    summary {
      productCount
      productQty
      positionCount
    }
  }
}
    `) as unknown as TypedDocumentString<BasketCountQuery, BasketCountQueryVariables>;
export const BlogCategoriesDocument = new TypedDocumentString(`
    query BlogCategories($limit: Int!) {
  blogCategories(limit: $limit) {
    totalCount
    results {
      blogCategoryId
      id
      title
      description
      pageUrl
      subtitle
    }
  }
}
    `) as unknown as TypedDocumentString<BlogCategoriesQuery, BlogCategoriesQueryVariables>;
export const BlogDetailPageDocument = new TypedDocumentString(`
    query BlogDetailPage($blogId: ID!, $thumbnailWidth: Int!) {
  blog(blogId: $blogId) {
    id
    blogId
    title
    teaser(format: HTML)
    description(format: HTML)
    date(format: "Y-m-d H:i:s")
    updatedAt(format: "d.m.Y")
    pageUrl
    blogAuthor {
      id
      fullName
    }
    categories {
      blogCategoryId
      title
    }
    tags {
      blogTagId
      title
    }
    medias(targetAttr: "content_image") {
      sortOrder
      alt
      thumbnail(width: $thumbnailWidth)
      mime
      width
      height
    }
  }
}
    `) as unknown as TypedDocumentString<BlogDetailPageQuery, BlogDetailPageQueryVariables>;
export const BlogOverviewListDocument = new TypedDocumentString(`
    query BlogOverviewList($categoryIds: [Int], $limit: Int, $offset: Int, $sortBy: BlogSortByEnum, $thumbnailWidth: Int!) {
  blogs(
    categoryIds: $categoryIds
    limit: $limit
    offset: $offset
    sortBy: $sortBy
  ) {
    totalCount
    results {
      id
      blogId
      title
      teaser(maxLength: 200)
      date(format: "Y-m-d H:i:s")
      pageUrl
      sortOrder
      categories {
        blogCategoryId
        title
      }
      medias(targetAttr: "content_image") {
        sortOrder
        alt
        thumbnail(width: $thumbnailWidth)
        mime
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BlogOverviewListQuery, BlogOverviewListQueryVariables>;
export const ShopClientsDocument = new TypedDocumentString(`
    query ShopClients($brandImageWidth: Int!, $landingPageHeroImageWidth: Int!) {
  clients {
    totalCount
    results {
      id
      shopClientId
      title
      brandColor
      fallbackColor: color
      status
      sortOrder
      logoHeader: medias(targetAttr: "b2b_logo_header") {
        path
        alt
      }
      logoFooter: medias(targetAttr: "b2b_logo_footer") {
        path
        alt
      }
      brandImage: medias(targetAttr: "image") {
        thumbnail(width: $brandImageWidth)
        alt
      }
      brandLogo: medias(targetAttr: "logo") {
        path
        alt
      }
      landingpagePreOrderHeroImages: medias(targetAttr: "pre_order_hero_images") {
        alt
        label
        link
        linkTitle
        sortOrder
        thumbnail(width: $landingPageHeroImageWidth)
      }
      landingpagePreOrderHeroImagesMobile: medias(
        targetAttr: "pre_order_hero_images_mobile"
      ) {
        alt
        label
        link
        linkTitle
        sortOrder
        thumbnail(width: $landingPageHeroImageWidth)
      }
      landingpageReOrderHeroImages: medias(targetAttr: "re_order_hero_images") {
        alt
        label
        link
        linkTitle
        sortOrder
        thumbnail(width: $landingPageHeroImageWidth)
      }
      landingpageReOrderHeroImagesMobile: medias(
        targetAttr: "re_order_hero_images_mobile"
      ) {
        alt
        label
        link
        linkTitle
        sortOrder
        thumbnail(width: $landingPageHeroImageWidth)
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ShopClientsQuery, ShopClientsQueryVariables>;
export const ThemeworldByIdDocument = new TypedDocumentString(`
    query ThemeworldById($themeworldId: Int!, $thumbnailWidth: Int!) {
  themeworld(themeworldId: $themeworldId) {
    id
    themeworldId
    shopClientId
    seasons
    productlines
    categories {
      id
      themeworldCategoryId
    }
    products {
      id
      shopProductId
    }
    title
    subtitle
    description
    status
    images: medias {
      id
      targetAttr
      thumbnail(width: $thumbnailWidth)
      width
      height
    }
  }
}
    `) as unknown as TypedDocumentString<ThemeworldByIdQuery, ThemeworldByIdQueryVariables>;
export const ThemeworldKeyPiecesDocument = new TypedDocumentString(`
    query ThemeworldKeyPieces($themeworldId: Int!) {
  themeworld(themeworldId: $themeworldId) {
    id
    themeworldId
    keyPieces: products(favoritesOnly: true) {
      id
      shopProductId
      sortOrder
      productData {
        id
        shopProductId
        title
        image: medias(targetAttr: "image") {
          id
          thumbnail(width: 400)
        }
        ...ProductTags
      }
    }
  }
}
    fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<ThemeworldKeyPiecesQuery, ThemeworldKeyPiecesQueryVariables>;
export const ThemeworldsByCategoryDocument = new TypedDocumentString(`
    query ThemeworldsByCategory($shopClientIds: [Int!], $seasonIds: [Int!], $productLineIds: [Int!], $categoryIds: [Int!], $sortBy: ThemeworldSortByEnum, $thumbnailWidth: Int!) {
  themeworlds(
    inB2B: true
    shopClientIds: $shopClientIds
    seasonIds: $seasonIds
    categoryIds: $categoryIds
    productLineIds: $productLineIds
    sortBy: $sortBy
    limit: -1
  ) {
    totalCount
    results {
      id
      themeworldId
      title
      status
      overviewImage: medias(targetAttr: "overview_image") {
        thumbnail(width: $thumbnailWidth)
      }
      mainImage: medias(targetAttr: "main_image") {
        id
        thumbnail(width: $thumbnailWidth)
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ThemeworldsByCategoryQuery, ThemeworldsByCategoryQueryVariables>;
export const ThemeworldCategoriesDocument = new TypedDocumentString(`
    query ThemeworldCategories($shopClientId: Int!, $seasonIds: [Int!], $productLineIds: [Int!], $themeworldSortBy: ThemeworldSortByEnum!) {
  themeworldCategories(
    inB2B: true
    shopClientIds: [$shopClientId]
    seasonIds: $seasonIds
    productLineIds: $productLineIds
  ) {
    totalCount
    results {
      id
      themeworldCategoryId
      image: medias(targetAttr: "image") {
        id
        targetAttr
        thumbnail(width: 200)
      }
      sortOrder
      title
      description
      urlSlug
      status
    }
  }
  themeworlds(
    inB2B: true
    shopClientIds: [$shopClientId]
    seasonIds: $seasonIds
    productLineIds: $productLineIds
    sortBy: $themeworldSortBy
    limit: -1
  ) {
    totalCount
    results {
      id
      themeworldId
      sortOrder
      title
      description
      status
      categories {
        id
        themeworldCategoryId
      }
      products {
        id
        shopProductId
      }
      categoryFallbackImage: medias(targetAttr: "overview_image") {
        id
        thumbnail(width: 200)
        alt
        sortOrder
      }
      overviewImage: medias(targetAttr: "overview_image") {
        id
        thumbnail(width: 1000)
        alt
        sortOrder
      }
      productImage: medias(targetAttr: "product_image") {
        id
        thumbnail(width: 1000)
        alt
        sortOrder
      }
      leftImage: medias(targetAttr: "left_image") {
        id
        thumbnail(width: 1000)
        alt
        sortOrder
      }
      mainImage: medias(targetAttr: "main_image") {
        id
        thumbnail(width: 1000)
        alt
        sortOrder
      }
      rightImage: medias(targetAttr: "right_image") {
        id
        thumbnail(width: 1000)
        alt
        sortOrder
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ThemeworldCategoriesQuery, ThemeworldCategoriesQueryVariables>;
export const CartAllocationWishlistsDocument = new TypedDocumentString(`
    query CartAllocationWishlists($limit: Int, $offset: Int, $loadSubmissions: Boolean, $pendingOnly: Boolean, $includeSubCustomers: Boolean, $seasonIds: [Int], $shopClientId: [Int]) {
  wishlists(
    limit: $limit
    offset: $offset
    loadSubmissions: $loadSubmissions
    pendingOnly: $pendingOnly
    includeSubCustomers: $includeSubCustomers
    seasonIds: $seasonIds
    shopClientId: $shopClientId
  ) {
    totalCount
    results {
      id
      title
      productCount
      positions {
        id
        wishlistId
        shopProductIdParent
        groupIdent
        groupIdentId
        products {
          shopProductId
          quantity
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CartAllocationWishlistsQuery, CartAllocationWishlistsQueryVariables>;
export const CartAllocationGetProductDocument = new TypedDocumentString(`
    query CartAllocationGetProduct($productId: Int!) {
  product(productId: $productId) {
    ...CartAllocationPositionProductData
    ...ProductFeatureValues
    seasonIds
    themeworlds(inB2b: true) {
      themeworldId
    }
    looks(inB2b: true) {
      looksId
    }
    relatedProductsCount
  }
}
    fragment CartAllocationPositionProductData on Product {
  shopProductId
  title
  sku
  customSku
  customData
  stockStatus
  seasonIds
  mainImage: medias(targetAttr: "image") {
    thumbnail(width: 800, height: 800)
  }
  ...ProductSizes
  ...ProductColor
  ...ProductPrice
  ...ProductTags
}
fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductFeatureValues on Product {
  featureValues {
    label
    value
  }
}
fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
fragment ProductSizeFields on ProductSize {
  shopProductId
  sku
  sizeId
  title
  status
  sortOrder
  sizeGridId
  sizeGridTitle
  sizeGridSortOrder
  stock
  stockStatus
}
fragment ProductSizes on Product {
  id
  shopProductId
  productSizes {
    ...ProductSizeFields
  }
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<CartAllocationGetProductQuery, CartAllocationGetProductQueryVariables>;
export const CartAllocationProductsByFilterDocument = new TypedDocumentString(`
    query CartAllocationProductsByFilter($selectedFilters: [String], $limit: Int, $preOrder: Boolean, $shopClientIds: [Int]) {
  products(
    selectedFilters: $selectedFilters
    limit: $limit
    preOrder: $preOrder
    shopClientIds: $shopClientIds
  ) {
    totalCount
    results {
      ...CartAllocationPositionProductData
    }
  }
}
    fragment CartAllocationPositionProductData on Product {
  shopProductId
  title
  sku
  customSku
  customData
  stockStatus
  seasonIds
  mainImage: medias(targetAttr: "image") {
    thumbnail(width: 800, height: 800)
  }
  ...ProductSizes
  ...ProductColor
  ...ProductPrice
  ...ProductTags
}
fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
fragment ProductSizeFields on ProductSize {
  shopProductId
  sku
  sizeId
  title
  status
  sortOrder
  sizeGridId
  sizeGridTitle
  sizeGridSortOrder
  stock
  stockStatus
}
fragment ProductSizes on Product {
  id
  shopProductId
  productSizes {
    ...ProductSizeFields
  }
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<CartAllocationProductsByFilterQuery, CartAllocationProductsByFilterQueryVariables>;
export const CartAllocationRelatedProductsDocument = new TypedDocumentString(`
    query CartAllocationRelatedProducts($productId: Int!) {
  product(productId: $productId) {
    seasonIds
    relatedProducts {
      shopProductId
      productData {
        ...CartAllocationPositionProductData
      }
    }
  }
}
    fragment CartAllocationPositionProductData on Product {
  shopProductId
  title
  sku
  customSku
  customData
  stockStatus
  seasonIds
  mainImage: medias(targetAttr: "image") {
    thumbnail(width: 800, height: 800)
  }
  ...ProductSizes
  ...ProductColor
  ...ProductPrice
  ...ProductTags
}
fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
fragment ProductSizeFields on ProductSize {
  shopProductId
  sku
  sizeId
  title
  status
  sortOrder
  sizeGridId
  sizeGridTitle
  sizeGridSortOrder
  stock
  stockStatus
}
fragment ProductSizes on Product {
  id
  shopProductId
  productSizes {
    ...ProductSizeFields
  }
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<CartAllocationRelatedProductsQuery, CartAllocationRelatedProductsQueryVariables>;
export const ProductPricesDocument = new TypedDocumentString(`
    query ProductPrices($priceData: [ProductPriceInputType]!) {
  productPrices(priceData: $priceData) {
    results {
      quantity
      shopProductId
    }
    total
    totalRrp
  }
}
    `) as unknown as TypedDocumentString<ProductPricesQuery, ProductPricesQueryVariables>;
export const CatalogSettingsDocument = new TypedDocumentString(`
    query CatalogSettings($shopClientId: Int!, $seasonId: Int, $productLineId: Int, $orderType: OrderTypeEnum) {
  catalogSettings(
    shopClientId: $shopClientId
    seasonId: $seasonId
    productLineId: $productLineId
    orderType: $orderType
  ) {
    sorting {
      id
      attribute
      label
      sortOrder
      sortOption
      isDefault
    }
    categoryTree
    defaultTopFilters {
      id
      ident
      label
      type
    }
    defaultFilters {
      id
      ident
      label
      type
    }
  }
}
    `) as unknown as TypedDocumentString<CatalogSettingsQuery, CatalogSettingsQueryVariables>;
export const CatalogProductsDocument = new TypedDocumentString(`
    query CatalogProducts($shopClientId: Int!, $preOrder: Boolean!, $afterOrder: Boolean!, $categoryIds: [Int]!, $displayFilters: [String], $searchQuery: String!, $selectedFilters: [String]!, $priceRange: String, $priceRangeRrp: String, $limit: Int!, $offset: Int!, $sortBy: ProductSortByEnum!, $mainColorsOnly: Boolean!) {
  products(
    shopClientIds: [$shopClientId]
    preOrder: $preOrder
    afterOrder: $afterOrder
    categoryIds: $categoryIds
    searchQuery: $searchQuery
    displayFilters: $displayFilters
    selectedFilters: $selectedFilters
    priceRange: $priceRange
    priceRangeRrp: $priceRangeRrp
    limit: $limit
    offset: $offset
    sortBy: $sortBy
    mainColorsOnly: $mainColorsOnly
  ) {
    totalCount
    results {
      ...ProductListItem
      ...ProductSizesCount
      ...ProductListItemRelated
    }
    searchResultCategoryIds
    filters {
      id
      ident
      label
      type
      additionalDisplayOption
      options {
        id
        label
        ident
        count
        hasHits
        additionalValues
      }
      displayOnTop
      sortOrder
      minValue
      maxValue
      hasHits
    }
  }
}
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductCustomData on Product {
  customData
}
fragment ProductListItem on Product {
  id
  shopProductId
  title
  customSku
  stockStatus
  smallThumb: medias(targetAttr: "image") {
    id
    thumbnail(width: 400)
  }
  largeThumb: medias(targetAttr: "image") {
    id
    thumbnail(width: 800)
  }
  ...ProductCustomData
  ...ProductPrice
  ...ProductColor
  ...ProductTags
}
fragment ProductListItemRelated on Product {
  relatedProductsCount
  relatedProducts {
    id
    productData {
      shopProductId
      image: medias(targetAttr: "image") {
        id
        thumbnail(width: 400)
      }
      ...ProductColor
      ...ProductTags
    }
  }
}
fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
fragment ProductSizesCount on Product {
  childrenCount
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<CatalogProductsQuery, CatalogProductsQueryVariables>;
export const SearchResultCategoryIdsDocument = new TypedDocumentString(`
    query SearchResultCategoryIds($shopClientId: Int!, $preOrder: Boolean!, $afterOrder: Boolean!, $selectedFilters: [String]!, $searchQuery: String!) {
  products(
    shopClientIds: [$shopClientId]
    preOrder: $preOrder
    afterOrder: $afterOrder
    selectedFilters: $selectedFilters
    searchQuery: $searchQuery
  ) {
    totalCount
    results {
      id
      shopProductId
    }
    searchResultCategoryIds
  }
}
    `) as unknown as TypedDocumentString<SearchResultCategoryIdsQuery, SearchResultCategoryIdsQueryVariables>;
export const CheckoutDeliveryAddressesDocument = new TypedDocumentString(`
    query CheckoutDeliveryAddresses($customerId: Int!) {
  customer(customerId: $customerId) {
    id
    customerNumber
    addresses(addressType: 2) {
      id
      firstname
      lastname
      street
      zipCode
      city
      countryLabel
      company
    }
    subCustomers {
      id
      customerNumber
      name
      addresses(addressType: 2) {
        id
        firstname
        lastname
        street
        zipCode
        city
        countryLabel
        company
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CheckoutDeliveryAddressesQuery, CheckoutDeliveryAddressesQueryVariables>;
export const SubmitBasketDocument = new TypedDocumentString(`
    mutation SubmitBasket($deliveryOrderAddress: OrderAddressInputType!, $invoiceOrderAddress: OrderAddressInputType!, $orderData: OrderInputType!, $orderAsSubCustomer: Int, $shopClientId: Int) {
  submitBasket(
    deliveryOrderAddress: $deliveryOrderAddress
    invoiceOrderAddress: $invoiceOrderAddress
    orderData: $orderData
    orderAsSubCustomer: $orderAsSubCustomer
    shopClientId: $shopClientId
  ) {
    id
    commission
    customerName
    customerNumber
    errors
  }
}
    `) as unknown as TypedDocumentString<SubmitBasketMutation, SubmitBasketMutationVariables>;
export const CheckoutWishlistDocument = new TypedDocumentString(`
    query CheckoutWishlist($wishlistId: Int!, $loadSubmissions: Boolean = false, $includeSubCustomers: Boolean = false) {
  wishlist(
    wishlistId: $wishlistId
    loadSubmissions: $loadSubmissions
    includeSubCustomers: $includeSubCustomers
  ) {
    id
    title
    customerName
    salesAppUserName
    productCount
    createdAt
    comment
    releaseComment
    commission
    status
    positions {
      id
      shopProductIdParent
      groupIdent
      groupIdentId
      productQty
      subTotal
      subTotalRrp
      wishlistId
      productData {
        id
        title
        customSku
        shopProductId
        image: medias(targetAttr: "image") {
          thumbnail(width: 800)
        }
        ...ProductColor
        ...ProductTags
      }
    }
    ...WishlistGroupSummary
    ...WishlistSummary
  }
}
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}
fragment WishlistGroupSummary on Wishlist {
  groupSummary {
    groupIdent
    groupIdentId
    positionCount
    productCount
    productQty
    total
    totalRrp
  }
}
fragment WishlistSummary on Wishlist {
  summary {
    positionCount
    productCount
    productQty
    groupCount
    total
    totalRrp
  }
}`) as unknown as TypedDocumentString<CheckoutWishlistQuery, CheckoutWishlistQueryVariables>;
export const ApproveWishlistDocument = new TypedDocumentString(`
    mutation ApproveWishlist($wishlistId: Int!, $commission: String, $releaseComment: String, $email: String, $message: String) {
  approveWishlist(
    wishlistId: $wishlistId
    commission: $commission
    releaseComment: $releaseComment
    email: $email
    message: $message
  ) {
    errors
  }
}
    `) as unknown as TypedDocumentString<ApproveWishlistMutation, ApproveWishlistMutationVariables>;
export const FormsByIdentsDocument = new TypedDocumentString(`
    query FormsByIdents($idents: [FormGeneratorIdentEnum!]!) {
  forms(idents: $idents) {
    results {
      id
      webFormId
      ident
      title
      formData
    }
  }
}
    `) as unknown as TypedDocumentString<FormsByIdentsQuery, FormsByIdentsQueryVariables>;
export const LookDocument = new TypedDocumentString(`
    query Look($looksId: Int!, $width: Int) {
  look(looksId: $looksId) {
    id
    looksId
    shopClientId
    title
    subtitle
    customTitle
    status
    saison
    description
    sortOrder
    seasons
    products {
      shopProductId
      isFavorite
      productData {
        title
        customSku
        priceFormatted
        rrpFormatted
        relatedProductsCount
        color {
          title
          hexCode
          number
        }
        medias(targetAttr: "image") {
          thumbnail(width: 400)
          alt
          targetAttr
          sortOrder
          mime
        }
      }
    }
    medias {
      targetAttr
      sortOrder
      thumbnail(width: $width)
      mime
      alt
    }
  }
}
    `) as unknown as TypedDocumentString<LookQuery, LookQueryVariables>;
export const ThemeworlsDocument = new TypedDocumentString(`
    query Themeworls($themeworldId: Int!, $width: Int) {
  themeworld(themeworldId: $themeworldId) {
    id
    themeworldId
    title
    subtitle
    status
    description
    sortOrder
    seasons
    medias {
      targetAttr
      sortOrder
      thumbnail(width: $width)
      mime
      alt
    }
  }
}
    `) as unknown as TypedDocumentString<ThemeworlsQuery, ThemeworlsQueryVariables>;
export const ThemeworldsByProductDocument = new TypedDocumentString(`
    query ThemeworldsByProduct($productId: Int!) {
  product(productId: $productId) {
    themeworlds(inB2b: true) {
      themeworldId
    }
  }
}
    `) as unknown as TypedDocumentString<ThemeworldsByProductQuery, ThemeworldsByProductQueryVariables>;
export const WishlistsCountDocument = new TypedDocumentString(`
    query WishlistsCount($loadSubmissions: Boolean = false, $pendingOnly: Boolean = false, $includeSubCustomers: Boolean = false, $seasonIds: [Int], $shopClientId: [Int]) {
  wishlists(
    loadSubmissions: $loadSubmissions
    pendingOnly: $pendingOnly
    includeSubCustomers: $includeSubCustomers
    seasonIds: $seasonIds
    shopClientId: $shopClientId
  ) {
    totalCount
  }
}
    `) as unknown as TypedDocumentString<WishlistsCountQuery, WishlistsCountQueryVariables>;
export const HeaderSearchProductsDocument = new TypedDocumentString(`
    query HeaderSearchProducts($shopClientId: Int!, $limit: Int!, $searchQuery: String!, $sortBy: ProductSortByEnum!, $preOrder: Boolean!, $afterOrder: Boolean!) {
  products(
    shopClientIds: [$shopClientId]
    limit: $limit
    mainColorsOnly: false
    searchQuery: $searchQuery
    sortBy: $sortBy
    preOrder: $preOrder
    afterOrder: $afterOrder
  ) {
    totalCount
    results {
      ...ProductListItem
    }
  }
}
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductCustomData on Product {
  customData
}
fragment ProductListItem on Product {
  id
  shopProductId
  title
  customSku
  stockStatus
  smallThumb: medias(targetAttr: "image") {
    id
    thumbnail(width: 400)
  }
  largeThumb: medias(targetAttr: "image") {
    id
    thumbnail(width: 800)
  }
  ...ProductCustomData
  ...ProductPrice
  ...ProductColor
  ...ProductTags
}
fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<HeaderSearchProductsQuery, HeaderSearchProductsQueryVariables>;
export const HeaderSearchProductsByIdsDocument = new TypedDocumentString(`
    query HeaderSearchProductsByIds($shopProductIds: [Int], $shopClientId: Int!, $limit: Int!) {
  products(
    shopProductIds: $shopProductIds
    shopClientIds: [$shopClientId]
    limit: $limit
  ) {
    totalCount
    results {
      ...ProductListItem
    }
  }
}
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductCustomData on Product {
  customData
}
fragment ProductListItem on Product {
  id
  shopProductId
  title
  customSku
  stockStatus
  smallThumb: medias(targetAttr: "image") {
    id
    thumbnail(width: 400)
  }
  largeThumb: medias(targetAttr: "image") {
    id
    thumbnail(width: 800)
  }
  ...ProductCustomData
  ...ProductPrice
  ...ProductColor
  ...ProductTags
}
fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<HeaderSearchProductsByIdsQuery, HeaderSearchProductsByIdsQueryVariables>;
export const LandingPageLookCategoriesDocument = new TypedDocumentString(`
    query LandingPageLookCategories($shopClientId: Int!, $sortBy: LooksSortByEnum!, $thumbnailWidth: Int!) {
  looksCategories(shopClientIds: [$shopClientId], inB2B: true) {
    results {
      id
      looksCategoryId
      sortOrder
      status
    }
  }
  looks(shopClientIds: [$shopClientId], inB2B: true, limit: -1, sortBy: $sortBy) {
    results {
      id
      looksId
      title
      customTitle
      status
      categories {
        id
        looksCategoryId
      }
      overviewImage: medias(targetAttr: "overview_image") {
        thumbnail(width: $thumbnailWidth)
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LandingPageLookCategoriesQuery, LandingPageLookCategoriesQueryVariables>;
export const LandingPageThemeworldCategoriesDocument = new TypedDocumentString(`
    query LandingPageThemeworldCategories($shopClientId: Int!, $sortBy: ThemeworldSortByEnum!, $thumbnailWidth: Int!) {
  themeworldCategories(shopClientIds: [$shopClientId], inB2B: true) {
    results {
      id
      themeworldCategoryId
      sortOrder
      status
    }
  }
  themeworlds(
    shopClientIds: [$shopClientId]
    inB2B: true
    limit: -1
    sortBy: $sortBy
  ) {
    results {
      id
      themeworldId
      title
      status
      categories {
        id
        themeworldCategoryId
      }
      overviewImage: medias(targetAttr: "overview_image") {
        thumbnail(width: $thumbnailWidth)
      }
      mainImage: medias(targetAttr: "main_image") {
        id
        thumbnail(width: $thumbnailWidth)
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LandingPageThemeworldCategoriesQuery, LandingPageThemeworldCategoriesQueryVariables>;
export const LookDetailPageDocument = new TypedDocumentString(`
    query LookDetailPage($lookId: Int!, $galleryThumbnailWidth: Int!, $productThumbSmallWidth: Int!, $productThumbLargeWidth: Int!) {
  look(looksId: $lookId) {
    id
    looksId
    shopClientId
    title
    subtitle
    customTitle
    status
    saison
    description
    sortOrder
    headerProducts: products {
      id
      shopProductId
      productData {
        title
        customSku
        stockStatus
        priceFormatted
        rrpFormatted
        originalPriceFormatted
        colorName
        color {
          number
          hexCode
        }
        smallThumb: medias(targetAttr: "image") {
          thumbnail(width: $productThumbSmallWidth)
        }
        largeThumb: medias(targetAttr: "image") {
          thumbnail(width: $productThumbLargeWidth)
        }
        relatedProductsCount
        ...ProductTags
      }
    }
    medias {
      targetAttr
      sortOrder
      thumbnail(width: $galleryThumbnailWidth)
      width
      height
      mime
      alt
    }
    categories {
      id
      looksCategoryId
    }
  }
}
    fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<LookDetailPageQuery, LookDetailPageQueryVariables>;
export const LookDetailRelatedLooksDocument = new TypedDocumentString(`
    query LookDetailRelatedLooks($shopClientId: Int!, $categoryIds: [Int!]!, $thumbnailWidth: Int!) {
  looks(
    shopClientIds: [$shopClientId]
    categoryIds: $categoryIds
    inB2B: true
    limit: -1
  ) {
    totalCount
    results {
      id
      looksId
      title
      customTitle
      sortOrder
      overviewImage: medias(targetAttr: "overview_image") {
        targetAttr
        thumbnail(width: $thumbnailWidth)
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LookDetailRelatedLooksQuery, LookDetailRelatedLooksQueryVariables>;
export const LookCategoriesDocument = new TypedDocumentString(`
    query LookCategories($shopClientId: Int!, $seasonIds: [Int!], $productLineIds: [Int!], $categoryThumbnailWidth: Int!, $overviewThumbnailWidth: Int!, $productThumbnailWidth: Int!) {
  looksCategories(
    shopClientIds: [$shopClientId]
    seasonIds: $seasonIds
    productLineIds: $productLineIds
    inB2B: true
  ) {
    results {
      id
      looksCategoryId
      title
      description
      sortOrder
      status
      urlSlug
      image: medias(targetAttr: "image") {
        targetAttr
        sortOrder
        thumbnail(width: $categoryThumbnailWidth)
        mime
        alt
      }
    }
  }
  looks(
    shopClientIds: [$shopClientId]
    seasonIds: $seasonIds
    productLineIds: $productLineIds
    inB2B: true
    limit: -1
  ) {
    totalCount
    results {
      id
      looksId
      status
      title
      subtitle
      customTitle
      sortOrder
      categories {
        id
        title
        looksCategoryId
      }
      categoryFallbackImage: medias(targetAttr: "overview_image") {
        targetAttr
        sortOrder
        thumbnail(width: $categoryThumbnailWidth)
        mime
        alt
      }
      overviewImage: medias(targetAttr: "overview_image") {
        targetAttr
        sortOrder
        thumbnail(width: $overviewThumbnailWidth)
        mime
        alt
      }
      products {
        productData {
          shopProductId
          title
          ...ProductTags
          image: medias(targetAttr: "image") {
            targetAttr
            sortOrder
            thumbnail(width: $productThumbnailWidth)
            mime
            alt
          }
        }
      }
    }
  }
}
    fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<LookCategoriesQuery, LookCategoriesQueryVariables>;
export const DownloadsDocument = new TypedDocumentString(`
    query Downloads($shopClientIds: [Int], $categoryIds: [Int], $limit: Int!, $thumbnailWidth: Int!) {
  downloads(
    shopClientIds: $shopClientIds
    categoryIds: $categoryIds
    limit: $limit
  ) {
    totalCount
    downloadTree
    results {
      id
      downloadId
      title
      status
      parentId
      categoryIds
      updatedAt(format: "Y-m-d")
      medias {
        id
        filename
        mime
        size
        thumbnail(width: $thumbnailWidth)
        updatedAt(format: "Y-m-d")
        path
        alt
        token
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DownloadsQuery, DownloadsQueryVariables>;
export const FooterNavigationDocument = new TypedDocumentString(`
    query FooterNavigation($shopClientId: Int!) {
  footerNavigation(shopClientId: $shopClientId) {
    navigation {
      label
      path
      children {
        label
        path
      }
    }
    errors
  }
}
    `) as unknown as TypedDocumentString<FooterNavigationQuery, FooterNavigationQueryVariables>;
export const HeaderNavigationDocument = new TypedDocumentString(`
    query HeaderNavigation($shopClientId: Int!, $bannerWidth: Int) {
  headerNavigation(shopClientId: $shopClientId, bannerWidth: $bannerWidth) {
    template
    navigation {
      label
      target
      path
      menu {
        type
        columns
      }
      banner {
        label
        path
        image
      }
      children {
        label
        target
        path
        style
        menu {
          type
          columns
        }
        children {
          label
          path
          target
          style
        }
      }
    }
    errors
  }
}
    `) as unknown as TypedDocumentString<HeaderNavigationQuery, HeaderNavigationQueryVariables>;
export const FetchProductThemeworldsAndLooksDocument = new TypedDocumentString(`
    query FetchProductThemeworldsAndLooks($productId: Int!, $largeImageWidth: Int!, $thumbWidth: Int!) {
  product(productId: $productId) {
    themeworlds(inB2b: true) {
      id
      themeworldId
      title
      description
      status
      medias {
        targetAttr
        sortOrder
        thumbnail(width: $largeImageWidth)
        alt
        mime
      }
      products {
        id
        shopProductId
        productData {
          medias {
            targetAttr
            sortOrder
            mime
            alt
            thumbnail(width: $thumbWidth)
          }
          ...ProductTags
        }
      }
    }
    looks(inB2b: true) {
      id
      looksId
      title
      customTitle
      status
      sortOrder
      productImage: medias(targetAttr: "product_image") {
        thumbnail(width: $largeImageWidth)
      }
      overviewImage: medias(targetAttr: "overview_image") {
        thumbnail(width: $largeImageWidth)
      }
      video: medias(targetAttr: "video") {
        path
      }
      products {
        id
        shopProductId
        productData {
          title
          medias {
            targetAttr
            sortOrder
            mime
            alt
            thumbnail(width: $thumbWidth)
          }
          ...ProductTags
        }
      }
    }
  }
}
    fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<FetchProductThemeworldsAndLooksQuery, FetchProductThemeworldsAndLooksQueryVariables>;
export const ProductsByFeatureDocument = new TypedDocumentString(`
    query ProductsByFeature($shopClientIds: [Int!]!, $selectedFilters: [String!]!, $sortBy: ProductSortByEnum) {
  products(
    shopClientIds: $shopClientIds
    selectedFilters: $selectedFilters
    mainColorsOnly: false
    limit: -1
    sortBy: $sortBy
  ) {
    totalCount
    results {
      ...ProductListItem
      ...ProductListItemRelated
    }
  }
}
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductCustomData on Product {
  customData
}
fragment ProductListItem on Product {
  id
  shopProductId
  title
  customSku
  stockStatus
  smallThumb: medias(targetAttr: "image") {
    id
    thumbnail(width: 400)
  }
  largeThumb: medias(targetAttr: "image") {
    id
    thumbnail(width: 800)
  }
  ...ProductCustomData
  ...ProductPrice
  ...ProductColor
  ...ProductTags
}
fragment ProductListItemRelated on Product {
  relatedProductsCount
  relatedProducts {
    id
    productData {
      shopProductId
      image: medias(targetAttr: "image") {
        id
        thumbnail(width: 400)
      }
      ...ProductColor
      ...ProductTags
    }
  }
}
fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<ProductsByFeatureQuery, ProductsByFeatureQueryVariables>;
export const ProductsByIdsDocument = new TypedDocumentString(`
    query ProductsByIds($shopClientId: Int!, $shopProductIds: [Int!]!, $selectedFilters: [String], $sortBy: ProductSortByEnum) {
  products(
    shopClientIds: [$shopClientId]
    shopProductIds: $shopProductIds
    selectedFilters: $selectedFilters
    sortBy: $sortBy
  ) {
    totalCount
    results {
      ...ProductListItem
    }
  }
}
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductCustomData on Product {
  customData
}
fragment ProductListItem on Product {
  id
  shopProductId
  title
  customSku
  stockStatus
  smallThumb: medias(targetAttr: "image") {
    id
    thumbnail(width: 400)
  }
  largeThumb: medias(targetAttr: "image") {
    id
    thumbnail(width: 800)
  }
  ...ProductCustomData
  ...ProductPrice
  ...ProductColor
  ...ProductTags
}
fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<ProductsByIdsQuery, ProductsByIdsQueryVariables>;
export const CountProductsByFeaturesDocument = new TypedDocumentString(`
    query CountProductsByFeatures($shopClientId: Int!, $selectedFilters: [String!]!, $sortBy: ProductSortByEnum) {
  products(
    shopClientIds: [$shopClientId]
    selectedFilters: $selectedFilters
    mainColorsOnly: false
    sortBy: $sortBy
    limit: -1
  ) {
    totalCount
    results {
      shopProductId
    }
  }
}
    `) as unknown as TypedDocumentString<CountProductsByFeaturesQuery, CountProductsByFeaturesQueryVariables>;
export const CountProductsFromLooksDocument = new TypedDocumentString(`
    query CountProductsFromLooks($productId: Int!) {
  product(productId: $productId) {
    looks(inB2b: true) {
      looksId
      products {
        shopProductId
        productData {
          seasonIds
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CountProductsFromLooksQuery, CountProductsFromLooksQueryVariables>;
export const CountProductsFromThemeworldsDocument = new TypedDocumentString(`
    query CountProductsFromThemeworlds($productId: Int!) {
  product(productId: $productId) {
    themeworlds(inB2b: true) {
      themeworldId
      products {
        shopProductId
        productData {
          seasonIds
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CountProductsFromThemeworldsQuery, CountProductsFromThemeworldsQueryVariables>;
export const ProductSizesDocument = new TypedDocumentString(`
    query ProductSizes($shopProductId: Int!) {
  product(productId: $shopProductId) {
    ...ProductSizes
  }
}
    fragment ProductSizeFields on ProductSize {
  shopProductId
  sku
  sizeId
  title
  status
  sortOrder
  sizeGridId
  sizeGridTitle
  sizeGridSortOrder
  stock
  stockStatus
}
fragment ProductSizes on Product {
  id
  shopProductId
  productSizes {
    ...ProductSizeFields
  }
}`) as unknown as TypedDocumentString<ProductSizesQuery, ProductSizesQueryVariables>;
export const ProductsSizesForIdsDocument = new TypedDocumentString(`
    query ProductsSizesForIds($shopClientId: Int!, $shopProductIds: [Int!]!) {
  products(
    shopClientIds: [$shopClientId]
    shopProductIds: $shopProductIds
    limit: -1
  ) {
    totalCount
    results {
      ...ProductSizes
    }
  }
}
    fragment ProductSizeFields on ProductSize {
  shopProductId
  sku
  sizeId
  title
  status
  sortOrder
  sizeGridId
  sizeGridTitle
  sizeGridSortOrder
  stock
  stockStatus
}
fragment ProductSizes on Product {
  id
  shopProductId
  productSizes {
    ...ProductSizeFields
  }
}`) as unknown as TypedDocumentString<ProductsSizesForIdsQuery, ProductsSizesForIdsQueryVariables>;
export const SeasonsDocument = new TypedDocumentString(`
    query Seasons($thumbnailWidth: Int!) {
  seasons {
    totalCount
    results {
      id
      seasonId
      ident
      title
      description
      sortOrder
      status
      thumbnail: medias(targetAttr: "image") {
        thumbnail(width: $thumbnailWidth)
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SeasonsQuery, SeasonsQueryVariables>;
export const TeamCategoryListDocument = new TypedDocumentString(`
    query TeamCategoryList($shopClientId: Int!) {
  teamCategories(shopClientIds: [$shopClientId]) {
    totalCount
    results {
      id
      teamCategoryId
      title
      status
      urlSlug
    }
  }
}
    `) as unknown as TypedDocumentString<TeamCategoryListQuery, TeamCategoryListQueryVariables>;
export const TeamsDocument = new TypedDocumentString(`
    query Teams($shopClientId: Int!, $categoryIds: [Int!]!, $sortBy: TeamSortByEnum!, $thumbnailWidth: Int!) {
  teams(
    shopClientIds: [$shopClientId]
    categoryIds: $categoryIds
    limit: -1
    sortBy: $sortBy
  ) {
    totalCount
    results {
      id
      teamId
      firstName
      lastName
      fullName
      function
      phone
      email
      location
      medias(targetAttr: "image") {
        sortOrder
        alt
        thumbnail(width: $thumbnailWidth)
        mime
      }
      categories {
        id
        title
        status
        urlSlug
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TeamsQuery, TeamsQueryVariables>;
export const AddWishlistToBasketDocument = new TypedDocumentString(`
    mutation AddWishlistToBasket($wishlistId: Int!) {
  addWishlistToBasket(wishlistId: $wishlistId) {
    id
    summary {
      currency
      positionCount
      productCount
      productQty
      subTotal(formatted: true)
      subTotalRrp(formatted: true)
      total(formatted: true)
    }
    errors
  }
}
    `) as unknown as TypedDocumentString<AddWishlistToBasketMutation, AddWishlistToBasketMutationVariables>;
export const CopyWishlistDocument = new TypedDocumentString(`
    mutation CopyWishlist($wishlistId: Int!, $title: String!) {
  copyWishlist(wishlistId: $wishlistId, title: $title) {
    ...WishlistOverviewItem
  }
}
    fragment WishlistOverviewItem on Wishlist {
  id
  title
  comment
  frontendUserName
  frontenduserId
  createdAt(format: "Y-m-d H:i:s")
  updatedAt(format: "Y-m-d H:i:s")
  summary {
    positionCount
    productQty
    total
  }
  shopClient {
    id
    shopClientId
    title
    brandColor
    color
    medias(targetAttr: "logo") {
      targetAttr
      path
      filename
    }
  }
}`) as unknown as TypedDocumentString<CopyWishlistMutation, CopyWishlistMutationVariables>;
export const CreateWishlistDocument = new TypedDocumentString(`
    mutation CreateWishlist($wishlistData: WishlistInputType!) {
  updateWishlist(wishlistData: $wishlistData) {
    ...WishlistOverviewItem
  }
}
    fragment WishlistOverviewItem on Wishlist {
  id
  title
  comment
  frontendUserName
  frontenduserId
  createdAt(format: "Y-m-d H:i:s")
  updatedAt(format: "Y-m-d H:i:s")
  summary {
    positionCount
    productQty
    total
  }
  shopClient {
    id
    shopClientId
    title
    brandColor
    color
    medias(targetAttr: "logo") {
      targetAttr
      path
      filename
    }
  }
}`) as unknown as TypedDocumentString<CreateWishlistMutation, CreateWishlistMutationVariables>;
export const ResetWishlistDocument = new TypedDocumentString(`
    mutation ResetWishlist($wishlistId: Int!) {
  resetWishlist(wishlistId: $wishlistId) {
    ...WishlistOverviewItem
  }
}
    fragment WishlistOverviewItem on Wishlist {
  id
  title
  comment
  frontendUserName
  frontenduserId
  createdAt(format: "Y-m-d H:i:s")
  updatedAt(format: "Y-m-d H:i:s")
  summary {
    positionCount
    productQty
    total
  }
  shopClient {
    id
    shopClientId
    title
    brandColor
    color
    medias(targetAttr: "logo") {
      targetAttr
      path
      filename
    }
  }
}`) as unknown as TypedDocumentString<ResetWishlistMutation, ResetWishlistMutationVariables>;
export const WishlistsOverviewDocument = new TypedDocumentString(`
    query WishlistsOverview($shopClientId: [Int], $loadSubmissions: Boolean = false, $includeSubCustomers: Boolean = false) {
  wishlists(
    shopClientId: $shopClientId
    loadSubmissions: $loadSubmissions
    includeSubCustomers: $includeSubCustomers
  ) {
    totalCount
    results {
      ...WishlistOverviewItem
      positions {
        products {
          shopProductId
          quantity
          productData {
            title
          }
        }
      }
    }
  }
}
    fragment WishlistOverviewItem on Wishlist {
  id
  title
  comment
  frontendUserName
  frontenduserId
  createdAt(format: "Y-m-d H:i:s")
  updatedAt(format: "Y-m-d H:i:s")
  summary {
    positionCount
    productQty
    total
  }
  shopClient {
    id
    shopClientId
    title
    brandColor
    color
    medias(targetAttr: "logo") {
      targetAttr
      path
      filename
    }
  }
}`) as unknown as TypedDocumentString<WishlistsOverviewQuery, WishlistsOverviewQueryVariables>;
export const DeleteWishlistDocument = new TypedDocumentString(`
    mutation DeleteWishlist($wishlistId: Int!) {
  deleteWishlist(wishlistId: $wishlistId) {
    id
    title
  }
}
    `) as unknown as TypedDocumentString<DeleteWishlistMutation, DeleteWishlistMutationVariables>;
export const WishlistDetailDocument = new TypedDocumentString(`
    query WishlistDetail($wishlistId: Int!, $loadSubmissions: Boolean = false, $includeSubCustomers: Boolean = false, $shopClientId: Int) {
  wishlist(
    wishlistId: $wishlistId
    loadSubmissions: $loadSubmissions
    includeSubCustomers: $includeSubCustomers
    shopClientId: $shopClientId
  ) {
    id
    title
    customerName
    salesAppUserName
    productCount
    createdAt
    status
    comment
    season {
      seasonId
      title
    }
    positions {
      id
      shopProductIdParent
      groupIdent
      groupIdentId
      productQty
      subTotal
      subTotalRrp
      products {
        shopProductId
        quantity
      }
      ...ProductSizesWishlist
      productData {
        id
        shopProductId
        title
        customSku
        seasonIds
        inStock
        quantityIncrement
        pageUrl
        customData
        medias(targetAttr: "image") {
          thumbnail(width: 800)
        }
        relatedProductsCount
        ...ProductPrice
        ...ProductTags
        ...ProductColor
      }
    }
    ...WishlistGroupSummary
    ...WishlistSummary
  }
}
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
fragment ProductSizeFields on ProductSize {
  shopProductId
  sku
  sizeId
  title
  status
  sortOrder
  sizeGridId
  sizeGridTitle
  sizeGridSortOrder
  stock
  stockStatus
}
fragment ProductSizesWishlist on WishlistPosition {
  id
  productSizes {
    ...ProductSizeFields
  }
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}
fragment WishlistGroupSummary on Wishlist {
  groupSummary {
    groupIdent
    groupIdentId
    positionCount
    productCount
    productQty
    total
    totalRrp
  }
}
fragment WishlistSummary on Wishlist {
  summary {
    positionCount
    productCount
    productQty
    groupCount
    total
    totalRrp
  }
}`) as unknown as TypedDocumentString<WishlistDetailQuery, WishlistDetailQueryVariables>;
export const RemoveWishlistPositionDocument = new TypedDocumentString(`
    mutation removeWishlistPosition($wishlistPositionId: Int!) {
  removeWishlistPosition(wishlistPositionId: $wishlistPositionId) {
    id
    title
    groupSummary {
      groupIdent
      groupIdentId
      positionCount
      productCount
      productQty
      total
      totalRrp
    }
    summary {
      positionCount
      productCount
      productQty
      groupCount
      total
      totalRrp
    }
    errors
  }
}
    `) as unknown as TypedDocumentString<RemoveWishlistPositionMutation, RemoveWishlistPositionMutationVariables>;
export const WishlistsForAddToWishlistDocument = new TypedDocumentString(`
    query WishlistsForAddToWishlist($shopClientId: [Int], $loadSubmissions: Boolean = false) {
  wishlists(shopClientId: $shopClientId, loadSubmissions: $loadSubmissions) {
    totalCount
    results {
      id
      title
      positions {
        id
        shopProductIdParent
      }
    }
  }
}
    `) as unknown as TypedDocumentString<WishlistsForAddToWishlistQuery, WishlistsForAddToWishlistQueryVariables>;
export const AddToWishlistDocument = new TypedDocumentString(`
    mutation AddToWishlist($wishlistData: WishlistInputType!, $wishlistPosition: WishlistPositionInputType) {
  updateWishlist(wishlistData: $wishlistData, wishlistPosition: $wishlistPosition) {
    id
    positions {
      id
      shopProductIdParent
    }
    ...WishlistOverviewItem
  }
}
    fragment WishlistOverviewItem on Wishlist {
  id
  title
  comment
  frontendUserName
  frontenduserId
  createdAt(format: "Y-m-d H:i:s")
  updatedAt(format: "Y-m-d H:i:s")
  summary {
    positionCount
    productQty
    total
  }
  shopClient {
    id
    shopClientId
    title
    brandColor
    color
    medias(targetAttr: "logo") {
      targetAttr
      path
      filename
    }
  }
}`) as unknown as TypedDocumentString<AddToWishlistMutation, AddToWishlistMutationVariables>;
export const RemoveFromWishlistDocument = new TypedDocumentString(`
    mutation RemoveFromWishlist($wishlistPositionId: Int!) {
  removeWishlistPosition(wishlistPositionId: $wishlistPositionId) {
    id
    ...WishlistOverviewItem
  }
}
    fragment WishlistOverviewItem on Wishlist {
  id
  title
  comment
  frontendUserName
  frontenduserId
  createdAt(format: "Y-m-d H:i:s")
  updatedAt(format: "Y-m-d H:i:s")
  summary {
    positionCount
    productQty
    total
  }
  shopClient {
    id
    shopClientId
    title
    brandColor
    color
    medias(targetAttr: "logo") {
      targetAttr
      path
      filename
    }
  }
}`) as unknown as TypedDocumentString<RemoveFromWishlistMutation, RemoveFromWishlistMutationVariables>;
export const UpdateWishlistModalPositionDocument = new TypedDocumentString(`
    mutation UpdateWishlistModalPosition($wishlistId: Int!, $wishlistPosition: WishlistPositionInputType, $shopClientId: Int) {
  updateWishlistPosition(
    wishlistId: $wishlistId
    wishlistPosition: $wishlistPosition
    shopClientId: $shopClientId
  ) {
    id
    wishlistId
    products {
      shopProductId
      quantity
    }
    subTotal
    subTotalRrp
    productQty
    errors
  }
}
    `) as unknown as TypedDocumentString<UpdateWishlistModalPositionMutation, UpdateWishlistModalPositionMutationVariables>;
export const WishlistsDocument = new TypedDocumentString(`
    query Wishlists($limit: Int, $offset: Int, $loadSubmissions: Boolean = false, $pendingOnly: Boolean = false, $includeSubCustomers: Boolean = false, $seasonIds: [Int], $shopClientId: [Int]) {
  wishlists(
    limit: $limit
    offset: $offset
    loadSubmissions: $loadSubmissions
    pendingOnly: $pendingOnly
    includeSubCustomers: $includeSubCustomers
    seasonIds: $seasonIds
    shopClientId: $shopClientId
  ) {
    totalCount
    results {
      id
      title
      productCount
      customerName
      salesAppUserName
      createdAt(format: "Y-m-d H:i:s")
      season {
        seasonId
        title
      }
      summary {
        positionCount
        productCount
        productQty
        groupCount
        total
        totalRrp
      }
      positions {
        products {
          shopProductId
          quantity
          productData {
            title
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<WishlistsQuery, WishlistsQueryVariables>;
export const WishlistPositionUpdateDocument = new TypedDocumentString(`
    mutation WishlistPositionUpdate($wishlistData: WishlistInputType!, $wishlistPosition: WishlistPositionInputType) {
  updateWishlist(wishlistData: $wishlistData, wishlistPosition: $wishlistPosition) {
    id
    positions {
      id
      productQty
      subTotal
      subTotalRrp
    }
    groupSummary {
      groupIdent
      groupIdentId
      positionCount
      productCount
      productQty
      total
      totalRrp
    }
    summary {
      positionCount
      productCount
      productQty
      groupCount
      total
      totalRrp
    }
    errors
  }
}
    `) as unknown as TypedDocumentString<WishlistPositionUpdateMutation, WishlistPositionUpdateMutationVariables>;
export const ActiveProductsDocument = new TypedDocumentString(`
    query ActiveProducts($shopProductId: Int!) {
  product(productId: $shopProductId) {
    ...ProductDetailPage
    ...ProductDetailPageMoodVideo
    relatedProducts {
      id
      shopProductId
      productData {
        ...ProductDetailPage
        ...ProductDetailPageMoodVideo
      }
    }
  }
}
    fragment ProductColor on Product {
  colorName
  color {
    id
    hexCode
    number
    sortOrder
  }
}
fragment ProductCustomData on Product {
  customData
}
fragment ProductDetailPage on Product {
  shopProductId
  title
  subtitle
  customSku
  description
  status
  stockStatus
  title
  featureValues {
    value
    label
  }
  themeworlds(inB2b: true) {
    id
    themeworldId
  }
  looks(inB2b: true) {
    id
    looksId
  }
  thumbnail: medias(targetAttr: "image") {
    thumbnail(width: 400)
  }
  mainImage: medias(targetAttr: "image") {
    targetAttr
    sortOrder
    thumbnail(width: 2000)
    width
    height
    alt
  }
  imageGallery: medias(targetAttr: "image_gallery") {
    targetAttr
    sortOrder
    thumbnail(width: 2000)
    width
    height
    alt
  }
  relatedProducts {
    shopProductId
    productData {
      shopProductId
    }
  }
  ...ProductPrice
  ...ProductCustomData
  ...ProductColor
  ...ProductTags
  ...ProductSizesCount
}
fragment ProductDetailPageMoodVideo on Product {
  moodVideo: medias(targetAttr: "mood_video") {
    targetAttr
    sortOrder
    path
    alt
  }
}
fragment ProductPrice on Product {
  price
  rrp
  isSale
  originalPrice
}
fragment ProductSizesCount on Product {
  childrenCount
}
fragment ProductTags on Product {
  tags {
    id
    productTagId
    title
    status
    sortOrder
    logo: medias(targetAttr: "logo") {
      path
    }
  }
}`) as unknown as TypedDocumentString<ActiveProductsQuery, ActiveProductsQueryVariables>;
export const WishlistCountProductsDocument = new TypedDocumentString(`
    query WishlistCountProducts($loadSubmissions: Boolean, $pendingOnly: Boolean, $includeSubCustomers: Boolean, $shopClientId: [Int]) {
  wishlists(
    loadSubmissions: $loadSubmissions
    pendingOnly: $pendingOnly
    includeSubCustomers: $includeSubCustomers
    shopClientId: $shopClientId
  ) {
    results {
      positions {
        shopProductIdParent
      }
    }
  }
}
    `) as unknown as TypedDocumentString<WishlistCountProductsQuery, WishlistCountProductsQueryVariables>;
export const FrontendUserDocument = new TypedDocumentString(`
    query FrontendUser {
  frontenduser {
    id
    salutation
    firstname
    lastname
    email
    activeCustomer {
      customerId
      customerNumber
      name
      country {
        countryId
        countryCode
        name
        termsOfService
        popupTermsOfService
        imprint
        privacyPolicy
      }
      currency {
        currencyId
        title
        isoCode
      }
      currencyRrp {
        currencyId
        title
        isoCode
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FrontendUserQuery, FrontendUserQueryVariables>;